import React, { Component, useEffect, useState } from "react";
import {Modal, 
        Card, 
        Form,
        Button, 
        Row, 
        Col, 
        Alert, 
        Tab, 
        Tabs, 
        InputGroup, 
        OverlayTrigger, 
        Tooltip, 
        Accordion,
        ListGroup} from "react-bootstrap";
import { FaArrowDown, 
         FaArrowLeft,
         FaArrowUp, 
         FaCheck, 
         FaEdit, 
         FaEye, 
         FaQuestionCircle, 
         FaSearch, 
         FaSpinner, 
         FaStream, 
         FaTimes, 
         FaTrash,
         FaGripVertical } from "react-icons/fa";
import { FaGear } from "react-icons/fa6";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import CreatableSelect from 'react-select/creatable';
import { IMaskInput } from "react-imask";
import ReactQuill from 'react-quill';
import AsyncSelect from 'react-select/async';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { MidiasContato, categoriasDeDicas, categoriasDeGraficos, categoriasDeProgramas, destinatariosMensagem, formatarValor, formatarValorAPI, getCurrentUser, hasPerm, momentosEnvio, responsaveisEtapas, tiposEnvio, tiposMensagem, tiposServicos, tiposUsuarioBotoes, unidadesDosagens, TiposCadastroMedico } from '../../common/utils';
import { withRouter } from '../../common/with-router';
import api from "../../services/api";
import '../Programas/ProgramasEdit.module.css';
import ProgramaRegras from './ProgramaRegras';
import ProgramaReguasComunicacao from './ProgramaReguasComunicacao';
import ProgramaConfiguracoes from './ProgramaConfiguracoes';
import ProgramaExamesLinhaCuidado from './ProgramaExamesLinhaCuidado';
import ProgramaFarmacovigilanciaConfig from './ProgramaFarmacovigilanciaConfig';
import ProgramaMensageriaRecorrente from './ProgramaMensageriaRecorrente';
import ModeloRelatorio from "./ProgramaModeloRelatorio.jsx";
import Editor from '@monaco-editor/react';
import ProgramaDashboard from "./ProgramaDashboard.jsx";
import ProgramaServicoProcedimento from "./ProgramaServicoProcedimento.jsx";
import ProgramaFAQ from "./ProgramaFAQ.jsx";
import ApiKeysPrograma from "../ProgramasV2/ApiKeysPrograma";
import AtualizacaoTermosPrograma from "./AtualizacaoTermosPrograma.jsx";
import AtualizacaoTermosPrestador from "./AtualizacaoTermosPrestador.jsx";

const StrictModeDroppable = ({ children, ...props }) => {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true));
    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);
  if (!enabled) {
    return null;
  }
  return <Droppable {...props}>{children}</Droppable>;
};

class ProgramasEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleEtapaChange = this.handleEtapaChange.bind(this);
        this.handleProdutoChange = this.handleProdutoChange.bind(this);
        this.handleChangeServico = this.handleChangeServico.bind(this);
        this.handleBotaoAtendimentoChange = this.handleBotaoAtendimentoChange.bind(this);
        this.handleColunaAtendimentoChange = this.handleColunaAtendimentoChange.bind(this);
        this.handleDicasChange = this.handleDicasChange.bind(this);
        this.handleSimNaoChange = this.handleSimNaoChange.bind(this);
        this.handleMidiasContatoChange = this.handleMidiasContatoChange.bind(this);
        this.handleOcultarEtapaChange = this.handleOcultarEtapaChange.bind(this);
        this.handleTiposMensagemChange = this.handleTiposMensagemChange.bind(this);
        this.onChangeWelcomeKit = this.onChangeWelcomeKit.bind(this);
        this.onChangeTermoPacientePDF = this.onChangeTermoPacientePDF.bind(this);
        this.onChangeClienteId = this.onChangeClienteId.bind(this);
        this.onChangeImagem = this.onChangeImagem.bind(this);
        this.onChangeImagemBranca = this.onChangeImagemBranca.bind(this);
        this.onChangeTermo = this.onChangeTermo.bind(this);
        this.onChangeTipo = this.onChangeTipo.bind(this);
        this.onChangeTermoPrestador = this.onChangeTermoPrestador.bind(this);
        this.onChangeDoenca = this.onChangeDoenca.bind(this);
        this.onChangeGrupo = this.onChangeGrupo.bind(this);
        this.onChangeModeloNovo = this.onChangeModeloNovo.bind(this);
        this.onChangeModeloExistente = this.onChangeModeloExistente.bind(this);
        this.handleHabilitarEnvioKitChange = this.handleHabilitarEnvioKitChange.bind(this);
        this.onChangeFarmacovigilancia = this.onChangeFarmacovigilancia.bind(this);
        this.handleKitChange = this.handleKitChange.bind(this);
        this.adicionarKit = this.adicionarKit.bind(this);
        this.handleProdutoKitChange = this.handleProdutoKitChange.bind(this);
        this.carregarKitsPrograma = this.carregarKitsPrograma.bind(this);
        this.salvarKit = this.salvarKit.bind(this);
        this.salvarProdutoKit = this.salvarProdutoKit.bind(this);
        this.removerKit = this.removerKit.bind(this);
        this.adicionarProdutoKit = this.adicionarProdutoKit.bind(this);
        this.removerProdutoKit = this.removerProdutoKit.bind(this);
        this.excluirArquivo = this.excluirArquivo.bind(this);

        this.enviaPrograma = this.enviaPrograma.bind(this);
        this.enviarFarmacovigilancia = this.enviarFarmacovigilancia.bind(this);

        this.onDragEnd = this.onDragEnd.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            uuid: '',
            nome: '',
            descricao: '',
            telefone: "",
            welcome_kit: '',
            welcome_kit_upload: '',
            bucketS3_nome: '',
            termo_paciente_pdf: '',
            termo_paciente_pdf_upload: '',
            dados_status: '',
            imagem_upload: '',
            imagem: '',
            magem_branca_upload: '',
            imagem_branca: '',
            tipo_id: '',
            tipo_nome: '',
            optout_logomarca_1: '',
            optout_logomarca_2: '',
            termo_id: '',
            termo_nome: '',
            termo_prestador_id: '',
            termo_prestador_nome: '',
            exige_confirmacao_diagnostico: '',
            doenca_principal_id: '',
            doenca_principal_nome: '',
            doencas: [{doenca_id: '', doenca_nome: '', idade_minima: '', idade_maxima: ''}],
            doencas_relacionadas: [],
            validacao_doenca: "paciente",
            showModalDoencasRelacionadas: false,
            showModalServico: false,
            showModalTemplate: false,
            cliente_id: this.props.dados_cliente?.cliente_id || "",
            cliente_nome: this.props.dados_cliente?.cliente_nome || "",
            permite_menor_idade: true,
            habilita_excel_farmacovigilancia: true,
            farmacovigilancia_habilitar_pdf: true,
            farmacovigilancia_imagem: '',
            farmacovigilancia_pdf_modelo: '',
            permite_atendimento_extra_com_aprovacao: true,
            medico_cadastro: false,
            laboratorio_cadastro: false,
            exibir_endereco_medico: false,
            habilitar_agendamentos_servicos: false,
            habilitar_vinculo_atendente: false,
            habilitar_escolha_laboratorio: false,
            habilitar_escolha_multiprofissional: false, 
            habilitar_gestao_aplicacoes: false,
            habilitar_optin_telefone: false,
            habilitar_validacao_atendimento: false,
            habilitar_registro_compras: false,
            habilitar_registro_dosagens: false,
            habilitar_gestao_produtos: false,
            habilitar_pre_cadastro_basico: false,
            endereco_paciente_obrigatorio: false,
            habilitar_mensageria_aniversario: false,
            habilitar_exames: false,
            habilitar_selecionar_multiplos_exames: false,
            ocultar_menu_atendimentos: false,
            ocultar_menu_receptivos: false,
            ocultar_nome_local: false,
            habilitar_geolocalizacao_laboratorios: false,
            exige_cpf_atendimento: false,
            permite_reativar_atendimento: false,
            exige_aceite_termo_opt_in_medicos: false,
            habilitar_indicacao_profissional: false,
            declaracao_indicacao: '',
            declaracao_indicacao_upload: '',
            declaracao_indicacao_marcacoes: '',
            erroMarcacoesDeclaracao: '',
            optout_habilitado: false,
            monitoria_tipos: [],
            layout_cor_fundo: '#FFFFFF',
            layout_cor_primaria: '#000000',
            layout_cor_secundaria: '#333333',
            label_botao_atendimento: '',
            label_endereco_paciente: '',
            canais_contato: '',
            nome_equipe: '',
            orientacao_cadastro: '',
            instrucoes_paciente_termo: '',
            instrucoes2_paciente_termo: '',
            dicas_texto: '',
            instrucao_atendimento: '',
            informacoes_receptivo: '',
            optout_titulo: '',
            optout_texto: '',
            template_atendimento_receptivo: '',
            template_mensageria_aniversario: '',
            template_mensagem_whatsapp: '',
            termos_template_whatsapp_prestador: '',
            link_politica_programa: '',
            link_regulamento_programa: '',
            medico_novo_modelo_mensagem_id: '',
            medico_novo_modelo_mensagem_titulo: '',
            medico_existente_modelo_mensagem_id: '',
            medico_existente_modelo_mensagem_titulo: '',
            versao: '',
            dados_cliente: Object,
            categoria: "",
            optout_status_id: "",
            contato_nome: "",
            contato_celular: "",
            contato_email: "",
            status: true,
            grupo_cadastro_medico_id: '',
            grupo_cadastro_medico_nome: '',
            farmacovigilancia_formulario_id: '',
            farmacovigilancia_formulario_nome: '',
            farmacovigilancia_email: '', 
            texto_sessao1: '' ,
            n_documento: '' ,
            farmacovigilancia_modelo: '' ,
            habilitar_envio_kit: false,
            imagemHelper: "",
            imagemBrancaHelper: "",
            logomarca1Helper: "",
            logomarca2Helper: "",
            nomeHelper: "",
            welcomeKitHelper: "",
            termoPacientePDFHelper: "",
            clienteIdHelper: "",
            categoriaHelper: "",
            tipoHelper: "",
            optoutHelper: "",
            telefoneHelper: "",
            tipoFaturamentoHelper: "",
            descricaopHelper: "",
            contatoNomeHelper: "",
            bucketS3Helper: "",
            contatoCelularHelper: "",
            contatoEmailHelper: '',
            layoutCorFundoHelper: '',
            layoutCorPrimariaHelper: '',
            layoutCorSecundariaHelper: '',
            statusHelper: '',
            erroLoadRegistro: "",
            programa_id: "",
            configuracoes: {},
            documentacao_configuracoes: "",
            titulo_pagina: "",
            loading: false,
            showModalHelpConfigEtapa: false,
            tipo_faturamento: "",
            tipo_cadastro_medico: "",
            regulamento_programa: '',
            regulamento_programa_upload: '',
            aviso_privacidade: '',
            aviso_privacidade_upload: '',
            politica_cookies: '',
            politica_cookies_upload: '',
            termos_programa_medicos: '',
            termos_programa_medicos_upload: '',
            opcoesClientes: [],
            carregamentoAbas: [],
            filtros_atendimento_padrao: [
                {id: null, slug: "acao_navegador", nome: "Ação Navegador",  ordem: 0, padrao: false, tipo: 'filtro_rapido', exibir_filtro: true, show: false},
                {id: null, slug: "andamento", nome: "Andamento", ordem: 1, padrao: false, tipo: 'filtro_rapido', exibir_filtro: true, show: false},
                {id: null, slug: "finalizados", nome: "Finalizados", ordem: 2, padrao: false, tipo: 'filtro_rapido', exibir_filtro: true, show: false},
                {id: null, slug: "cancelados", nome: "Cancelados", ordem: 3, padrao: false, tipo: 'filtro_rapido', exibir_filtro: true, show: false},
                {id: null, slug: "nome_paciente", nome: "Nome do Paciente", ordem: 0, padrao: false, tipo: 'filtro_avancado', exibir_filtro: true, show: false},
                {id: null, slug: "cpf_paciente", nome: "CPF do Paciente", ordem: 1, padrao: false, tipo: 'filtro_avancado', exibir_filtro: true, show: false},
                {id: null, slug: "nome_laboratorio", nome: "Nome do Laboratório", ordem: 2, padrao: false, tipo: 'filtro_avancado', exibir_filtro: true, show: false},
                {id: null, slug: "programa", nome: "Programa", ordem: 3, padrao: false, tipo: 'filtro_avancado', exibir_filtro: true, show: false},
                {id: null, slug: "etapa", nome: "Etapa", ordem: 4, padrao: false, tipo: 'filtro_avancado', exibir_filtro: true, show: false},
                {id: null, slug: "status", nome: "Status", ordem: 5, padrao: false, tipo: 'filtro_avancado', exibir_filtro: true, show: false},
                {id: null, slug: "atendente", nome: "Atendente", ordem: 6, padrao: false, tipo: 'filtro_avancado', exibir_filtro: true, show: false}
            ],
            colunas_atendimento_padrao: [
                {id: null, slug: "paciente", nome: "Paciente", ordem: 0, show: false, exibir_campo: true},
                {id: null, slug: "laboratorio", nome: "Laboratório", ordem: 1, show: false, exibir_campo: true},
                {id: null, slug: "data_cadastro", nome: "Data Cadastro", ordem: 2, show: false, exibir_campo: true},
                {id: null, slug: "ultima_modificacao", nome: "Última Modificação", ordem: 3, show: false, exibir_campo: true},
                {id: null, slug: "programa", nome: "Programa", ordem: 4, show: false, exibir_campo: true},
                {id: null, slug: "status", nome: "Status", ordem: 5, show: false, exibir_campo: true},
                {id: null, slug: "etapa", nome: "Etapa", ordem: 6, show: false, exibir_campo: true},
                {id: null, slug: "tempo_etapa", nome: "Tempo na Etapa", ordem: 7, show: false, exibir_campo: true},
                {id: null, slug: "proxima_acao", nome: "Próxima Ação", ordem: 8, show: false, exibir_campo: true}
            ],
            aplicacoes_legenda: "" ,
            status_aplicacao: [{nome: "", motivos_nao_realizacao: ""}],
            dosagens: [{quantidade: "", unidade: "", id: null}],
            status_programa: [{nome: "", slug: '', ativo: "", ordem: '', cor: '#000000', template_whatsapp: "", descricao: '', orientacao: '', tipo: '', menu_adicional_atendimento: '', id: null}],            
            etapas: [{ 
                nome: '', dias_proxima_etapa: '', formulario_id: '', descricao: '', 
                formulario_nome: '', formulario_pesquisa_id: '', formulario_pesquisa_nome: '', responsavel_etapa: '', ocultar_etapa: [], midias_contato: [], 
                tipo_mensagem: [], whatsapp_template: '', tipo_envio: '', momento_envio: '', 
                etapa_termo: '', etapa_pesquisa: '', etapa_pesquisa_id: null, acao_navegador_apos_prazo: '', prazo_acao_navegador: '', 
                etapa_nota_fiscal: '', conteudo_mensagem: '', conteudo_mensagem_email: '', 
                destinatario_mensagem: '', id: null, titulo_sucesso_finalizacao: '', 
                mensagem_sucesso_finalizacao: '', cancelamento_whatsapp_template: '', 
                cancelamento_titulo_email: '', cancelamento_conteudo_mensagem: '', 
                cancelamento_conteudo_mensagem_email: '', cancelamento_destinatario_mensagem: '', 
                cancelamento_retorno_whatsapp_template: '', cancelamento_retorno_titulo_email: '', 
                cancelamento_retorno_conteudo_mensagem: '', cancelamento_retorno_conteudo_mensagem_email: '', 
                cancelamento_retorno_destinatario_mensagem: '', servicos_procedimentos: [], 
                isServicosFocused: false, opcoesServicos: [], servicos_relacionados_bool: false, etapa_tipo_paciente: '',
                servico_obrigatorio: false, servico_fixo: false, alerta_navegador: '', status_finalizacao_etapa_id: "",
                avancar_etapa_automaticamente: '', dias_envio_mensageria: '', envia_mensageria_cron: '', criar_acao_atendimento: false, acao_id:'', acao_nome:'', acao_texto: '', configuracoes: '[]',
            }],
            produtos: [{ valor: '', titulo: '', produto_id: '', produto_nome: '', ordem: '', etapa_id: '', etapa_nome: '', id: null }],
            servicos: [{ valor: '', limite_por_cpf: "", servico_procedimento_id: '', servico_procedimento_nome: '', estados_selecionados: '', estados_register: "", id: null, show: false, limite_observacao: '', permite_ultrapassar_limite: false, lembrete_dia_anterior: false, template_whatsapp_prestador: '', template_whatsapp_paciente: '', limite_reagendamentos: '', limite_periodo: '' }],
            historico_de_compras: [{ valor: '', produto_id: '', produto_nome: '', id: null }],
            botoes_atendimento: [{ titulo: '', descricao: '', formulario_id: '',  callback_funcao: '',  formulario_nome: '', tipo_usuario: '', envia_email: false, email_enderecos: "", email_titulo: "", email_conteudo: "", exibir_botao_monitoria: false, exibir_aba: false, id: null }],
            dicas: [{ titulo: '', imagem: '', imagem_upload: '', descricao: '', categoria: '', id: null }],
            graficos: [{titulo_grafico: '', categoria: ''}],
            ocultar_menu_prestadores: false,
            showModalConfiguracoes: false,
            etapaConfiguracaoIndex: null,
            configuracoesJson: '[]',
            configuracoesJsonError: '',
            loadingModalConfiguracoes: false,
            label_doencas: "",
            habilitar_tipos_agendamento: "",
            agendamento_email_solicitacao_prestador: "",
            solicitacao_aceite_termo_opt_in_medicos: "",
            envio_email_credenciais_de_acesso_medicos: "",
            agendamento_email_atualizacao_status: "",
            limite_atendimentos_por_cpf: "",
            aviso_limite_atendimentos: "",
            motivos_optout: [{titulo: "", ordem: ''}],
            acoes_programa: [{nome: "", ordem: '', slug: ''}],
            servico_titulo: "Adicionar Serviço/Procedimento",
            template_titulo: "Configuração de templates para envio manual",
            servico_id: "",
            servico_nome: "",
            servico_descricao: "",
            servico_tipo: "",
            servico_valor: "",
            servico_nomeHelper: "",
            servico_descricaoHelper: "",
            servico_tipoHelper: "",
            servico_valorHelper: "",
            templates: [{ titulo: "", template: "", destinatario: "" }],
            kits: [{ titulo: '', status: true, produtos: [{ produto_id: '', dosagem: '' }] }],
            template_id: "",
            tituloHelper: "",
            templateHelper: "",
            destinatarioHelper: "",
        };

        this.tiposFaturamento = {
            "atendimento": "Atendimento",
            "servico": "Serviço"
        };

        this.list_tipo_dosagem = {
            gotas: "Gotas",
            ml: "ML"
        };

        this.carregarProdutos();
    }

    componentDidMount(){
        const id = this.props.router.params.id;

        let dados_usuario = getCurrentUser();
        if (!hasPerm('change_programas') || (dados_usuario['tipo_usuario'] != '' && dados_usuario['tipo_usuario'] != 'gestor')) {
            window.location.href = '/sem-permissao';
            return;
        }

        const ambienteId = Number(dados_usuario.ambiente_programa_id);
        const currentId  = Number(id);

        if(dados_usuario['tipo_usuario'] && ambienteId !== currentId) {
            window.location.href = '/sem-permissao';
            return;
        }
    
        this.carregarDadosPrograma();
    }

    carregarKitsPrograma = async () => {
        if (this.state.programa_id) {
            try {
                const responseKits = await api.get(`/programas/kits/?programa_id=${this.state.programa_id}`);
                const kits = responseKits.data.results;
    
                for (let kit of kits) {
                    const responseProdutos = await api.get(`/programas/kits/produtos/?programa_kit_id=${kit.id}`);
                    kit.produtos = responseProdutos.data.results.map(produto => ({
                        id: produto.id,
                        produto_id: produto.produto_id,
                        produto_nome: produto.dados_produto.nome,
                        dosagem: produto.dosagem,
                        dosagem_tipo: produto.dosagem_tipo
                    }));
                }
    
                this.setState({ kits });
            } catch (error) {
                console.error('Erro ao carregar kits e produtos:', error);
            }
        }
    };

    async salvarKit(index) {
        const kit = this.state.kits[index];
        const url = kit.id ? `/programas/kits/${kit.id}/` : '/programas/kits/';
        const metodo = kit.id ? 'put' : 'post';
    
        const dadosKit = {
            titulo: kit.titulo,
            programa_id: this.state.programa_id,
            status: kit.status,
        };
    
        try {
            const response = await api({
                method: metodo,
                url: url,
                data: dadosKit,
            });
    
            if (!kit.id) {
                const kits = [...this.state.kits];
                kits[index].id = response.data.id;
                this.setState({ kits });
            }
    
            // Verificar se há produtos no kit antes de salvar
            if (kit.produtos && kit.produtos.length > 0) {
                // Salvar produtos do kit
                for (let produtoIndex = 0; produtoIndex < kit.produtos.length; produtoIndex++) {
                    await this.salvarProdutoKit(index, produtoIndex);
                }
        }
    
            const MySwal = withReactContent(Swal);
            const textSwal = kit.id ? 'Kit atualizado com sucesso' : 'Novo kit adicionado com sucesso';
    
            MySwal.fire({
                title: 'Sucesso!',
                text: textSwal,
                icon: 'success',
                showCloseButton: true,
            });
    
        } catch (error) {
            console.error('Erro ao salvar kit:', error);
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                title: 'Erro!',
                text: 'Erro ao salvar o kit, tente novamente.',
                icon: 'error',
                showCloseButton: true,
            });
        }
    }

    async salvarProdutoKit(kitIndex, produtoIndex) {
        const produto = this.state.kits[kitIndex].produtos[produtoIndex];
        const url = produto.id ? `/programas/kits/produtos/${produto.id}/` : '/programas/kits/produtos/';
        const metodo = produto.id ? 'put' : 'post';
    
        const dadosProduto = {
            programa_kit_id: this.state.kits[kitIndex].id,
            produto_id: produto.produto_id,
            dosagem: produto.dosagem,
            dosagem_tipo: produto.dosagem_tipo
        };
    
        try {
            const response = await api({
                method: metodo,
                url: url,
                data: dadosProduto,
            });
    
            if (!produto.id) {
                const kits = [...this.state.kits];
                kits[kitIndex].produtos[produtoIndex].id = response.data.id;
                this.setState({ kits });
            } else {
                const kits = [...this.state.kits];
                kits[kitIndex].produtos[produtoIndex] = {
                    ...kits[kitIndex].produtos[produtoIndex],
                    produto_id: response.data.produto_id,
                    dosagem: response.data.dosagem,
                    dosagem_tipo: response.data.dosagem_tipo
                };
                this.setState({ kits });
            }
        } catch (error) {
            // Verifica se o erro é do tipo ERR_BAD_REQUEST e exibe a mensagem retornada pela API
            let erro_msg = 'Erro ao salvar produto do kit, verifique os campos e tente novamente.';
            if (error.code === 'ERR_BAD_REQUEST' && error.response && error.response.data) {
                erro_msg = JSON.stringify(error.response.data);
            }
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Atenção!',
                html: erro_msg,
            });
        }
    }

    carregarDadosPrograma = async () => {
        const id = this.props.router.params.id;

        if(id){
            this.setState({
                programa_id: id,
                titulo_pagina: 'Editando Programa',
                loading: true,
                erroLoadRegistro: ''
            })

            //consulta os dados do programa na api
            await api.get(`/programas/${id}`)
            .then(response => {
                const dadosResponse = response.data;
                const dados = this.tratarNulos(dadosResponse);

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',
                    uuid: dados.uuid,
                    nome: dados.nome,
                    descricao: dados.descricao,
                    telefone: dados.telefone,
                    welcome_kit: dados.welcome_kit,
                    termo_paciente_pdf: dados.termo_paciente_pdf,
                    imagem: dados.imagem,
                    imagem_branca: dados.imagem_branca,
                    tipo_id: dados.tipo_id,
                    tipo_nome: (dados.dados_tipo.nome) ? dados.dados_tipo.nome : '',
                    optout_logomarca_1: dados.optout_logomarca_1,
                    optout_logomarca_2: dados.optout_logomarca_2,
                    dados_status: dados.dados_status,
                    termo_id: dados.termo_id,
                    termo_nome: (dados.dados_termo.nome) ? dados.dados_termo.nome : '',
                    termo_prestador_id: dados.termo_prestador_id,
                    termo_prestador_nome: (dados.dados_termo_prestador.nome) ? dados.dados_termo_prestador.nome : '',
                    medico_novo_modelo_mensagem_id: dados.medico_novo_modelo_mensagem_id,
                    medico_novo_modelo_mensagem_titulo: dados.dados_medico_novo_modelo_mensagem.titulo,
                    medico_existente_modelo_mensagem_id: dados.medico_existente_modelo_mensagem_id,
                    medico_existente_modelo_mensagem_titulo: dados.dados_medico_existente_modelo_mensagem.titulo,
                    cliente_id: dados.cliente_id,
                    dados_cliente: dados.dados_cliente,
                    categoria: dados.categoria,
                    optout_status_id: dados.optout_status_id,
                    contato_nome: dados.contato_nome,
                    bucketS3_nome: dados.bucketS3_nome,
                    contato_celular: dados.contato_celular,
                    contato_email: dados.contato_email,
                    permite_menor_idade: dados.permite_menor_idade,
                    permite_atendimento_extra_com_aprovacao: dados.permite_atendimento_extra_com_aprovacao,
                    medico_cadastro: dados.medico_cadastro,
                    laboratorio_cadastro: dados.laboratorio_cadastro,
                    habilitar_agendamentos_servicos: dados.habilitar_agendamentos_servicos,
                    habilitar_gestao_produtos: dados.habilitar_gestao_produtos,
                    habilitar_exames: dados.habilitar_exames,
                    habilitar_selecionar_multiplos_exames: dados.habilitar_selecionar_multiplos_exames,
                    habilitar_vinculo_atendente: dados.habilitar_vinculo_atendente,
                    habilitar_escolha_laboratorio: dados.habilitar_escolha_laboratorio,
                    habilitar_escolha_multiprofissional: dados.habilitar_escolha_multiprofissional,
                    habilitar_optin_telefone: dados.habilitar_optin_telefone,
                    habilitar_registro_compras: dados.habilitar_registro_compras,
                    habilitar_registro_dosagens: dados.habilitar_registro_dosagens,
                    habilitar_gestao_aplicacoes: dados.habilitar_gestao_aplicacoes,
                    habilitar_pre_cadastro_basico: dados.habilitar_pre_cadastro_basico,    
                    endereco_paciente_obrigatorio: dados.endereco_paciente_obrigatorio, 
                    ocultar_menu_atendimentos: dados.ocultar_menu_atendimentos,
                    habilitar_mensageria_aniversario: dados.habilitar_mensageria_aniversario,
                    habilitar_validacao_atendimento: dados.habilitar_validacao_atendimento,
                    ocultar_menu_receptivos: dados.ocultar_menu_receptivos,
                    ocultar_menu_prestadores: dados.ocultar_menu_prestadores,
                    ocultar_nome_local: dados.ocultar_nome_local,
                    habilitar_geolocalizacao_laboratorios: dados.habilitar_geolocalizacao_laboratorios,
                    exige_cpf_atendimento: dados.exige_cpf_atendimento,
                    permite_reativar_atendimento: dados.permite_reativar_atendimento,
                    exige_aceite_termo_opt_in_medicos: dados.exige_aceite_termo_opt_in_medicos,
                    habilitar_indicacao_profissional: dados.habilitar_indicacao_profissional || false,
                    declaracao_indicacao: dados.declaracao_indicacao || '',
                    //o JSON vai para a tela como texto identado: é editado à mão
                    declaracao_indicacao_marcacoes: dados.declaracao_indicacao_marcacoes
                        ? JSON.stringify(dados.declaracao_indicacao_marcacoes, null, 2) : '',
                    optout_habilitado: dados.optout_habilitado,
                    grupo_cadastro_medico_id: dados.grupo_cadastro_medico_id,
                    grupo_cadastro_medico_nome: dados.dados_grupo_cadastro_medico.nome,
                    layout_cor_fundo: dados.layout_cor_fundo,
                    layout_cor_primaria: dados.layout_cor_primaria,
                    layout_cor_secundaria: dados.layout_cor_secundaria,
                    doenca_principal_id: dados.doenca_principal_id,
                    doenca_principal_nome: dados.dados_doenca_principal.nome,
                    validacao_doenca: dados.validacao_doenca,
                    exige_confirmacao_diagnostico: dados.exige_confirmacao_diagnostico,
                    label_botao_atendimento: dados.label_botao_atendimento,
                    label_endereco_paciente: dados.label_endereco_paciente,
                    canais_contato: dados.canais_contato,
                    nome_equipe: dados.nome_equipe,
                    orientacao_cadastro: dados.orientacao_cadastro,
                    instrucoes_paciente_termo: dados.instrucoes_paciente_termo,
                    instrucoes2_paciente_termo: dados.instrucoes2_paciente_termo,
                    dicas_texto: dados.dicas_texto,
                    instrucao_atendimento: dados.instrucao_atendimento,
                    informacoes_receptivo: dados.informacoes_receptivo,
                    optout_titulo: dados.optout_titulo,
                    optout_texto: dados.optout_texto,
                    template_atendimento_receptivo: dados.template_atendimento_receptivo,
                    template_mensageria_aniversario: dados.template_mensageria_aniversario,
                    template_mensagem_whatsapp: dados.template_mensagem_whatsapp,
                    termos_template_whatsapp_prestador: dados.termos_template_whatsapp_prestador || '',
                    link_politica_programa: dados.link_politica_programa,
                    link_regulamento_programa: dados.link_regulamento_programa,
                    versao: dados.versao,
                    status: dados.status,
                    tipo_faturamento: dados.tipo_faturamento,
                    tipo_cadastro_medico: dados.tipo_cadastro_medico ?? "",
                    farmacovigilancia_formulario_id: dados.farmacovigilancia_formulario_id,
                    farmacovigilancia_formulario_nome: dados.dados_farmacovigilancia_formulario.nome,
                    farmacovigilancia_email: dados.farmacovigilancia_email,
                    habilita_excel_farmacovigilancia: dados.habilita_excel_farmacovigilancia,
                    farmacovigilancia_habilitar_pdf: dados.farmacovigilancia_habilitar_pdf,
                    farmacovigilancia_pdf_modelo: dados.farmacovigilancia_pdf_modelo,
                    habilitar_envio_kit: dados.habilitar_envio_kit_paciente,
                    //loading: false,
                    regulamento_programa: dados.regulamento_programa,
                    aviso_privacidade: dados.aviso_privacidade,
                    politica_cookies: dados.politica_cookies,
                    termos_programa_medicos: dados.termos_programa_medicos,
                    opcoesClientes: [{
                        value: dados.cliente_id,
                        label: dados.dados_cliente.nome_fantasia || dados.dados_cliente.nome
                    }],
                    titulo_pagina: 'Editando Programa: ' + dados.nome,
                    aplicacoes_legenda: dados.aplicacoes_legenda,
                    label_doencas: dados.label_doencas,
                    habilitar_tipos_agendamento: dados.habilitar_tipos_agendamento,
                    agendamento_email_solicitacao_prestador: dados.agendamento_email_solicitacao_prestador,
                    solicitacao_aceite_termo_opt_in_medicos: dados.solicitacao_aceite_termo_opt_in_medicos,
                    envio_email_credenciais_de_acesso_medicos: dados.envio_email_credenciais_de_acesso_medicos,
                    agendamento_email_atualizacao_status: dados.agendamento_email_atualizacao_status,
                    limite_atendimentos_por_cpf: dados.limite_atendimentos_por_cpf,
                    aviso_limite_atendimentos: dados.aviso_limite_atendimentos,
                    configuracoes: dadosResponse.configuracoes || {},
                    documentacao_configuracoes: dadosResponse.documentacao_configuracoes || "",
                })

                this.carregarStatusAplicacao();
                this.carregarDosagens();
                this.carregarOptOutMotivos();
                this.carregarKitsPrograma();

                this.setState({
                    loading: false
                })
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar programa, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
        else {

            if(!hasPerm('add_programas')) {
                this.props.router.navigate("/sem-permissao");
                return;
            }

            this.setState({
                programa_id: '',
                titulo_pagina: 'Adicionar Programa',
                loading: false,
                erroLoadRegistro: '',
            })
        }
    }

    removeMonitoriaTipos = async(id) => {
        const url = `/programas/aplicacoes-tipos/${id}`;
        const metodo = 'DELETE';

        api({
            method: metodo,
            url: url
        })
        .then(response => {
            this.setState(({
                monitoria_tipos: this.state.monitoria_tipos.filter(tipo => tipo.value !== id),
            }));
            
        })
        .catch(error => {
            console.error("Erro ao remover um novo Tipo: " + error)
        });    
    }

    handleChangeMonitoriaTipos = async (selectedOptions) => {
        // Detecta os tipos removidos comparando com o estado anterior
        const removedItems = this.state.monitoria_tipos.filter(
            (item) => !selectedOptions.some((option) => option.value === item.value)
        );
        if (removedItems.length > 0) {
            // Aqui você sabe que um item foi removido
            // Chama a função para deletar o tipo na API
            removedItems.forEach((item) => this.removeMonitoriaTipos(item.value));
        }

        this.setState(({
            monitoria_tipos: selectedOptions,
        }));
        
    }

    criaMonitoriaTipos = async (valor) => {
        const url = `/programas/aplicacoes-tipos/`;
        const metodo = 'post';
    
        const dadosInsert = {
            nome: valor,
            programa_id: this.state.programa_id
        }

        api({
            method: metodo,
            url: url,
            data: dadosInsert,
        })
        .then(response => {
            this.setState(prevState => ({
                monitoria_tipos: [...prevState.monitoria_tipos, { value: response.data.id, label: response.data.nome }],
            }));
            
        })
        .catch(error => {
            console.error("Erro ao cadastrar um novo Tipo: " + error)
        });

    }

    carregaMonitoriaTipos = async () => {
        try {
            const response = await api.get(`/programas/aplicacoes-tipos/?programa_id=${this.state.programa_id}`);
            const opcoes = response.data.results.map(tipos => ({
                value: tipos.id,
                label: tipos.nome
            }));
            this.setState({ monitoria_tipos: opcoes });
        } catch (error) {
            console.error('Erro ao carregar tipos:', error);
            return [];
        }
    };

    tratarNulos = (obj) => {
        const novoObjeto = {};
        for (let key in obj) {
            novoObjeto[key] = (obj[key] === null || obj[key] === "null") ? "" : obj[key];
        }
        return novoObjeto;
    };

    carregarDadosFarmacovigilanciaPrograma = async () => {
        const { programa_id } = this.state;
    
        if (programa_id) {

            this.setState({
                loading: true,
                erroLoadRegistro: ''
            });
    
           
            api.get(`/programas/farmacovigilancia/?programa_id=${programa_id}`)
                .then(response => {
                    const dadosFarmacovigilancia = response.data.results;
    
                    if (dadosFarmacovigilancia.length > 0) {
                        const registro = dadosFarmacovigilancia[0];
    
                        this.setState({
                            texto_sessao1: registro.texto_sessao1 || '',
                            n_documento: registro.n_documento || '',
                            farmacovigilancia_modelo: registro.farmacovigilancia_modelo || '',
                            versao: registro.versao || '',
                            farmacovigilancia_imagem: registro.farmacovigilancia_imagem || '',
                            farmacovigilancia_pdf_modelo: registro.farmacovigilancia_pdf_modelo || '',
                            habilita_excel_farmacovigilancia: registro.habilita_excel_farmacovigilancia || '',
                            farmacovigilancia_habilitar_pdf: registro.farmacovigilancia_habilitar_pdf || '',
                            loading: false
                        });
                    } else {
                        this.setState({
                            texto_sessao1: '',
                            n_documento: '',
                            farmacovigilancia_modelo: '',
                            habilita_excel_farmacovigilancia: '',
                            farmacovigilancia_habilitar_pdf: '',
                            versao: '',
                            farmacovigilancia_imagem: '',
                            farmacovigilancia_pdf_modelo: '',
                            loading: false
                        });
                    }
                })
                .catch(error => {
                    console.error("Erro ao consultar dados de farmacovigilância:", error);
                    let erro_msg = 'Erro ao consultar dados de farmacovigilância, tente novamente';
                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }
                    this.setState({
                        erroLoadRegistro: erro_msg,
                        loading: false
                    });
                });
        } else {
            this.setState({
                texto_sessao1: '',
                n_documento: '',
                farmacovigilancia_modelo: '',
                farmacovigilancia_imagem: '',
                farmacovigilancia_pdf_modelo: '',
                versao: '',
                habilita_excel_farmacovigilancia: '',
                farmacovigilancia_habilitar_pdf: '',
                erroLoadRegistro: '',
                loading: false
            });
        }
    };
    
    carregarClientes = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/clientes/?nome=${inputValue}`);
            const opcoes = response.data.results.map(cliente => ({
                value: cliente.id,
                label: (cliente.dados_pessoa.nome_fantasia) ? `${cliente.dados_pessoa.nome_fantasia} (${cliente.dados_pessoa.razao_social})` : `${cliente.dados_pessoa.nome}`
            }));
            //this.setState({ opcoesClientes: opcoes });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            return [];
        }
    };

    carregarTiposPrograma = async (inputValue) => {
        try {
            const response = await api.get(`/programas/tipos/?nome=${inputValue}`);
            const opcoes = response.data.results.map(tipo => ({
                value: tipo.id,
                label: tipo.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar termos:', error);
            return [];
        }
    };

    carregarTermos = async (inputValue) => {
        try {
            const response = await api.get(`/termos/?titulo=${inputValue}`);
            const opcoes = response.data.results.map(termo => ({
                value: termo.id,
                label: termo.titulo
            }));
            //this.setState({ opcoesClientes: opcoes });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar termos:', error);
            return [];
        }
    };

    
    carregarDoencas = async (inputValue) => {
        try {
            const response = await api.get(`/doencas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(doenca => ({
                value: doenca.id,
                label: doenca.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar doenças:', error);
            return [];
        }
    };
    
    carregarFormularios = async (inputValue) => {
        try {
            const response = await api.get(`/formularios/?nome=${inputValue}&status=1&tipo=normal`);
            const opcoes = response.data.results.map(formulario => ({
                value: formulario.id,
                label: formulario.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar formulários:', error);
            return [];
        }
    };

    carregarFormulariosPesquisas = async (inputValue) => {
        try {
            const response = await api.get(`/formularios/?nome=${inputValue}&status=1&tipo=pesquisa`);
            const opcoes = response.data.results.map(formulario => ({
                value: formulario.id,
                label: formulario.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar formulários:', error);
            return [];
        }
    };

    CarregarModelosMensagem = async (inputValue) => {
        try {
            const response = await api.get(`/configuracoes/modelos-mensagem/?titulo=${inputValue}`);
            const opcoes = response.data.results.map(carregarModelosMensagem => ({
                value: carregarModelosMensagem.id,
                label: carregarModelosMensagem.titulo,
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar formulários:', error);
            return [];
        }
    };
    
    carregarFormulariosFarmacovigilancia = async (inputValue) => {
        try {
            const response = await api.get(`/formularios/?status=1&nome=${inputValue}`);
            const opcoes = response.data.results.map(farmacovigilancia_formulario => ({
                value: farmacovigilancia_formulario.id,
                label: farmacovigilancia_formulario.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar formulários de farmacovigilância:', error);
            return [];
        }
    };

    carregarProdutos = async (inputValue) => {
        //if (inputValue.length < 3) return [];
        try {
            const response = await api.get(`/produtos/?nome=${inputValue}&status=1`);
            const opcoes = response.data.results.map(produto => ({
                value: produto.id,
                label: produto.nome,
                valor: formatarValor(produto.valor)
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar produtos:', error);
            return [];
        }
    };

    carregarServicos = async (inputValue) => {
        try {
            // Realiza a primeira requisição para obter serviços do programa
            const responsePrograma = await api.get(`/servicos_procedimentos/?nome=${inputValue}&programa_id=${this.state.programa_id}&status=1&programa=${this.state.programa_id}`);
            const opcoesDoPrograma = responsePrograma.data.results;
    
            // Realiza a segunda requisição para obter todos os serviços disponíveis
            const responseTodos = await api.get(`/servicos_procedimentos/?nome=${inputValue}&status=1&`);
            const opcoes = responseTodos.data.results
                .filter(servico => !opcoesDoPrograma.some(opcao => opcao.id === servico.id)) // Filtra os serviços que já estão no programa
                .map(servico => ({
                    value: servico.id,
                    label: `${servico.nome} (#${servico.id})`,
                    valor: formatarValor(servico.valor)
                }));
    
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar serviços/procedimentos:', error);
            return [];
        }
    };

    carregarEstados = async (inputValue) => {
        try {
            const estadosBrasileiros = [
                { value: 'AC', label: 'Acre' },
                { value: 'AL', label: 'Alagoas' },
                { value: 'AM', label: 'Amazonas' },
                { value: 'AP', label: 'Amapá' },
                { value: 'BA', label: 'Bahia' },
                { value: 'CE', label: 'Ceará' },
                { value: 'DF', label: 'Distrito Federal' },
                { value: 'ES', label: 'Espírito Santo' },
                { value: 'GO', label: 'Goiás' },
                { value: 'MA', label: 'Maranhão' },
                { value: 'MT', label: 'Mato Grosso' },
                { value: 'MS', label: 'Mato Grosso do Sul' },
                { value: 'MG', label: 'Minas Gerais' },
                { value: 'PA', label: 'Pará' },
                { value: 'PB', label: 'Paraíba' },
                { value: 'PR', label: 'Paraná' },
                { value: 'PE', label: 'Pernambuco' },
                { value: 'PI', label: 'Piauí' },
                { value: 'RJ', label: 'Rio de Janeiro' },
                { value: 'RN', label: 'Rio Grande do Norte' },
                { value: 'RS', label: 'Rio Grande do Sul' },
                { value: 'RO', label: 'Rondônia' },
                { value: 'RR', label: 'Roraima' },
                { value: 'SC', label: 'Santa Catarina' },
                { value: 'SP', label: 'São Paulo' },
                { value: 'SE', label: 'Sergipe' },
                { value: 'TO', label: 'Tocantins' },
            ];

            const opcoes = estadosBrasileiros.filter(estado => 
                estado.label.toLowerCase().includes(inputValue.toLowerCase())
            );
    
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar serviços/procedimentos:', error);
            return [];
        }
    };

    onChangeGrupo = (grupoSelecionado) => {
        this.setState({ grupo_cadastro_medico_id: grupoSelecionado ? grupoSelecionado.value : '', grupo_cadastro_medico_nome: grupoSelecionado ? grupoSelecionado.label : '' });
    };

    carregarGrupos = async (inputValue) => {
        try {
            const response = await api.get(`/grupos/?nome=${inputValue}`);
            const opcoes = response.data.results.map(grupo => ({
                value: grupo.id,
                label: grupo.name
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar grupos:', error);
            return [];
        }
    };

    carregarDoencasPrograma = async (tipo) => {
        return await api.get(`/programas/doencas/?programa_id=${this.state.programa_id}`)
            .then(response => {
                if (tipo !== "enviar") {
                    const doencasPrograma = response.data.results.map(r => ({
                        value: r.dados_doenca.id,
                        label: r.dados_doenca.nome,
                    }));
    
                    this.setState({ doencas_relacionadas: doencasPrograma });
                }
                return response.data.results;
            })
            .catch(error => {
                console.error('Erro ao carregar doenças:', error);
                return [];
            });
    };

    removerDoenca = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover doença relacionada?',
            text: "Tem certeza que deseja remover esta doença relacionada?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
    
                const doenca = this.state.doencas[index];
    
                if (doenca.id) {
                    api({
                        method: 'delete',
                        url: `/programas/doencas/${doenca.id}/`,
                    })
                    .then(response => {
                        const MySwal = withReactContent(Swal);
                        const textSwal = 'Doença relacionada removida com sucesso';
    
                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        });
    
                        this.setState(prevState => ({
                            doencas: prevState.doencas.filter((_, i) => i !== index),
                        }));
    
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover a doença, tente novamente';
    
                        if (error.response && error.response.status === 500) {
                            erro_msg = 'Servidor indisponível no momento';
                        }
    
                        const MySwal = withReactContent(Swal);
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        });
                    });
    
                } else {
                    this.setState(prevState => ({
                        doencas: prevState.doencas.filter((_, i) => i !== index),
                    }));
    
                    MySwal.fire(
                        'Removida!',
                        'A doença relacionada foi removida.',
                        'success'
                    );
                }
            }
        });
    };
    

    adicionarDoenca = () => {
        this.setState(prevState => ({
            doencas: [
                ...prevState.doencas,
                {
                    doenca_id: '',
                    doenca_nome: '',
                    idade_minima: '',
                    idade_maxima: ''
                }
            ]
        }));
    };

    handleChangeIdade = (index, e, field) => {
        const doencas = [...this.state.doencas];
        doencas[index][field] = e.target.value;
        this.setState({ doencas });
    };

    onChangeDoencaRelacionada = (index, selectedOption) => {
        const doencas = [...this.state.doencas];
        doencas[index].doenca_id = selectedOption ? selectedOption.value : '';
        doencas[index].doenca_nome = selectedOption ? selectedOption.label : '';
        this.setState({ doencas });
    };

    salvarDoenca = (index) => {
        const doenca = this.state.doencas[index];
        const url = doenca.id ? `/programas/doencas/${doenca.id}/` : '/programas/doencas/';
        const metodo = doenca.id ? 'put' : 'post';
    
        const dadosDoenca = {
            programa_id: this.state.programa_id,
            doenca_id: doenca.doenca_id,
            idade_minima: doenca.idade_minima,
            idade_maxima: doenca.idade_maxima,
        };
    
        api({
            method: metodo,
            url: url,
            data: dadosDoenca,
        })
        .then(response => {
            // Se for uma nova doença, atualize o estado com a ID retornada pela API
            if (!doenca.id) {
                this.setState(prevState => {
                    const doencasAtualizadas = [...prevState.doencas];
                    doencasAtualizadas[index].id = response.data.id;
                    return { doencas: doencasAtualizadas };
                });
            }
    
            const MySwal = withReactContent(Swal);
            const textSwal = doenca.id ? 'Doença atualizada com sucesso' : 'Doença cadastrada com sucesso';
    
            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar a doença, verifique os campos e tente novamente';
            let content = '';
    
            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 400) {
                const campos = error.response.data;
    
                // percorre os campos com erro
                for (let key in campos) {
                    var value = campos[key];
    
                    if (key === 'doenca_id') {
                        content += `<br>&bull; Doença: ${value}`;
                    }
                    if (key === 'idade_minima') {
                        content += `<br>&bull; Idade Mínima: ${value}`;
                    }
                    if (key === 'idade_maxima') {
                        content += `<br>&bull; Idade Máxima: ${value}`;
                    }
                }
            }
    
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            });
        });
    };

    carregarDoencasRelacionadas = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/doencas/?programa_id=${this.state.programa_id}`)
                .then(response => {
                    const doencasCarregadas = response.data.results.map(doenca => ({
                        id: doenca.id,
                        doenca_id: doenca.dados_doenca.id,
                        doenca_nome: doenca.dados_doenca.nome,
                        idade_minima: doenca.idade_minima,
                        idade_maxima: doenca.idade_maxima
                    }));
                    this.setState({ doencas: doencasCarregadas });
                })
                .catch(error => {
                    console.error('Erro ao carregar doenças:', error);
    
                    let erro_msg = 'Erro ao carregar doenças relacionadas, tente novamente';
    
                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }
    
                    this.setState({
                        erroLoadRegistro: erro_msg,
                    });
                });
        }
    };

    enviaMonitoria = async () => {
        const formData = new FormData();
    
        const url = '/programas/' + this.state.programa_id + '/';
        const metodo = 'put';
    
        if (this.state.aplicacoes_legenda) {
            formData.append('aplicacoes_legenda', this.state.aplicacoes_legenda);
        }

        try {
            const response = await api({
                method: metodo,
                url: url,
                data: formData,
            });

            const MySwal = withReactContent(Swal);
            const textSwal = 'Monitoria atualizado com sucesso';
    
            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            });
    
            this.setState({
                loading: false,
            });
        } 
        catch (error) {
            let erro_msg = "Erro ao realizar o cadastro:<br />";
    
            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 400) {
                const responseData = error.response.data;
                const campos = responseData.erros ? responseData.erros : responseData;
            }
    
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: "Atenção!",
                html: erro_msg,
            });
    
            this.setState({
                loading: false,
            });
        }    
    } 

    enviaMotivoOptOut = async () => {
        const formData = new FormData();
    
        const url = '/programas/optout-motivos/' + this.state.programa_id + '/';
        const metodo = 'put';
    
        if (this.state.titulo) {
            formData.append('titulo', this.state.titulo);
        }
        if (this.state.ordem) {
            formData.append('ordem', this.state.ordem);
        }

        try {
            const response = await api({
                method: metodo,
                url: url,
                data: formData,
            });

            const MySwal = withReactContent(Swal);
            const textSwal = 'Monitoria atualizado com sucesso';
    
            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            });
    
            this.setState({
                loading: false,
            });
        } 
        catch (error) {
            let erro_msg = "Erro ao realizar o cadastro:<br />";
    
            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 400) {
                const responseData = error.response.data;
                const campos = responseData.erros ? responseData.erros : responseData;
            }
    
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: "Atenção!",
                html: erro_msg,
            });
    
            this.setState({
                loading: false,
            });
        }    
    } 

    enviaDoencas = async (id) => {
        const formData = new FormData();
    
        const url = this.state.programa_id ? '/programas/' + this.state.programa_id + '/' : '/programas/';
        const metodo = this.state.programa_id ? 'put' : 'post';

        if (this.state.validacao_doenca) {
            formData.append('validacao_doenca', this.state.validacao_doenca);
        }
        
        formData.append('exige_confirmacao_diagnostico', this.state.exige_confirmacao_diagnostico);
        
        if (this.state.doenca_principal_id) {
            formData.append('doenca_principal_id', this.state.doenca_principal_id);
        }

        if (this.state.label_doencas) {
            formData.append('label_doencas', this.state.label_doencas);
        }
    
        try {
            const response = await api({
                method: metodo,
                url: url,
                data: formData,
            });
    
            const doencasRelacionadas = this.state.doencas_relacionadas;
    
            // Carregar as doenças cadastradas
            const doencasCadastradas = await this.carregarDoencasPrograma("enviar");
    
            // Excluir todas as doenças cadastradas
            if (doencasCadastradas.length > 0) {
                await Promise.all(
                    doencasCadastradas.map(async (r) => {
                        try {
                            await api.delete(`/programas/doencas/${r.id}/`);
                        } catch (error) {
                            console.error(`Erro ao excluir doença com ID ${r.id}:`, error);
                        }
                    })
                );
            }
    
            // Inserir novas doenças relacionadas
            if (doencasRelacionadas.length > 0) {
                await Promise.all(
                    doencasRelacionadas.map(async (e) => {
                        const formData = new FormData();
                        formData.append("programa_id", this.state.programa_id ? this.state.programa_id : id);
                        formData.append("doenca_id", e.value);
                        formData.append("idade_minima", e.value);
                        formData.append("idade_maxima", e.value);
    
                        try {
                            await api({
                                method: "POST",
                                url: "/programas/doencas/",
                                data: formData,
                            });
                        } catch (error) {
                            //console.error(`Erro ao inserir doença com ID ${e.value}:`, error);
                        }
                    })
                );
            }
    
            // Exibir a mensagem de sucesso
            const MySwal = withReactContent(Swal);
            const textSwal = this.state.programa_id ? 'Programa atualizado com sucesso' : 'Programa cadastrado com sucesso';
    
            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            });
    
            this.setState({
                loading: false,
            });
    
        } catch (error) {
            let erro_msg = "Erro ao realizar o cadastro:<br />";
    
            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 400) {
                const responseData = error.response.data;
                const campos = responseData.erros ? responseData.erros : responseData;
            }
    
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: "Atenção!",
                html: erro_msg,
            });
    
            this.setState({
                loading: false,
            });
        }
    };
    handleKitChange(index, event, fieldName) {
        const kits = [...this.state.kits];
        kits[index][fieldName] = event.target.value;
        this.setState({ kits });
    }

    adicionarKit() {
        this.setState(prevState => ({
            kits: [...prevState.kits, { titulo: '', status: true, produtos: [{ produto_id: '', dosagem: '' }] }],
        }));
    }

    async removerKit(index) {
        const kit = this.state.kits[index];
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover kit?',
            text: "Tem certeza que deseja remover este kit?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                if (kit.id) {
                    try {
                        await api.delete(`/programas/kits/${kit.id}/`);
                        
                        // Remove o kit do estado local
                        const kits = [...this.state.kits];
                        kits.splice(index, 1);
                        this.setState({ kits });
    
                        Swal.fire('Sucesso', 'Kit removido com sucesso!', 'success');
                    } catch (error) {
                        if (error.response && error.response.status === 400) {
                            Swal.fire('Aviso', error.response.data.detail, 'warning');
                        } else {
                            Swal.fire('Erro', 'Erro ao remover kit, tente novamente.', 'error');
                        }
                    }
                } else {
                    // Remove o kit do estado local se não tiver ID
                    const kits = [...this.state.kits];
                    kits.splice(index, 1);
                    this.setState({ kits });
    
                    Swal.fire('Sucesso', 'Kit removido com sucesso!', 'success');
                }
            }
        });
    }

    handleProdutoKitChange = (kitIndex, produtoIndex, selectedOption, field) => {
        const value = selectedOption ? selectedOption.value : '';
        const label = selectedOption ? selectedOption.label : '';
        this.setState((prevState) => {
          const kits = [...prevState.kits];
          kits[kitIndex].produtos[produtoIndex][field] = value;
          if (field === 'produto_id') {
            kits[kitIndex].produtos[produtoIndex]['produto_nome'] = label;
          }
          return { kits };
        });
    };

    handleDosagemChange = (kitIndex, produtoIndex, event) => {
        const value = event.target.value;
        this.setState((prevState) => {
            const kits = [...prevState.kits];
            kits[kitIndex].produtos[produtoIndex].dosagem = value;
            return { kits };
        });
    };  

    handleChangeDosagemTipo = (kitIndex, produtoIndex, e) => {
        const novoValor = e.target.value;
        this.setState(prevState => {
            const kits = [...prevState.kits];
            kits[kitIndex].produtos = [...kits[kitIndex].produtos];
            kits[kitIndex].produtos[produtoIndex] = {
                ...kits[kitIndex].produtos[produtoIndex],
                dosagem_tipo: novoValor
            };
            return { kits };
        });
    };

    adicionarProdutoKit(kitIndex) {
        const kits = [...this.state.kits];
        kits[kitIndex].produtos.push({ produto_id: '', dosagem: '' });
        this.setState({ kits });
    }

    async removerProdutoKit(kitIndex, produtoIndex) {
        const produto = this.state.kits[kitIndex].produtos[produtoIndex];
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover produto?',
            text: "Tem certeza que deseja remover este produto?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                if (produto.id) {
                    try {
                        await api.delete(`/programas/kits/produtos/${produto.id}/`);
                    } catch (error) {
                        MySwal.fire('Erro', 'Erro ao remover produto, tente novamente.', 'error');
                        return;
                    }
                }
                const kits = [...this.state.kits];
                kits[kitIndex].produtos.splice(produtoIndex, 1);
                this.setState({ kits });
                MySwal.fire('Removido!', 'Produto removido com sucesso.', 'success');
            }
        });
    }

    handleHabilitarEnvioKitChange(value) {
        this.setState({ habilitar_envio_kit: value }, () => {
    
            const formData = new FormData();
            formData.append('habilitar_envio_kit_paciente', this.state.habilitar_envio_kit);
    
            const url = `/programas/${this.state.programa_id}/`;
            const metodo = 'put';
        
            api({
                method: metodo,
                url: url,
                data: formData,
            })
            .then(response => {
                const situacao = response.data.habilitar_envio_kit_paciente;
                let text_msg = situacao ? 'Habilitar envio de kit para paciente com sucesso.' : 'Desabilitar envio de kit para paciente com sucesso.';

                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    title: 'Sucesso!', 
                    text: text_msg,
                    icon: 'success',
                    showCloseButton: true,
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao remover o serviço, tente novamente';            
    
                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento';
                }
                else if(error.response && error.response.status === 400){
                    const campos = error.response.data;       
                    
                }
    
                const MySwal = withReactContent(Swal)
                MySwal.fire({
                    icon: 'error',
                    showCloseButton: true,
                    title: <p>{erro_msg}</p>,
                })
            });
        });
    }
  
    enviaPrograma = (e) => {
        e.preventDefault();

        const formData = new FormData();

        this.setState({
            loading: true,
            imagemHelper: "",
            imagemBrancaHelper: "",
            logomarca1Helper: "",
            logomarca2Helper: "",
            nomeHelper: "",
            welcomeKitHelper: "",
            termoPacientePDFHelper: "",
            tipoFaturamentoHelper: "",
            clienteIdHelper: "",
            categoriaHelper: "",
            tipoHelper: "",
            optoutHelper: "",
            telefoneHelper: "",
            descricaopHelper: "",
            contatoNomeHelper: "",
            bucketS3Helper: "",
            contatoCelularHelper: "",
            contatoEmailHelper: '',
        });

        //vererifica se é edição ou adição
        const url = (this.state.programa_id) ? '/programas/'+this.state.programa_id+'/' : '/programas/'
        const metodo = (this.state.programa_id) ? 'put' : 'post'

        if (this.state.imagem_branca_upload) {
            formData.append('imagem_branca', this.state.imagem_branca_upload);
        }
        if (this.state.imagem_upload) {
            formData.append('imagem', this.state.imagem_upload);
        }
        if (this.state.optout_logomarca_1 instanceof File) {
            formData.append('optout_logomarca_1', this.state.optout_logomarca_1);
        }
        if (this.state.optout_logomarca_2 instanceof File) {
            formData.append('optout_logomarca_2', this.state.optout_logomarca_2);
        }
        if (this.state.welcome_kit_upload) {
            formData.append('welcome_kit', this.state.welcome_kit_upload);
        }
        if (this.state.termo_paciente_pdf_upload) {
            formData.append('termo_paciente_pdf', this.state.termo_paciente_pdf_upload);
        }

        if (this.state.declaracao_indicacao_upload) {
            formData.append('declaracao_indicacao', this.state.declaracao_indicacao_upload);
        }

        if (this.state.regulamento_programa_upload) {
            formData.append('regulamento_programa', this.state.regulamento_programa_upload);
        }
        if (this.state.aviso_privacidade_upload) {
            formData.append('aviso_privacidade', this.state.aviso_privacidade_upload);
        }
        if (this.state.politica_cookies_upload) {
            formData.append('politica_cookies', this.state.politica_cookies_upload);
        }
        if (this.state.termos_programa_medicos_upload) {
            formData.append('termos_programa_medicos', this.state.termos_programa_medicos_upload);
        }

        formData.append('nome', this.state.nome);
        formData.append('descricao', this.state.descricao);
        formData.append('telefone', this.state.telefone);
        formData.append('cliente_id', this.state.cliente_id);
        formData.append('bucketS3_nome', this.state.bucketS3_nome);

        if(this.state.grupo_cadastro_medico_id) {
            formData.append('grupo_cadastro_medico_id', this.state.grupo_cadastro_medico_id);
        }

        if(this.state.tipo_id) {
            formData.append('tipo_id', this.state.tipo_id);
        }
        
        if(this.state.termo_id) {
            formData.append('termo_id', this.state.termo_id);
        }

        if(this.state.termo_prestador_id) {
            formData.append('termo_prestador_id', this.state.termo_prestador_id);
        }

        if(this.state.farmacovigilancia_formulario_id) {
            formData.append('farmacovigilancia_formulario_id', this.state.farmacovigilancia_formulario_id);
        }
        if (this.state.template_atendimento_receptivo) {
            formData.append('template_atendimento_receptivo', this.state.template_atendimento_receptivo);
        }
        if (this.state.template_mensageria_aniversario) {
            formData.append('template_mensageria_aniversario', this.state.template_mensageria_aniversario);
        }

        if (this.state.template_mensagem_whatsapp) {
            formData.append('template_mensagem_whatsapp', this.state.template_mensagem_whatsapp);
        }

        //vai sempre: enviar so quando preenchido impediria limpar e voltar a notificar só por e-mail
        formData.append('termos_template_whatsapp_prestador', this.state.termos_template_whatsapp_prestador || '');

        formData.append('categoria', this.state.categoria);
        formData.append('optout_status_id', this.state.optout_status_id);
        formData.append('contato_nome', this.state.contato_nome);
        formData.append('contato_celular', this.state.contato_celular);
        formData.append('contato_email', this.state.contato_email);
        formData.append('status', this.state.status);
        formData.append('permite_menor_idade', this.state.permite_menor_idade);
        formData.append('permite_atendimento_extra_com_aprovacao', this.state.permite_atendimento_extra_com_aprovacao);    
        formData.append('medico_cadastro', this.state.medico_cadastro);      
        formData.append('laboratorio_cadastro', this.state.laboratorio_cadastro);       
        formData.append('habilitar_agendamentos_servicos', this.state.habilitar_agendamentos_servicos);    
        formData.append('habilitar_gestao_produtos', this.state.habilitar_gestao_produtos);    
        formData.append('habilitar_exames', this.state.habilitar_exames);
        formData.append('habilitar_selecionar_multiplos_exames', this.state.habilitar_selecionar_multiplos_exames);
        formData.append('habilitar_vinculo_atendente', this.state.habilitar_vinculo_atendente);      
        formData.append('habilitar_escolha_laboratorio', this.state.habilitar_escolha_laboratorio);     
        formData.append('habilitar_escolha_multiprofissional', this.state.habilitar_escolha_multiprofissional);         
        formData.append('habilitar_optin_telefone', this.state.habilitar_optin_telefone);                
        formData.append('habilitar_gestao_aplicacoes', this.state.habilitar_gestao_aplicacoes);         
        formData.append('habilitar_pre_cadastro_basico', this.state.habilitar_pre_cadastro_basico);
        formData.append('endereco_paciente_obrigatorio', this.state.endereco_paciente_obrigatorio);           
        formData.append('habilitar_registro_compras', this.state.habilitar_registro_compras);         
        formData.append('habilitar_registro_dosagens', this.state.habilitar_registro_dosagens);               
        formData.append('ocultar_menu_atendimentos', this.state.ocultar_menu_atendimentos);        
        formData.append('habilitar_validacao_atendimento', this.state.habilitar_validacao_atendimento); 
        formData.append('habilitar_mensageria_aniversario', this.state.habilitar_mensageria_aniversario);         
        formData.append('ocultar_menu_receptivos', this.state.ocultar_menu_receptivos);        
        formData.append('ocultar_menu_prestadores', this.state.ocultar_menu_prestadores);        
        formData.append('ocultar_nome_local', this.state.ocultar_nome_local);        
        formData.append('habilitar_geolocalizacao_laboratorios', this.state.habilitar_geolocalizacao_laboratorios);        
        formData.append('exige_cpf_atendimento', this.state.exige_cpf_atendimento);        
        formData.append('permite_reativar_atendimento', this.state.permite_reativar_atendimento);    
        formData.append('exige_aceite_termo_opt_in_medicos', this.state.exige_aceite_termo_opt_in_medicos);
        formData.append('habilitar_indicacao_profissional', this.state.habilitar_indicacao_profissional);
        //enviar JSON inválido apagaria o mapeamento do PDF: só vai o que dá para ler
        if (this.state.declaracao_indicacao_marcacoes.trim()) {
            try {
                formData.append('declaracao_indicacao_marcacoes',
                    JSON.stringify(JSON.parse(this.state.declaracao_indicacao_marcacoes)));
            } catch (erro) {
                console.error('Marcações da declaração em formato inválido:', erro);
            }
        }    
        formData.append('optout_habilitado', this.state.optout_habilitado);        
        formData.append('layout_cor_fundo', this.state.layout_cor_fundo);  
        formData.append('layout_cor_primaria', this.state.layout_cor_primaria);  
        formData.append('layout_cor_secundaria', this.state.layout_cor_secundaria);  
        formData.append('label_botao_atendimento', this.state.label_botao_atendimento);   
        formData.append('label_endereco_paciente', this.state.label_endereco_paciente);    
        formData.append('canais_contato', this.state.canais_contato);    
        formData.append('nome_equipe', this.state.nome_equipe);    
        formData.append('orientacao_cadastro', this.state.orientacao_cadastro);    
        formData.append('instrucoes_paciente_termo', this.state.instrucoes_paciente_termo);    
        formData.append('instrucoes2_paciente_termo', this.state.instrucoes2_paciente_termo);  
        formData.append('dicas_texto', this.state.dicas_texto);            
        formData.append('instrucao_atendimento', this.state.instrucao_atendimento);    
        formData.append('informacoes_receptivo', this.state.informacoes_receptivo);       
        formData.append('optout_titulo', this.state.optout_titulo);       
        formData.append('optout_texto', this.state.optout_texto);       
        formData.append('link_politica_programa', this.state.link_politica_programa);    
        formData.append('link_regulamento_programa', this.state.link_regulamento_programa);  

        formData.append('habilitar_tipos_agendamento ', this.state.habilitar_tipos_agendamento);  
        formData.append('agendamento_email_solicitacao_prestador', this.state.agendamento_email_solicitacao_prestador);  
        formData.append('solicitacao_aceite_termo_opt_in_medicos', this.state.solicitacao_aceite_termo_opt_in_medicos);  
        formData.append('envio_email_credenciais_de_acesso_medicos', this.state.envio_email_credenciais_de_acesso_medicos);  
        formData.append('agendamento_email_atualizacao_status', this.state.agendamento_email_atualizacao_status);  
        formData.append('limite_atendimentos_por_cpf', this.state.limite_atendimentos_por_cpf);  
        formData.append('aviso_limite_atendimentos', this.state.aviso_limite_atendimentos);  


        formData.append('tipo_faturamento', this.state.tipo_faturamento);
        if (this.state.tipo_cadastro_medico) {
            formData.append('tipo_cadastro_medico', this.state.tipo_cadastro_medico);
        }

        //formData.append('configuracoes', JSON.stringify(this.state.configuracoes));
        formData.append('documentacao_configuracoes', this.state.documentacao_configuracoes);

        if(this.state.medico_novo_modelo_mensagem_id) {
            formData.append('medico_novo_modelo_mensagem_id', this.state.medico_novo_modelo_mensagem_id);  
        }
        
        if(this.state.medico_existente_modelo_mensagem_id) {
            formData.append('medico_existente_modelo_mensagem_id ', this.state.medico_existente_modelo_mensagem_id);  
        }
        
        formData.append('versao', this.state.versao);    

        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.programa_id) ? 'Programa atualizado com sucesso' : 'Programa cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            if(!this.state.programa_id){
                this.props.router.navigate("/programas");
            } else {
                this.carregarDadosPrograma();
            }
        })
        .catch(error => {
            let erro_msg = "Erro ao realizar o cadastro:<br />";      

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const responseData = error.response.data;
                const campos = responseData.erros ? responseData.erros : responseData;                         
                
                for (let key in campos){
                    var value = campos[key];

                    erro_msg += "<br />" + key + ": " + value;

                    if(key === 'nome'){
                        this.setState({ nomeHelper: value })
                    }
                    if(key === 'descricao'){
                        this.setState({ descricaopHelper: value })
                    }
                    if(key === 'bucketS3_nome'){
                        this.setState({ bucketS3Helper: value })
                    }
                    if(key === 'telefone'){
                        this.setState({ telefoneHelper: value })
                    }
                    if(key === 'imagem'){
                        this.setState({ imagemHelper: value })
                    }
                    if(key === 'imagem_branca'){
                        this.setState({ imagemBrancaHelper: value })
                    }
                    if(key === 'optout_logomarca_1'){
                        this.setState({ logomarca1Helper: value })
                    }
                    if(key === 'optout_logomarca_2'){
                        this.setState({ logomarca2Helper: value })
                    }
                    if(key === 'welcome_kit'){
                        this.setState({ welcomeKitHelper: value })
                    }
                    if(key === 'termo_paciente_pdf'){
                        this.setState({ termoPacientePDFHelper: value })
                    }
                    if(key === 'cliente_id'){
                        this.setState({ clienteIdHelper: value })
                    }
                    if(key === 'termo_id'){
                        this.setState({ termoIdHelper: value })
                    }
                    if(key === 'tipo_id'){
                        this.setState({ tipoHelper: value })
                    }
                    if(key === 'categoria'){
                        this.setState({ categoriaHelper: value })
                    }
                    if(key === 'optout_status_id'){
                        this.setState({ optoutHelper: value })
                    }
                    if(key === 'contato_nome'){
                        this.setState({ contatoNomeHelper: value })
                    }
                    if(key === 'contato_celular'){
                        this.setState({ contatoCelularHelper: value })
                    }
                    if(key === 'contato_email'){
                        this.setState({ contatoEmailHelper: value })
                    }
                    if(key === 'status'){
                        this.setState({ statusHelper: value })
                    }
                    if(key === 'tipo_faturamento'){
                        this.setState({ tipoFaturamentoHelper: value })
                    }                    
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: "Atenção!",
                html: erro_msg,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    //ETAPAS DO PROGRAMA
    carregarEtapas = async () => {
        if (this.state.programa_id) {
            await this.handleSelectTab("statusDoPrograma");
            await api.get(`/programas/etapas/?programa_id=${this.state.programa_id}&status=1`)
                .then(response => {                    
                    const etapasCarregadas = response.data.results.map(etapa => ({
                        id: etapa.id,
                        nome: etapa.nome,
                        descricao: etapa.descricao,
                        dias_proxima_etapa: etapa.dias_proxima_etapa,
                        formulario_id: etapa.formulario_id,
                        formulario_nome: etapa.dados_formulario.nome,
                        formulario_pesquisa_id: etapa.formulario_pesquisa_id,
                        formulario_pesquisa_nome: etapa.dados_formulario_pesquisa.nome,
                        responsavel_etapa: etapa.responsavel_etapa,
                        titulo_sucesso_finalizacao: etapa.titulo_sucesso_finalizacao,
                        mensagem_sucesso_finalizacao: etapa.mensagem_sucesso_finalizacao,
                        ocultar_etapa: etapa.ocultar_etapa ? etapa.ocultar_etapa.split(',') : [],
                        ordem: etapa.ordem,
                        midias_contato: etapa.midias_contato ? etapa.midias_contato.split(',') : [],
                        alerta_navegador: etapa.alerta_navegador,
                        conteudo_mensagem: etapa.conteudo_mensagem,
                        conteudo_mensagem_email: etapa.conteudo_mensagem_email,
                        tipo_envio: etapa.tipo_envio,
                        whatsapp_template: etapa.whatsapp_template,
                        momento_envio: etapa.momento_envio,
                        etapa_termo: etapa.etapa_termo,
                        etapa_pesquisa: etapa.etapa_pesquisa,
                        etapa_pesquisa_id: etapa.etapa_pesquisa ? etapa.etapa_pesquisa_id : null,
                        acao_navegador_apos_prazo : etapa.acao_navegador_apos_prazo,
                        avancar_etapa_automaticamente : etapa.avancar_etapa_automaticamente,
                        prazo_acao_navegador : etapa.prazo_acao_navegador,
                        dias_envio_mensageria : etapa.dias_envio_mensageria,
                        envia_mensageria_cron : etapa.envia_mensageria_cron,
                        etapa_nota_fiscal: etapa.etapa_nota_fiscal,
                        etapa_tipo_paciente: etapa.etapa_tipo_paciente,
                        destinatario_mensagem: etapa.destinatario_mensagem,
                        status_finalizacao_etapa_id: etapa.status_finalizacao_etapa_id,
                        // cancelamento
                        cancelamento_whatsapp_template: etapa.cancelamento_whatsapp_template,
                        cancelamento_titulo_email: etapa.cancelamento_titulo_email,
                        cancelamento_conteudo_mensagem: etapa.cancelamento_conteudo_mensagem,
                        cancelamento_conteudo_mensagem_email: etapa.cancelamento_conteudo_mensagem_email,
                        cancelamento_destinatario_mensagem: etapa.cancelamento_destinatario_mensagem,
                        // retorno
                        cancelamento_retorno_whatsapp_template: etapa.cancelamento_retorno_whatsapp_template,
                        cancelamento_retorno_titulo_email: etapa.cancelamento_retorno_titulo_email,
                        cancelamento_retorno_conteudo_mensagem: etapa.cancelamento_retorno_conteudo_mensagem,
                        cancelamento_retorno_conteudo_mensagem_email: etapa.cancelamento_retorno_conteudo_mensagem_email,
                        cancelamento_retorno_destinatario_mensagem: etapa.cancelamento_retorno_destinatario_mensagem,
                        // acoes
                        criar_acao_atendimento: etapa.criar_acao_atendimento,
                        acao_id: etapa.acao_id,
                        acao_nome: etapa.dados_acao.nome,
                        acao_texto: etapa.acao_texto,
                        // servicos
                        opcoesServicos: [],
                        servicos_relacionados_bool: etapa.servicos_relacionados,
                        servico_obrigatorio: etapa.servico_obrigatorio,
                        servico_fixo: etapa.servico_fixo,
                        servicos_procedimentos: etapa.dados_servicos_relacionados.map(servico => ({
                            value: servico.servico_procedimento_id,
                            label: servico.servico_procedimento__nome,
                        })),
                        configuracoes: etapa.configuracoes ? JSON.stringify(etapa.configuracoes, null, 4) : '[]',
                    }));
                    this.setState({ etapas: etapasCarregadas });
                })
                .catch(error => {
                    console.error('Erro ao carregar etapas:', error);
                    
                    let erro_msg = 'Erro ao carregar etapas do programa, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    salvarEtapa = (index) => {
        const etapa = this.state.etapas[index];
        const url = etapa.id ? `/programas/etapas/${etapa.id}/` : '/programas/etapas/';
        const metodo = etapa.id ? 'put' : 'post';

        const midiasContatoString = etapa.midias_contato.join(',');
        const ocultarEtapaString = (etapa.ocultar_etapa.length > 0) ? etapa.ocultar_etapa.join(',') : '';
        let servicos_ids = [];

        if(etapa.servicos_procedimentos){
            servicos_ids = etapa.servicos_procedimentos.map(item => item['value']);
        }
    
        const dadosEtapa = {
            nome: etapa.nome,
            descricao: etapa.descricao,
            dias_proxima_etapa: etapa.dias_proxima_etapa,
            ordem: index + 1, // A ordem pode ser o índice da etapa + 1
            programa_id: this.state.programa_id,
            formulario_id: etapa.formulario_id,
            servicos_relacionados: etapa.servicos_relacionados_bool,
            servico_obrigatorio: etapa.servico_obrigatorio,
            servico_fixo: etapa.servico_fixo,
            servicos_procedimentos: servicos_ids,
        };

        if(etapa.alerta_navegador) {
            dadosEtapa['alerta_navegador'] = etapa.alerta_navegador;
        }

        if (etapa.configuracoes) {
            dadosEtapa['configuracoes'] = JSON.parse(etapa.configuracoes);
        } else {
            dadosEtapa['configuracoes'] = [];
        }

        if(etapa.formulario_pesquisa_id) {
            dadosEtapa['formulario_pesquisa_id'] = etapa.formulario_pesquisa_id;
        }

        if(etapa.conteudo_mensagem) {
            dadosEtapa['conteudo_mensagem'] = etapa.conteudo_mensagem; 
        } else {
            dadosEtapa['conteudo_mensagem'] = "";
        }
        if(etapa.conteudo_mensagem_email) {
            dadosEtapa['conteudo_mensagem_email'] = etapa.conteudo_mensagem_email; 
        } else {
            dadosEtapa['conteudo_mensagem_email'] = "";
        }
        if(etapa.tipo_envio) {
            dadosEtapa['tipo_envio'] = etapa.tipo_envio; 
        } else {
            dadosEtapa['tipo_envio'] = "";
        }
        if(etapa.whatsapp_template) {
            dadosEtapa['whatsapp_template'] = etapa.whatsapp_template; 
        } else {
            //dadosEtapa['whatsapp_template'] = "";
        }
        if(etapa.momento_envio) {
            dadosEtapa['momento_envio'] = etapa.momento_envio; 
        } else {
            dadosEtapa['momento_envio'] = "inicio";
        }
        if(etapa.etapa_termo) {
            dadosEtapa['etapa_termo'] = etapa.etapa_termo; 
        } else {
            dadosEtapa['etapa_termo'] = 0;
        }
        if(etapa.etapa_pesquisa_id) {
            dadosEtapa['etapa_pesquisa_id'] = etapa.etapa_pesquisa_id; 
        } else {
            dadosEtapa['etapa_pesquisa_id'] = null;
        }
        if(etapa.acao_navegador_apos_prazo ) {
            dadosEtapa['acao_navegador_apos_prazo'] = etapa.acao_navegador_apos_prazo; 
        } else {
            dadosEtapa['acao_navegador_apos_prazo'] = 0;
        }
        if(etapa.avancar_etapa_automaticamente ) {
            dadosEtapa['avancar_etapa_automaticamente'] = etapa.avancar_etapa_automaticamente; 
        } else {
            dadosEtapa['avancar_etapa_automaticamente'] = 0;
        }
        if(etapa.prazo_acao_navegador ) {
            dadosEtapa['prazo_acao_navegador'] = etapa.prazo_acao_navegador; 
        } else {
            dadosEtapa['prazo_acao_navegador'] = 0;
        }
        if(etapa.dias_envio_mensageria ) {
            dadosEtapa['dias_envio_mensageria'] = etapa.dias_envio_mensageria; 
        } else {
            dadosEtapa['dias_envio_mensageria'] = 0;
        }
        if(etapa.envia_mensageria_cron ) {
            dadosEtapa['envia_mensageria_cron'] = etapa.envia_mensageria_cron; 
        } else {
            dadosEtapa['envia_mensageria_cron'] = 0;
        }
        if(etapa.status_finalizacao_etapa_id) {
            dadosEtapa['status_finalizacao_etapa_id'] = etapa.status_finalizacao_etapa_id; 
        } else {
            dadosEtapa['status_finalizacao_etapa_id'] = null; 
        }
        if(etapa.etapa_nota_fiscal) {
            dadosEtapa['etapa_nota_fiscal'] = etapa.etapa_nota_fiscal; 
        } else {
            dadosEtapa['etapa_nota_fiscal'] = 0;
        }
        if(etapa.etapa_tipo_paciente) {
            dadosEtapa['etapa_tipo_paciente'] = etapa.etapa_tipo_paciente; 
        } else {
            dadosEtapa['etapa_tipo_paciente'] = 0;
        }

        if(etapa.destinatario_mensagem) {
            dadosEtapa['destinatario_mensagem'] = etapa.destinatario_mensagem; 
        } else {
            dadosEtapa['destinatario_mensagem'] = "";
        }

        // cancelamento 
        if(etapa.cancelamento_whatsapp_template) {
            dadosEtapa['cancelamento_whatsapp_template'] = etapa.cancelamento_whatsapp_template; 
        } else {
            dadosEtapa['cancelamento_whatsapp_template'] = "";
        }
        if(etapa.cancelamento_titulo_email) {
            dadosEtapa['cancelamento_titulo_email'] = etapa.cancelamento_titulo_email; 
        } else {
            dadosEtapa['cancelamento_titulo_email'] = "";
        }
        if(etapa.cancelamento_conteudo_mensagem) {
            dadosEtapa['cancelamento_conteudo_mensagem'] = etapa.cancelamento_conteudo_mensagem; 
        } else {
            dadosEtapa['cancelamento_conteudo_mensagem'] = "";
        }
        if(etapa.cancelamento_conteudo_mensagem_email) {
            dadosEtapa['cancelamento_conteudo_mensagem_email'] = etapa.cancelamento_conteudo_mensagem_email; 
        } else {
            dadosEtapa['cancelamento_conteudo_mensagem_email'] = "";
        }
        if(etapa.cancelamento_destinatario_mensagem) {
            dadosEtapa['cancelamento_destinatario_mensagem'] = etapa.cancelamento_destinatario_mensagem; 
        } else {
            dadosEtapa['cancelamento_destinatario_mensagem'] = "";
        }
        // retorno
        if(etapa.cancelamento_retorno_whatsapp_template) {
            dadosEtapa['cancelamento_retorno_whatsapp_template'] = etapa.cancelamento_retorno_whatsapp_template; 
        } else {
            dadosEtapa['cancelamento_retorno_whatsapp_template'] = "";
        }
        if(etapa.cancelamento_retorno_titulo_email) {
            dadosEtapa['cancelamento_retorno_titulo_email'] = etapa.cancelamento_retorno_titulo_email; 
        } else {
            dadosEtapa['cancelamento_retorno_titulo_email'] = "";
        }
        if(etapa.cancelamento_retorno_conteudo_mensagem) {
            dadosEtapa['cancelamento_retorno_conteudo_mensagem'] = etapa.cancelamento_retorno_conteudo_mensagem; 
        } else {
            dadosEtapa['cancelamento_retorno_conteudo_mensagem'] = "";
        }
        if(etapa.cancelamento_retorno_conteudo_mensagem_email) {
            dadosEtapa['cancelamento_retorno_conteudo_mensagem_email'] = etapa.cancelamento_retorno_conteudo_mensagem_email; 
        } else {
            dadosEtapa['cancelamento_retorno_conteudo_mensagem_email'] = "";
        }
        if(etapa.cancelamento_retorno_destinatario_mensagem) {
            dadosEtapa['cancelamento_retorno_destinatario_mensagem'] = etapa.cancelamento_retorno_destinatario_mensagem; 
        } else {
            dadosEtapa['cancelamento_retorno_destinatario_mensagem'] = "";
        }
        // acoes
        if(etapa.criar_acao_atendimento) {
            dadosEtapa['criar_acao_atendimento'] = etapa.criar_acao_atendimento; 
        } else {
            dadosEtapa['criar_acao_atendimento'] = false;
        }
        if(etapa.acao_id) {
            dadosEtapa['acao_id'] = etapa.acao_id; 
        } else {
            dadosEtapa['acao_id'] = null;
        }
        if(etapa.acao_texto) {
            dadosEtapa['acao_texto'] = etapa.acao_texto; 
        } else {
            dadosEtapa['acao_texto'] = "";
        }
        if(midiasContatoString) {
            dadosEtapa['midias_contato'] = midiasContatoString; 
        } else {
            dadosEtapa['midias_contato'] = "";
        }

        if(etapa.responsavel_etapa) {
            dadosEtapa['responsavel_etapa'] = etapa.responsavel_etapa;
        }

        if(etapa.titulo_sucesso_finalizacao) {
            dadosEtapa['titulo_sucesso_finalizacao'] = etapa.titulo_sucesso_finalizacao;
        }

        if(etapa.mensagem_sucesso_finalizacao) {
            dadosEtapa['mensagem_sucesso_finalizacao'] = etapa.mensagem_sucesso_finalizacao;
        }

        if(ocultarEtapaString) {
            dadosEtapa['ocultar_etapa'] = ocultarEtapaString; 
        }

        api({
            method: metodo,
            url: url,
            data: dadosEtapa,
        })
        .then(response => {
            // Se for uma nova etapa, atualize o estado com a ID retornada pela API
            if (!etapa.id) {
                this.setState(prevState => {
                    const etapasAtualizadas = [...prevState.etapas];
                    etapasAtualizadas[index].id = response.data.id;
                    return { etapas: etapasAtualizadas };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (etapa.id) ? 'Etapa atualizada com sucesso' : 'Etapa cadastrada com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar a etapa, verifique os campos e tente novamente';           
            let content = ''; 

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;       
                

                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'nome') {
                        content += `<br>&bull; Nome: ${value}`;
                    }
                    if(key == 'descricao') {
                        content += `<br>&bull; Descrição: ${value}`;
                    }
                    if(key == 'dias_proxima_etapa') {
                        content += `<br>&bull; Dias para Próxima Etapa: ${value}`;
                    }
                    if(key == 'formulario_id') {
                        content += `<br>&bull; Formulário: ${value}`;
                    }
                    if(key == 'alerta_navegador') {
                        content += `<br>&bull; Alerta Navegador: ${value}`;
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content
            })
        });
    };

    adicionarEtapa = () => {
        this.setState(prevState => ({
            etapas: [...prevState.etapas, { nome: '', dias_proxima_etapa: '', formulario_id: '', formulario_nome: '', descricao: '', responsavel_etapa: '', ocultar_etapa: [], midias_contato: [], tipo_mensagem: [], etapa_termo: '', acao_navegador_apos_prazo: '', avancar_etapa_automaticamente: '' , prazo_acao_navegador: '', dias_envio_mensageria: '', etapa_nota_fiscal: '', momento_envio: '', whatsapp_template: '', tipo_envio: '', conteudo_mensagem: '', conteudo_mensagem_email: '', destinatario_mensagem: '', titulo_sucesso_finalizacao: '', mensagem_sucesso_finalizacao: '', cancelamento_whatsapp_template: '', cancelamento_titulo_email: '', cancelamento_conteudo_mensagem: '', cancelamento_conteudo_mensagem_email: '', cancelamento_destinatario_mensagem: '', cancelamento_retorno_whatsapp_template: '', cancelamento_retorno_titulo_email: '', cancelamento_retorno_conteudo_mensagem: '', cancelamento_retorno_conteudo_mensagem_email: '', cancelamento_retorno_destinatario_mensagem: '', etapa_tipo_paciente: '', alerta_navegador: '', status_finalizacao_etapa_id: '', envia_mensageria_cron: '', criar_acao_atendimento: false, acao_id: '', acao_nome: '', acao_texto: '' }],
        }));
    };

    removerEtapa = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover etapa?',
            text: "Tem certeza que deseja remover esta etapa?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const etapa = this.state.etapas[index];

                if (etapa.id) {

                    const url = `/programas/etapas/${etapa.id}/`;
                    const metodo = 'put';
                
                    const dadosEtapa = {
                        status: false
                    };
                
                    api({
                        method: metodo,
                        url: url,
                        data: dadosEtapa,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Etapa removida com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            etapas: prevState.etapas.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover a etapa, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        etapas: prevState.etapas.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'A etapa foi removida.',
                        'success'
                    );
                }
            }
        });
    };

    handleEtapaChange = (index, event, fieldName) => {
        const etapas = [...this.state.etapas];
        if (fieldName === 'acao_id') {
            etapas[index] = { ...etapas[index], acao_id: event.value, acao_nome: event.label };
        } else if (fieldName === 'formulario_id') {
            etapas[index] = { ...etapas[index], formulario_id: event.value, formulario_nome: event.label };
        } 
        else if (fieldName === 'formulario_pesquisa_id') {
            etapas[index] = { ...etapas[index], formulario_pesquisa_id: event.value, formulario_pesquisa_nome: event.label };
        } 
        else if(fieldName === 'responsavel_etapa' || fieldName === 'ocultar_etapa' || fieldName === 'etapa_pesquisa_id') {
            etapas[index] = { ...etapas[index], [fieldName]: event.value }; 
        }  
        else if (fieldName == 'criar_acao_atendimento' || fieldName === 'etapa_tipo_paciente' || fieldName === 'etapa_termo' || fieldName === 'etapa_nota_fiscal' || fieldName === 'etapa_pesquisa') {
            etapas[index] = { ...etapas[index], [fieldName]: event.target.value === "1" }; 
        }
        else {
            const { name, value } = event.target;
            etapas[index] = { ...etapas[index], [name]: value };
        }
        this.setState({ etapas });
    };

    handleFocusEtapaServicos = async (index) => {
        const updatedEtapas = [...this.state.etapas];

        // Atualiza a flag isServicosFocused para a etapa correspondente
        updatedEtapas[index].isServicosFocused = true;

        // Carrega as opções apenas ao focar, se ainda não foram carregadas
        if (updatedEtapas[index].opcoesServicos.length === 0) {
            const opcoes = await this.buscaServicosProcedimentos('', index);
            updatedEtapas[index].opcoesServicos = opcoes;
        }

        this.setState({ etapas: updatedEtapas });
    };

    handleSimNaoChange = (index, fieldName, event) => {
        const etapas = [...this.state.etapas];
        const { value } = event.target;
        
        etapas[index] = { 
            ...etapas[index], 
            [fieldName]: value === "1" 
        };
    
        this.setState({ etapas });
    };

    handleEtapaChangeCheck = (isChecked, index, fieldName) => {
        const etapas = [...this.state.etapas];

        etapas[index] = { ...etapas[index], [fieldName]: isChecked };       
        
        this.setState({ etapas });
    };
    

    handleMidiasContatoChange = (midia, isChecked, etapaIndex) => {
        const etapas = [...this.state.etapas];
        let midiasContatoSet = new Set(etapas[etapaIndex].midias_contato);
    
        if (isChecked) {
            midiasContatoSet.add(midia);
        } else {
            midiasContatoSet.delete(midia);
        }
    
        etapas[etapaIndex].midias_contato = Array.from(midiasContatoSet);
        this.setState({ etapas });
    };

    handleTiposMensagemChange = (tipo, etapaIndex) => {
        const etapas = [...this.state.etapas];
    
        etapas[etapaIndex].tipo_mensagem = tipo; 
    
        this.setState({ etapas });
    };


    handleOcultarEtapaChange = (categoria_user, isChecked, etapaIndex) => {
        const etapas = [...this.state.etapas];
        let ocultarEtapasSet = new Set(etapas[etapaIndex].ocultar_etapa);
    
        if (isChecked) {
            ocultarEtapasSet.add(categoria_user);
        } else {
            ocultarEtapasSet.delete(categoria_user);
        }
    
        etapas[etapaIndex].ocultar_etapa = Array.from(ocultarEtapasSet);
        this.setState({ etapas });
    };

    //handle

    onDragEndEtapas = (result) => {
        if (!result.destination) {
            return;
        }

        const sourceIndex = result.source.index;
        const destinationIndex = result.destination.index;

        if (sourceIndex === destinationIndex) {
            return;
        }

        const novasEtapas = Array.from(this.state.etapas);
        const [removed] = novasEtapas.splice(sourceIndex, 1);
        novasEtapas.splice(destinationIndex, 0, removed);

        novasEtapas.forEach((item, index) => {
            item.ordem = index + 1;
        });

        this.setState({ etapas: novasEtapas }, () => {
             // Opcional: Só salvar se a etapa tiver ID
            novasEtapas.forEach((etapa, index) => {
                if(etapa.id) {
                    this.salvarEtapa(index); // Salva cada etapa pra atualizar a ordem
                }
            });
        });
    };

    //PRODUTOS DO PROGRAMA
    carregarProdutosPrograma = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/produtos/?programa=${this.state.programa_id}&status=1`)
                .then(response => {
                    const produtosCarregados = response.data.results.map(produto => ({
                        id: produto.id,
                        valor: formatarValor(produto.valor),
                        produto_id: produto.produto_id,
                        produto_nome: produto.dados_produto.nome
                    }));
                    this.setState({ produtos: produtosCarregados });
                })
                .catch(error => {
                    console.error('Erro ao carregar produtos:', error);
                    
                    let erro_msg = 'Erro ao carregar produtos do programa, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    salvarProduto = (index) => {
        const produto = this.state.produtos[index];
        const url = produto.id ? `/programas/produtos/${produto.id}/` : '/programas/produtos/';
        const metodo = produto.id ? 'put' : 'post';
    
        const dadosProduto = {
            status: true,
            valor: formatarValorAPI(produto.valor),
            programa_id: this.state.programa_id,
            produto_id: produto.produto_id
        };
    
        api({
            method: metodo,
            url: url,
            data: dadosProduto,
        })
        .then(response => {
            // Se for um novo produto, atualize o estado com a ID retornada pela API
            if (!produto.id) {
                this.setState(prevState => {
                    const produtosAtualizados = [...prevState.produtos];
                    produtosAtualizados[index].id = response.data.id;
                    return { produtos: produtosAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (produto.id) ? 'Produto atualizado com sucesso' : 'Produto cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o produto, verifique os campos e tente novamente';         
            let content = '';   

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'produto_id') {
                        content += `<br>&bull; Produto: ${value}`;
                    }
                    if(key == 'valor') {
                        content += `<br>&bull; Valor: ${value}`;
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    };

    adicionarProduto = () => {
        this.setState(prevState => ({
            produtos: [...prevState.produtos, { valor: '', produto_id: '', produto_nome: '' }],
        }));
    };

    removerProduto = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover produto?',
            text: "Tem certeza que deseja remover este produto?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const produto = this.state.produtos[index];

                if (produto.id) {

                    const url = `/programas/produtos/${produto.id}/`;
                    const metodo = 'put';
                
                    const dadosProduto = {
                        status: false
                    };
                
                    api({
                        method: metodo,
                        url: url,
                        data: dadosProduto,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Produto removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            produtos: prevState.produtos.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o produto, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        produtos: prevState.produtos.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O produto foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    handleProdutoChange = (index, event, fieldName) => {
        const produtos = [...this.state.produtos];
        if (fieldName === 'produto_id') {
            produtos[index] = { ...produtos[index], produto_id: event.value, produto_nome: event.label, valor: event.valor };
        } else if(fieldName === 'valor') {
            const { value } = event.target;
            produtos[index] = { ...produtos[index], valor: formatarValor(value) };
        } else {
            const { name, value } = event.target;
            produtos[index] = { ...produtos[index], [name]: value };
        }
        this.setState({ produtos });
    };

    //status do programa
    carregarStatusAplicacao = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/aplicacoes-status/?programa_id=${this.state.programa_id}`)
                .then(response => {
                    const statusCarregado = response.data.results.map(status => ({
                        id: status.id,
                        nome: status.nome,
                        motivos_nao_realizacao: status.motivos_nao_realizacao
                    }));
                    this.setState({ status_aplicacao: statusCarregado });
                })
                .catch(error => {
                    console.error('Erro ao carregar status:', error);
                    
                    let erro_msg = 'Erro ao carregar status da aplicação, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    }

    carregarDosagens = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/dosagens/?programa_id=${this.state.programa_id}`)
                .then(response => {
                    const dosagensCarregadas = response.data.results.map(dosagem => ({
                        id: dosagem.id,
                        quantidade: dosagem.quantidade,
                        unidade: dosagem.unidade
                    }));
                    this.setState({ dosagens: dosagensCarregadas });
                })
                .catch(error => {
                    console.error('Erro ao carregar status:', error);
                    
                    let erro_msg = 'Erro ao carregar dosagens, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    }

    carregarOptOutMotivos = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/optout-motivos/?programa_id=${this.state.programa_id}`)
                .then(response => {
                    const optoutCarregado = response.data.results.map(optout => ({
                        id: optout.id,
                        titulo: optout.titulo,
                        ordem: optout.ordem
                    }));
                    this.setState({ motivos_optout: optoutCarregado });
                })
                .catch(error => {
                    console.error('Erro ao carregar optout:', error);
                    
                    let erro_msg = 'Erro ao carregar optout da aplicação, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    }

    //status do programa
    carregarStatusPrograma = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/status/?programa_id=${this.state.programa_id}`)
                .then(response => {
                    const statusCarregado = response.data.results.map(status => ({
                        id: status.id,
                        nome: status.nome,
                        slug: status.slug,
                        ativo: status.status,
                        menu_adicional_atendimento: status.menu_adicional_atendimento,
                        ordem: status.ordem,
                        template_whatsapp: status.template_whatsapp,
                        icon: status.icon,
                        cor: status.cor,
                        descricao: status.descricao,
                        orientacao: status.orientacao,
                        tipo: status.tipo,
                        icon: status.icon
                    }));
                    this.setState({ status_programa: statusCarregado });
                })
                .catch(error => {
                    console.error('Erro ao carregar status:', error);
                    
                    let erro_msg = 'Erro ao carregar status do programa, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    }

    carregarAcoesPrograma = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/acoes/?programa_id=${this.state.programa_id}`)
                .then(response => {
                    const acoesCarregado = response.data.results.map(acoes => ({
                        id: acoes.id,
                        nome: acoes.nome,
                        slug: acoes.slug,
                        ordem: acoes.ordem,
                    }));
                    this.setState({ acoes_programa: acoesCarregado });
                })
                .catch(error => {
                    console.error('Erro ao carregar ações:', error);
                    
                    let erro_msg = 'Erro ao carregar ações do programa, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    }


    //botoes do programa
    carregarBotoesPrograma = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/botoes/?programa_id=${this.state.programa_id}`)
                .then(response => {
                    const botoesCarregados = response.data.results.map(botao => ({
                        id: botao.id,
                        titulo: botao.titulo,
                        descricao: botao.descricao,
                        formulario_id: botao.formulario_id,
                        formulario_nome: botao.dados_formulario.nome,
                        callback_funcao: botao.callback_funcao,
                        tipo_usuario: botao.tipo_usuario,
                        envia_email: botao.envia_email,
                        email_enderecos: botao.email_enderecos,
                        email_titulo: botao.email_titulo,
                        email_conteudo: botao.email_conteudo,
                        exibir_botao_monitoria: botao.exibir_botao_monitoria,
                        exibir_aba: botao.exibir_aba
                    }));
                    this.setState({ botoes_atendimento: botoesCarregados });
                })
                .catch(error => {
                    console.error('Erro ao carregar botões:', error);
                    
                    let erro_msg = 'Erro ao carregar botões de atendimento, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    //DICAS DO PROGRAMA
    carregarDicasPrograma = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/dicas/?programa_id=${this.state.programa_id}`)
                .then(response => {
                    const dicasCarregadas = response.data.results.map(dica => ({
                        id: dica.id,
                        titulo: dica.titulo,
                        imagem: dica.imagem,
                        descricao: dica.descricao,
                        categoria: dica.categoria,
                    }));
                    this.setState({ dicas: dicasCarregadas });
                })
                .catch(error => {
                    console.error('Erro ao carregar dicas:', error);
                    
                    let erro_msg = 'Erro ao carregar dicas do programa, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    //GRAFICOS DO PROGRAMA
    carregarGraficosPrograma = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/graficos/?programa_id=${this.state.programa_id}`)
                .then(response => {
                    const graficosCarregadas = response.data.results.map(grafico => ({
                        id: grafico.id,
                        titulo_grafico: grafico.titulo_grafico,
                        categoria: grafico.categoria,
                    }));
                    this.setState({ graficos: graficosCarregadas });
                })
                .catch(error => {
                    console.error('Erro ao carregar graficos:', error);
                    
                    let erro_msg = 'Erro ao carregar gráficos do programa, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };


    //SERVIÇoS DO PROGRAMA
    carregarServicosPrograma = async () => {
        if (this.state.programa_id) {
            try {
                const response = await api.get(`/programas/servicos_procedimentos/?programa=${this.state.programa_id}&status=1&limit=200`);
    
                const estadosBrasileiros = [
                    { value: 'AC', label: 'Acre' },
                    { value: 'AL', label: 'Alagoas' },
                    { value: 'AM', label: 'Amazonas' },
                    { value: 'AP', label: 'Amapá' },
                    { value: 'BA', label: 'Bahia' },
                    { value: 'CE', label: 'Ceará' },
                    { value: 'DF', label: 'Distrito Federal' },
                    { value: 'ES', label: 'Espírito Santo' },
                    { value: 'GO', label: 'Goiás' },
                    { value: 'MA', label: 'Maranhão' },
                    { value: 'MT', label: 'Mato Grosso' },
                    { value: 'MS', label: 'Mato Grosso do Sul' },
                    { value: 'MG', label: 'Minas Gerais' },
                    { value: 'PA', label: 'Pará' },
                    { value: 'PB', label: 'Paraíba' },
                    { value: 'PR', label: 'Paraná' },
                    { value: 'PE', label: 'Pernambuco' },
                    { value: 'PI', label: 'Piauí' },
                    { value: 'RJ', label: 'Rio de Janeiro' },
                    { value: 'RN', label: 'Rio Grande do Norte' },
                    { value: 'RS', label: 'Rio Grande do Sul' },
                    { value: 'RO', label: 'Rondônia' },
                    { value: 'RR', label: 'Roraima' },
                    { value: 'SC', label: 'Santa Catarina' },
                    { value: 'SP', label: 'São Paulo' },
                    { value: 'SE', label: 'Sergipe' },
                    { value: 'TO', label: 'Tocantins' },
                ];
    
                const servicosCarregados = response.data.results.map(servico => {
                    const servicoComEstados = {
                        id: servico.id,
                        valor: formatarValor(servico.valor),

                        limite_por_cpf: servico.limite_por_cpf,

                        servico_procedimento_id: servico.servico_procedimento_id,
                        servico_procedimento_nome: servico.dados_servico.nome,
                        estados_register: servico.estados_list,
                        limite_observacao: servico.limite_observacao || '',
                        permite_ultrapassar_limite: servico.permite_ultrapassar_limite || false,
                        lembrete_dia_anterior: servico.lembrete_dia_anterior || false,
                        template_whatsapp_prestador: servico.template_whatsapp_prestador || '',
                        template_whatsapp_paciente: servico.template_whatsapp_paciente || '',
                        limite_reagendamentos: servico.limite_reagendamentos || '',
                        limite_periodo: servico.limite_periodo || '',
                    };
    
                    if (Array.isArray(servico.estados_list)) {
                        const estados_selecionados = servico.estados_list.reduce((acc, estadoRegistro) => {
                            // Encontra o estado correspondente ao 'uf' no array 'estadosBrasileiros'
                            const estado = estadosBrasileiros.find(est => est.value === estadoRegistro.uf);
                            if (estado) {
                                acc[estado.value] = estado.label;
                            }
                            return acc;
                        }, {});
    
                        servicoComEstados.estados_selecionados = estados_selecionados;
                    }
    
                    return servicoComEstados;
                });
    
                // Atualiza o estado com os dados carregados
                this.setState({ servicos: servicosCarregados });
    
            } catch (error) {
                console.error('Erro ao carregar serviços:', error);
    
                let erro_msg = 'Erro ao carregar serviços do programa, tente novamente';
    
                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }
    
                this.setState({
                    erroLoadRegistro: erro_msg,
                });
            }
        }
    };
    

    salvarServico = (index) => {
        const servico = this.state.servicos[index];
        const url = servico.id ? `/programas/servicos_procedimentos/${servico.id}/` : '/programas/servicos_procedimentos/';
        const metodo = servico.id ? 'put' : 'post';
    
        const dadosServico = {
            status: true,
            valor: (servico.valor) ? formatarValorAPI(servico.valor) : 0,

            limite_por_cpf: servico.limite_por_cpf,

            programa_id: this.state.programa_id,
            servico_procedimento_id: servico.servico_procedimento_id,
            limite_observacao: servico.limite_observacao || '',
            permite_ultrapassar_limite: servico.permite_ultrapassar_limite,
            lembrete_dia_anterior: servico.lembrete_dia_anterior,
            template_whatsapp_prestador: servico.template_whatsapp_prestador || '',
            template_whatsapp_paciente: servico.template_whatsapp_paciente || ''
        };

        if(servico.limite_reagendamentos) {
            dadosServico['limite_reagendamentos'] = servico.limite_reagendamentos;
        }

        if(servico.estados_register) {
            dadosServico['estados_register'] = servico.estados_register;
        }

        if(servico.limite_periodo) {
            dadosServico['limite_periodo'] = servico.limite_periodo;
        }

        api({
            method: metodo,
            url: url,
            data: dadosServico,
        })
        .then(response => {
            if (!servico.id) {
                this.setState(prevState => {
                    const servicosAtualizados = [...prevState.servicos];
                    servicosAtualizados[index].id = response.data.id;
                    return { servicos: servicosAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (servico.id) ? 'Serviço atualizado com sucesso' : 'Serviço cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o serviço, verifique os campos e tente novamente'; 
            let content = '';           

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'servico_procedimento_id') {
                        content += `<br>&bull; Serviço/Procedimento: ${value}`;
                    }
                    if(key == 'valor') {
                        content += `<br>&bull; Valor: ${value}`;
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
        
    }

    salvarStatusPrograma = (index) => {
        const status = this.state.status_programa[index];
        const url = status.id ? `/programas/status/${status.id}/` : '/programas/status/';
        const metodo = status.id ? 'put' : 'post';
    
        const dadosStatus = {
            nome: status.nome,
            slug: status.slug,
            status: status.ativo,
            menu_adicional_atendimento: status.menu_adicional_atendimento || '',
            ordem: status.ordem,
            template_whatsapp: status.template_whatsapp,
            cor: status.cor || "",
            icon: status.icon || "",
            descricao: status.descricao,
            orientacao: status.orientacao,
            tipo: status.tipo,
            icon: status.icon || "",
            programa_id: this.state.programa_id
        };

        api({
            method: metodo,
            url: url,
            data: dadosStatus,
        })
        .then(response => {
            // Se for um novo botao, atualize o estado com a ID retornada pela API
            if (!status.id) {
                this.setState(prevState => {
                    const statusAtualizados = [...prevState.status_programa];
                    statusAtualizados[index].id = response.data.id;
                    return { status_programa: statusAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (status.id) ? 'Status do programa atualizado com sucesso' : 'Status do programa cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o status, verifique os campos e tente novamente'; 
            let content = '';           

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'nome') {
                        content += `<br>&bull; Nome: ${value}`;
                    }
                    if(key == 'slug') {
                        content += `<br>&bull; Slug: ${value}`;
                    }
                    if(key == 'programa_id') {
                        content += `<br>&bull; Id do programa: ${value}`;
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
        
    }

    salvarOptOutPrograma = (index) => {
        const optout = this.state.motivos_optout[index];
        const url = optout.id ? `/programas/optout-motivos/${optout.id}/` : '/programas/optout-motivos/';
        const metodo = optout.id ? 'put' : 'post';
    
        const dadosOptOut = {
            titulo: optout.titulo,
            ordem: optout.ordem,
            programa_id: this.state.programa_id
        };

        api({
            method: metodo,
            url: url,
            data: dadosOptOut,
        })
        .then(response => {
            // Se for um novo botao, atualize o estado com a ID retornada pela API
            if (!optout.id) {
                this.setState(prevState => {
                    const optOutAtualizados = [...prevState.motivos_optout];
                    optOutAtualizados[index].id = response.data.id;
                    return { motivos_optout: optOutAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (optout.id) ? 'Optout do programa atualizado com sucesso' : 'Optout do programa cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar optout, verifique os campos e tente novamente'; 
            let content = '';           

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'titulo') {
                        content += `<br>&bull; Titulo: ${value}`;
                    }
                    if(key == 'ordem') {
                        content += `<br>&bull; Ordem: ${value}`;
                    }
                    if(key == 'programa_id') {
                        content += `<br>&bull; Id do Programa: ${value}`;
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
        
    }

    salvarAcoesPrograma = (index) => {
        const acoes = this.state.acoes_programa[index];
        const url = acoes.id ? `/programas/acoes/${acoes.id}/` : '/programas/acoes/';
        const metodo = acoes.id ? 'put' : 'post';
    
        const dadosOptOut = {
            nome: acoes.nome,
            ordem: acoes.ordem,
            slug: acoes.slug,
            programa_id: this.state.programa_id
        };

        api({
            method: metodo,
            url: url,
            data: dadosOptOut,
        })
        .then(response => {
            // Se for um novo botao, atualize o estado com a ID retornada pela API
            if (!acoes.id) {
                this.setState(prevState => {
                    const acoesAtualizados = [...prevState.acoes_programa];
                    acoesAtualizados[index].id = response.data.id;
                    return { acoes_programa: acoesAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (acoes.id) ? 'Ações do programa atualizado com sucesso' : 'Ações do programa cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar ações do programa, verifique os campos e tente novamente'; 
            let content = '';           

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'titulo') {
                        content += `<br>&bull; Titulo: ${value}`;
                    }
                    if(key == 'ordem') {
                        content += `<br>&bull; Ordem: ${value}`;
                    }
                    if(key == 'programa_id') {
                        content += `<br>&bull; Id do Programa: ${value}`;
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
        
    }

    salvarFiltroAtendimento = (filtro) => {
        const url = filtro.id ? `/programas/filtros-atendimentos/${filtro.id}/` : '/programas/filtros-atendimentos/';
        const metodo = filtro.id ? 'put' : 'post';

        const dadosFiltroAtendimento = {
            nome: filtro.nome,
            slug: filtro.slug,
            ordem: filtro.ordem,
            exibir_filtro: filtro.exibir_filtro,
            tipo: filtro.tipo,
            padrao: filtro.padrao,
            programa_id: this.state.programa_id
        };
    
        api({
            method: metodo,
            url: url,
            data: dadosFiltroAtendimento,
        })
        .then(response => {
            
            const MySwal = withReactContent(Swal)
            const textSwal = (filtro.id) ? 'Filtro de atendimento atualizado com sucesso' : 'Filtro de atendimento cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            this.carregarFiltrosAtendimentoPrograma();
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o filtro de atendimento, verifique os campos e tente novamente'; 
            let content = '';           

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'nome') {
                        content += `<br>&bull; Nome: ${value}`;
                    }
                    if(key == 'slug') {
                        content += `<br>&bull; Slug: ${value}`;
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    };

    salvarColunaAtendimento = (coluna) => {
        const url = coluna.id ? `/programas/colunas-atendimentos/${coluna.id}/` : '/programas/colunas-atendimentos/';
        const metodo = coluna.id ? 'put' : 'post';

        const dadosColunaAtendimento = {
            nome: coluna.nome,
            slug: coluna.slug,
            ordem: coluna.ordem,
            exibir_campo: coluna.exibir_campo,
            programa_id: this.state.programa_id
        };
    
        api({
            method: metodo,
            url: url,
            data: dadosColunaAtendimento,
        })
        .then(response => {
            
            const MySwal = withReactContent(Swal)
            const textSwal = (coluna.id) ? 'Coluna de atendimento atualizado com sucesso' : 'Coluna de atendimento cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            this.carregarColunasAtendimentoPrograma();
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar a coluna de atendimento, verifique os campos e tente novamente'; 
            let content = '';           

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'nome') {
                        content += `<br>&bull; Nome: ${value}`;
                    }
                    if(key == 'slug') {
                        content += `<br>&bull; Slug: ${value}`;
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    };

    carregarFiltrosAtendimentoPrograma = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/filtros-atendimentos/?programa_id=${this.state.programa_id}`)
                .then(response => {
                    const filtrosAtendimento = response.data;
                    // Mapeia os filtros do padrão e atualiza os campos de acordo com o slug
                    const updatedFiltrosAtendimento = this.state.filtros_atendimento_padrao.map(filtroPadrao => {
                        // Encontra o filtro que tem o mesmo slug no retorno da API
                        const filtroApi = filtrosAtendimento.find(filtro => filtro.slug === filtroPadrao.slug);
                        
                        if (filtroApi) {
                            // Atualiza os campos com os dados da API
                            return {
                                ...filtroPadrao, // mantém as propriedades existentes
                                id: filtroApi.id,
                                nome: filtroApi.nome,
                                ordem: filtroApi.ordem,
                                padrao: filtroApi.padrao,
                                exibir_filtro: filtroApi.exibir_filtro
                            };
                        }
                        // Se não encontrar, retorna o filtro padrão sem alteração
                        return filtroPadrao;
                    });
                    //console.log(updatedColunasAtendimento);
                    // Atualiza o estado com as colunas modificadas
                    this.setState({ filtros_atendimento_padrao: updatedFiltrosAtendimento });
                })
                .catch(error => {
                    console.error('Erro ao carregar filtros de atendimento:', error);
                    
                    let erro_msg = 'Erro ao carregar filtros de atendimento, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    //Colunas de Atendimento do Programa
    carregarColunasAtendimentoPrograma = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/colunas-atendimentos/?programa_id=${this.state.programa_id}`)
                .then(response => {
                    const colunasAtendimento = response.data;
                    // Mapeia as colunas do padrão e atualiza os campos de acordo com o slug
                    const updatedColunasAtendimento = this.state.colunas_atendimento_padrao.map(colunaPadrao => {
                        // Encontra a coluna que tem o mesmo slug no retorno da API
                        const colunaApi = colunasAtendimento.find(coluna => coluna.slug === colunaPadrao.slug);
                        
                        if (colunaApi) {
                            // Atualiza os campos com os dados da API
                            return {
                                ...colunaPadrao, // mantém as propriedades existentes
                                id: colunaApi.id,
                                nome: colunaApi.nome,
                                ordem: colunaApi.ordem,
                                exibir_campo: colunaApi.exibir_campo
                            };
                        }
                        // Se não encontrar, retorna a coluna padrão sem alteração
                        return colunaPadrao;
                    });
                    //console.log(updatedColunasAtendimento);
                    // Atualiza o estado com as colunas modificadas
                    this.setState({ colunas_atendimento_padrao: updatedColunasAtendimento });
                })
                .catch(error => {
                    console.error('Erro ao carregar colunas atendimento:', error);
                    
                    let erro_msg = 'Erro ao carregar colunas de atendimento, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    salvarStatusAplicacao = (index) => {
        const status = this.state.status_aplicacao[index];
        const url = status.id ? `/programas/aplicacoes-status/${status.id}/` : '/programas/aplicacoes-status/';
        const metodo = status.id ? 'put' : 'post';
    
        const dadosStatus = {
            nome: status.nome,
            motivos_nao_realizacao: status.motivos_nao_realizacao,
            programa_id: this.state.programa_id
        };

        api({
            method: metodo,
            url: url,
            data: dadosStatus,
        })
        .then(response => {
            // Se for um novo botao, atualize o estado com a ID retornada pela API
            if (!status.id) {
                this.setState(prevState => {
                    const statusAtualizados = [...prevState.status_aplicacao];
                    statusAtualizados[index].id = response.data.id;
                    return { status_aplicacao: statusAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (status.id) ? 'Status da aplicação atualizado com sucesso' : 'Status da aplicação cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o status da aplicação, verifique os campos e tente novamente'; 
            let content = '';           

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'nome') {
                        content += `<br>&bull; Nome: ${value}`;
                    }
                    if(key == 'programa_id') {
                        content += `<br>&bull; Id do programa: ${value}`;
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
        
    }

    salvarDosagem = (index) => {
        const dosagem = this.state.dosagens[index];
        const url = dosagem.id ? `/programas/dosagens/${dosagem.id}/` : '/programas/dosagens/';
        const metodo = dosagem.id ? 'put' : 'post';
    
        const dadosDosagem = {
            quantidade: dosagem.quantidade,
            unidade: dosagem.unidade,
            programa_id: this.state.programa_id
        };

        api({
            method: metodo,
            url: url,
            data: dadosDosagem,
        })
        .then(response => {
            // Se for um novo botao, atualize o estado com a ID retornada pela API
            if (!dosagem.id) {
                this.setState(prevState => {
                    const dosagemAtualizados = [...prevState.dosagens];
                    dosagemAtualizados[index].id = response.data.id;
                    return { dosagens: dosagemAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (dosagem.id) ? 'Dosagem atualizada com sucesso' : 'Dosagem cadastrada com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar a dosagem, verifique os campos e tente novamente'; 
            let content = '';           

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'quantidade') {
                        content += `<br>&bull; Quantidade: ${value}`;
                    }
                    if(key == 'unidade') {
                        content += `<br>&bull; Unidade: ${value}`;
                    }
                    if(key == 'programa_id') {
                        content += `<br>&bull; Id do programa: ${value}`;
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });       
    }   

    salvarBotoesAtendimento = (index) => {
        const botao = this.state.botoes_atendimento[index];
        const url = botao.id ? `/programas/botoes/${botao.id}/` : '/programas/botoes/';
        const metodo = botao.id ? 'put' : 'post';
    
        const dadosBotao = {
            titulo: botao.titulo,
            descricao: botao.descricao,
            formulario_id: botao.formulario_id,
            programa_id: this.state.programa_id
        };

        if(botao.envia_email){
            dadosBotao['envia_email'] = botao.envia_email;
            dadosBotao['email_titulo'] = botao.email_titulo;
            dadosBotao['email_enderecos'] = botao.email_enderecos;
            dadosBotao['email_conteudo'] = botao.email_conteudo;    
        }

        dadosBotao['exibir_botao_monitoria'] = botao.exibir_botao_monitoria;
        dadosBotao['exibir_aba'] = botao.exibir_aba;

        dadosBotao['tipo_usuario'] = (botao.tipo_usuario) ? botao.tipo_usuario : '';
        dadosBotao['callback_funcao'] = (botao.callback_funcao) ? botao.callback_funcao : '';
    
        api({
            method: metodo,
            url: url,
            data: dadosBotao,
        })
        .then(response => {
            // Se for um novo botao, atualize o estado com a ID retornada pela API
            if (!botao.id) {
                this.setState(prevState => {
                    const botoesAtualizados = [...prevState.botoes_atendimento];
                    botoesAtualizados[index].id = response.data.id;
                    return { botoes_atendimento: botoesAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (botao.id) ? 'Botão de atendimento atualizado com sucesso' : 'Botão de atendimento cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o botão, verifique os campos e tente novamente'; 
            let content = '';           

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'titulo') {
                        content += `<br>&bull; Título: ${value}`;
                    }
                    if(key == 'valor') {
                        content += `<br>&bull; Descrição: ${value}`;
                    }
                    if(key == 'formulario_id') {
                        content += `<br>&bull; Id do formulário: ${value}`;
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    };

    salvarDica = (index) => {
        const formData = new FormData();

        const dica = this.state.dicas[index];
        const url = dica.id ? `/programas/dicas/${dica.id}/` : '/programas/dicas/';
        const metodo = dica.id ? 'put' : 'post';

        if (dica.imagem_upload) {
            formData.append('imagem', dica.imagem_upload);
        }        

        formData.append('titulo', dica.titulo);
        formData.append('categoria', dica.categoria);
        formData.append('descricao', dica.descricao);
        formData.append('programa_id', this.state.programa_id); 

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            // atualiza o estado das dicas
            this.setState(prevState => {
                const dicasAtualizados = [...prevState.dicas];

                if (!dica.id) {
                    dicasAtualizados[index].id = response.data.id;
                }

                if (response.data.imagem) {
                    dicasAtualizados[index].imagem = response.data.imagem;
                }

                return { dicas: dicasAtualizados };
            });
            
            const MySwal = withReactContent(Swal)
            const textSwal = (dica.id) ? 'Dica atualizada com sucesso' : 'Dica cadastrada com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar a dica, verifique os campos e tente novamente'; 
            let content = '';           

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'titulo') {
                        content += `<br>&bull; Título: ${value}`;
                    }
                    if(key == 'descricao') {
                        content += `<br>&bull; Descrição: ${value}`;
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    };

    enviarFarmacovigilancia = async (e) => {
        e.preventDefault();
        const formDataPrograma = new FormData();
        const formDataFarmacovigilancia = new FormData();
    
        formDataPrograma.append('farmacovigilancia_formulario_id', this.state.farmacovigilancia_formulario_id);
        formDataPrograma.append('farmacovigilancia_formulario_nome', this.state.farmacovigilancia_formulario_nome);
        formDataPrograma.append('farmacovigilancia_email', this.state.farmacovigilancia_email);

        const urlPrograma = this.state.programa_id ? `/programas/${this.state.programa_id}/` : '/programas/';
        const metodoPrograma = this.state.programa_id ? 'put' : 'post';
    
        await api({
            method: metodoPrograma,
            url: urlPrograma,
            data: formDataPrograma,
        })
        .then(responsePrograma => {
            // Chamada para verificar se já existe um registro de farmacovigilância
            const urlCheckFarmacovigilancia = `/programas/farmacovigilancia/?programa_id=${this.state.programa_id}`;
    
            api.get(urlCheckFarmacovigilancia)
            .then(responseCheck => {
                // Se houver um registro, atualiza; caso contrário, cria um novo
                const existeRegistro = responseCheck.data.length > 0;
                const farmacovigilanciaId = existeRegistro ? responseCheck.data[0].id : null;
    
                const urlFarmacovigilancia = existeRegistro
                    ? `/programas/farmacovigilancia/${farmacovigilanciaId}/`
                    : `/programas/farmacovigilancia/`;
                const metodoFarmacovigilancia = existeRegistro ? 'put' : 'post';
    
                formDataFarmacovigilancia.append('texto_sessao1', this.state.texto_sessao1);
                formDataFarmacovigilancia.append('n_documento', this.state.n_documento);
                formDataFarmacovigilancia.append('farmacovigilancia_modelo', this.state.farmacovigilancia_modelo);
                if (this.state.farmacovigilancia_imagem instanceof File) {
                    formData.append('farmacovigilancia_imagem', this.state.farmacovigilancia_imagem);
                }
                if (this.state.farmacovigilancia_pdf_modelo) {
                    formData.append('farmacovigilancia_pdf_modelo', this.state.farmacovigilancia_pdf_modelo);
                }
                formDataFarmacovigilancia.append('versao', this.state.versao);
                formDataFarmacovigilancia.append('habilita_excel_farmacovigilancia', this.state.habilita_excel_farmacovigilancia);
                formDataFarmacovigilancia.append('farmacovigilancia_habilitar_pdf', this.state.farmacovigilancia_habilitar_pdf);
                formDataFarmacovigilancia.append('programa_id', this.state.programa_id);

                api({
                    method: metodoFarmacovigilancia,
                    url: urlFarmacovigilancia,
                    data: formDataFarmacovigilancia,
                })
                .then(responseFarmacovigilancia => {
                    const MySwal = withReactContent(Swal);
                    const textSwal = existeRegistro
                        ? 'Farmacovigilância atualizada com sucesso'
                        : 'Farmacovigilância cadastrada com sucesso';
    
                    MySwal.fire({
                        title: <p>{textSwal}</p>,
                        icon: 'success',
                        showCloseButton: true,
                    });
    
                    this.setState({
                        loading: false,
                        farmacovigilancia_id: responseFarmacovigilancia.data.id,
                    });

                    this.carregarDadosFarmacovigilanciaPrograma();
                })
                .catch(error => {
                    this.handleError(error, 'Erro ao salvar os campos de farmacovigilância');
                });
            })
            .catch(error => {
                this.handleError(error, 'Erro ao verificar registro de farmacovigilância');
            });
        })
        .catch(error => {
            this.handleError(error, 'Erro ao salvar o formulário e o email');
        });
    };

    adicionarServico = () => {
        this.setState(prevState => ({
            servicos: [...prevState.servicos, { valor: '', servico_procedimento_id: '', servico_procedimento_nome: '', estados_register: '', estados_selecionados: '', limite_observacao: '', permite_ultrapassar_limite: false, lembrete_dia_anterior: false, template_whatsapp_prestador: '', template_whatsapp_paciente: '', limite_reagendamentos: '', limite_periodo: '' }],
        }));
    };

    adicionarStatusAplicacao = () => {
        this.setState(prevState => ({
            status_aplicacao: [...prevState.status_aplicacao, {nome: "", motivos_nao_realizacao: ''}],
        }));
    };

    adicionarDosagem = () => {
        this.setState(prevState => ({
            dosagens: [...prevState.dosagens, {quantidade: '', unidade: ''}],
        }));
    };

    adicionarStatus = () => {
        this.setState(prevState => ({
            status_programa: [...prevState.status_programa, {nome: "", slug: '', ativo: "", ordem: '', template_whatsapp: "", cor: '', icon: '', descricao: '', orientacao: '', tipo: '', menu_adicional_atendimento: ''}],
        }));
    };

    adicionarOptOut = () => {
        this.setState(prevState => ({
            motivos_optout: [...prevState.motivos_optout, {titulo: "", ordem: ''}],
        }));
    };

    adicionarAcoesPrograma = () => {
        this.setState(prevState => ({
            acoes_programa: [...prevState.acoes_programa, {nome: "", ordem: '', slug: ''}],
        }));
    };

    adicionarBotao = () => {
        this.setState(prevState => ({
            botoes_atendimento: [...prevState.botoes_atendimento, { titulo: '', descricao: '', formulario_id: '', formulario_nome: '', tipo_usuario: '', envia_email: "", email_titulo: "", email_enderecos: "", email_conteudo: "", exibir_botao_monitoria: false, exibir_aba: false }],
        }));
    };

    adicionarDica = () => {
        this.setState(prevState => ({
            dicas: [...prevState.dicas, { titulo: '', imagem: '', imagem_upload: '', descricao: '' }],
        }));
    };

    adicionarGrafico = () => {
        this.setState(prevState => ({
            graficos: [...prevState.graficos, { titulo_grafico: '', categoria: '' }],
        }));
    };

    removerServico = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover serviço?',
            text: "Tem certeza que deseja remover este serviço/procedimento?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const servico = this.state.servicos[index];

                if (servico.id) {

                    const url = `/programas/servicos_procedimentos/${servico.id}/`;
                    const metodo = 'put';
                
                    const dadosServico = {
                        status: false
                    };
                
                    api({
                        method: metodo,
                        url: url,
                        data: dadosServico,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Serviço removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            servicos: prevState.servicos.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o serviço, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        servicos: prevState.servicos.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O serviço foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    removerStatusAplicacao = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover status da aplicação?',
            text: "Tem certeza que deseja remover este status da aplicação?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const status = this.state.status_aplicacao[index];

                if (status.id) {
                    api({
                        method: 'delete',
                        url: `/programas/aplicacoes-status/${status.id}/`,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Status da aplicação removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            status_aplicacao: prevState.status_aplicacao.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o status da aplicação, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        status_aplicacao: prevState.status_aplicacao.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O status da aplicação foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    removerDosagem = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover dosagem?',
            text: "Tem certeza que deseja remover esta dosagem?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const dosagem = this.state.dosagens[index];

                if (dosagem.id) {
                    api({
                        method: 'delete',
                        url: `/programas/dosagens/${dosagem.id}/`,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Dosagem removida com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            dosagens: prevState.dosagens.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover a dosagem, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        dosagens: prevState.dosagens.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'A dosagem foi removida.',
                        'success'
                    );
                }
            }
        });
    };

    removerStatus = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover status do programa?',
            text: "Tem certeza que deseja remover este status do programa?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const status = this.state.status_programa[index];

                if (status.id) {
                    api({
                        method: 'delete',
                        url: `/programas/status/${status.id}/`,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Status do programa removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            status_programa: prevState.status_programa.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o status, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        status_programa: prevState.status_programa.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O status do programa foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    removerOptOutPrograma = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover optout do programa?',
            text: "Tem certeza que deseja remover este optout do programa?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const optout = this.state.motivos_optout[index];

                if (optout.id) {
                    api({
                        method: 'delete',
                        url: `/programas/optout-motivos/${optout.id}/`,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Optout do programa removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            motivos_optout: prevState.motivos_optout.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o optout, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        motivos_optout: prevState.motivos_optout.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O optout do programa foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    removerAcoesPrograma = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover ações do programa?',
            text: "Tem certeza que deseja remover esta ação do programa?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const acao = this.state.acoes_programa[index];

                if (acao.id) {
                    api({
                        method: 'delete',
                        url: `/programas/acao/${acao.id}/`,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Ação do programa removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            acoes_programa: prevState.acoes_programa.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover a ação, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        acoes_programa: prevState.acoes_programa.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'A ação do programa foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    removerBotao = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover botão de atendimento?',
            text: "Tem certeza que deseja remover este botão de atendimento?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const botao = this.state.botoes_atendimento[index];

                if (botao.id) {
                    api({
                        method: 'delete',
                        url: `/programas/botoes/${botao.id}/`,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Botão de atendimento removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            botoes_atendimento: prevState.botoes_atendimento.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o botão, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        botoes_atendimento: prevState.botoes_atendimento.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O botão de atendimento foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    removerDica = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover dica?',
            text: "Tem certeza que deseja remover esta dica?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const dica = this.state.dicas[index];

                if (dica.id) {                
                    api({
                        method: 'delete',
                        url: `/programas/dicas/${dica.id}/`,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Dica removida com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            dicas: prevState.dicas.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover a dica, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        dicas: prevState.dicas.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'A dica foi removida.',
                        'success'
                    );
                }
            }
        });
    };

    removerGrafico = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover gráfico?',
            text: "Tem certeza que deseja remover este gráfico?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const grafico = this.state.graficos[index];

                if (grafico.id) {                
                    api({
                        method: 'delete',
                        url: `/programas/graficos/${grafico.id}/`,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Gráfico removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            graficos: prevState.graficos.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o gráfico, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        graficos: prevState.graficos.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O gráfico foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    
    handleError = (error, defaultMessage) => {
        let erro_msg = defaultMessage;
        let content = '';
    
        if (error.response && error.response.status === 500) {
            erro_msg = 'Servidor indisponível no momento';
        } else if (error.response && error.response.status === 400) {
            const campos = error.response.data;
            for (let key in campos) {
                const value = campos[key];
                content += `<br>&bull; ${key}: ${value}`;
            }
        }
    
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            icon: 'error',
            showCloseButton: true,
            title: <p>{erro_msg}</p>,
            html: content,
        });
    
        this.setState({ loading: false });
    };
    

    handleChangeServico = (index, event, fieldName, arrChild) => {
        const servicos = [...this.state.servicos];
        if(fieldName === "show"){
            servicos[index] = {
                ...servicos[index],
                show: !servicos[index].show, // Inverte o valor de show
            };
        }
        if (fieldName === 'servico_procedimento_id') {
            servicos[index] = { ...servicos[index], servico_procedimento_id: event.value, servico_procedimento_nome: event.label, valor: event.valor };
        } else if(fieldName === 'estados_selecionados'){

            event.forEach(estado => {
                servicos[index] = {
                    ...servicos[index],
                    estados_selecionados: {
                        ...servicos[index].estados_selecionados,
                        [estado.value]: estado.label
                    }
                };
            });

            event.forEach(estado => {
                const novoEstado = {
                    uf: estado.value,
                    novo: false,
                    novo_acm: false,
                    adequacao: false,
                    adequacao_acm: false,
                    renovacao: false,
                    renovacao_adm: false
                };

                // Verifique se 'estados_register' é um array. Se não for, inicialize como um array vazio
                if (!Array.isArray(servicos[index].estados_register)) {
                    servicos[index].estados_register = [];
                }

                // Encontre o índice do estado com a mesma sigla (uf) dentro de estados_register
                const estadoIndex = servicos[index].estados_register.findIndex(estadoRegistro => estadoRegistro.uf === estado.value);

                if (estadoIndex !== -1) {
                    // Se o estado já existir, substitui
                    //servicos[index].estados_register[estadoIndex] = novoEstado;
                } else {
                    // Caso não exista, adiciona o novo estado
                    servicos[index].estados_register.push(novoEstado);
                }
            });

            // Remover estados que não estão mais no 'event'
            const estadosEventValues = event.map(estado => estado.value);

            // Remover do 'estados_selecionados'
            servicos[index].estados_selecionados = Object.keys(servicos[index].estados_selecionados)
                .filter(key => estadosEventValues.includes(key))
                .reduce((acc, key) => {
                    acc[key] = servicos[index].estados_selecionados[key];
                    return acc;
                }, {});

            // Remover do 'estados_register'
            servicos[index].estados_register = servicos[index].estados_register.filter(estadoRegistro => 
                estadosEventValues.includes(estadoRegistro.uf)
            );
        } else if (fieldName == "estados_register"){
            // Atualiza o objeto `servicos[index]` de forma imutável
            // Atualizando servicos[index] (suponhamos que index = 0)
            servicos[index] = {
                ...servicos[index], // Mantém o conteúdo original de servicos[index]
                estados_register: servicos[index].estados_register.map((item, idx) =>
                    idx === Number(arrChild.index_child)
                        ? { ...item, [arrChild.campo]: arrChild.value } // Atualiza o campo 'novo' para true
                        : item // Mantém os outros itens inalterados
                )
            };
        } else if(fieldName === 'valor') {
            const { value } = event.target;
            servicos[index] = { ...servicos[index], valor: formatarValor(value) };
        }        
        else if(fieldName == 'padrao'){                           
            servicos[index] = { ...servicos[index], padrao: event.target.checked };
        }
        else if(fieldName === 'permite_ultrapassar_limite' || fieldName === 'lembrete_dia_anterior'){
            const { value } = event.target;
            servicos[index] = { ...servicos[index], [fieldName]: value === 'true' };
        }
        else {
            const { name, value } = event.target;
            servicos[index] = { ...servicos[index], [name]: value };            
        }
        this.setState({ servicos });

        //console.log(this.state.servicos);
    };

    handleChangeDosagem = (index, event, fieldName) => {
        const dosagens = [...this.state.dosagens];
        dosagens[index] = { ...dosagens[index], [fieldName]: event.target.value };
        this.setState({ dosagens });
    };

    handleChangeStatusAplicacao = (index, event, fieldName) => {
        const status_aplicacao = [...this.state.status_aplicacao];
        status_aplicacao[index] = { ...status_aplicacao[index], [fieldName]: event.target.value };
        this.setState({ status_aplicacao });
    };

    handleChangeStatus = (index, event, fieldName, bool) => {
        const status_programa = [...this.state.status_programa];
        if (fieldName === 'nome') {
            status_programa[index] = { ...status_programa[index], nome: event.target.value, slug: this.gerarSlug(event.target.value) };
        //} //else if (fieldName === 'slug'){
        //    status_programa[index] = { ...status_programa[index], [name]: this.gerarSlug(value) };
        } else {
            const { name, value } = event.target;
            if(!value){
                status_programa[index] = { ...status_programa[index], [name]: bool };
            } else {
                status_programa[index] = { ...status_programa[index], [name]: value };
            }
            
        }
        this.setState({ status_programa });
    };

    handleChangeOptOut = (index, event, fieldName) => {
        const motivos_optout = [...this.state.motivos_optout];
        motivos_optout[index] = { ...motivos_optout[index], [fieldName]: event.target.value };
        this.setState({ motivos_optout });
    };

    handleChangeAcoesPrograma = (index, event, fieldName) => {
        const acoes_programa = [...this.state.acoes_programa];
        acoes_programa[index] = { ...acoes_programa[index], [fieldName]: event.target.value };
        this.setState({ acoes_programa });
    };

    gerarSlug (nome) {
        return nome
          .toLowerCase() // Converte para minúsculas
          .normalize('NFD') // Normaliza caracteres acentuados
          .replace(/[\u0300-\u036f]/g, '') // Remove acentos
          .replace(/[^a-z0-9-]/g, '-') // Substitui caracteres não alfanuméricos por hífen
          .replace(/--+/g, '-') // Remove hífens duplicados
          .replace(/^-|-$| /g, ''); // Remove hífens no começo ou fim e espaços
      };

    handleBotaoAtendimentoChange = (index, event, fieldName, bool) => {
        const botoes_atendimento = [...this.state.botoes_atendimento];

        if(fieldName === "envia_email" || fieldName === "exibir_botao_monitoria" || fieldName === "exibir_aba"){
            botoes_atendimento[index] = { ...botoes_atendimento[index], [fieldName]: bool };
        }
        else if (fieldName === 'formulario_id') {
            botoes_atendimento[index] = { ...botoes_atendimento[index], formulario_id: event.value, formulario_nome: event.label, valor: event.valor };
        } else if (fieldName === "email_conteudo"){
            botoes_atendimento[index] = { ...botoes_atendimento[index], ["email_conteudo"]: event };
        } else {
            const { name, value } = event.target;
            botoes_atendimento[index] = { ...botoes_atendimento[index], [name]: value };
        }
        this.setState({ botoes_atendimento });
    };

    handleColunaAtendimentoChange = (index, event, fieldName, bool) => {
        const colunas_atendimento_padrao = [...this.state.colunas_atendimento_padrao];

        if(fieldName === "show"){
            colunas_atendimento_padrao[index] = { ...colunas_atendimento_padrao[index], [fieldName]: !bool };
        } else if(fieldName === "exibir_campo"){
            colunas_atendimento_padrao[index] = { ...colunas_atendimento_padrao[index], [fieldName]: bool };    
        } else {
            const { name, value } = event.target;
            colunas_atendimento_padrao[index] = { ...colunas_atendimento_padrao[index], [name]: value };    
        }
        
        this.setState({ colunas_atendimento_padrao });
    };

    handleFiltroAtendimentoChange = (index, event, fieldName, bool) => {
        const filtros_atendimento_padrao = [...this.state.filtros_atendimento_padrao];
        if(fieldName === "show"){
            filtros_atendimento_padrao[index] = { ...filtros_atendimento_padrao[index], [fieldName]: !bool };
        } else if(fieldName === "exibir_filtro" || fieldName === "padrao"){
            filtros_atendimento_padrao[index] = { ...filtros_atendimento_padrao[index], [fieldName]: bool };    
        } else {
            const { name, value } = event.target;
            filtros_atendimento_padrao[index] = { ...filtros_atendimento_padrao[index], [name]: value };    
        }
        
        this.setState({ filtros_atendimento_padrao });
    };

    handleDicasChange = (index, event, fieldName) => {
        const dicas = [...this.state.dicas];

        if (fieldName === 'imagem_upload') {
            dicas[index] = { ...dicas[index], imagem_upload: event.target.files[0] };
        }
        else {
            const { name, value } = event.target;
            dicas[index] = { ...dicas[index], [name]: value };
        }

        this.setState({ dicas });
    };

    handleGraficosChange = (index, event, fieldName) => {
        const graficos = [...this.state.graficos];

        const { name, value } = event.target;
        graficos[index] = { ...graficos[index], [name]: value };

        this.setState({ graficos });
    };

    //TRATAMENTO GERAL
    handleChange = (e) => {
        const { name, value } = e.target;
        if(name == "servico_valor"){
            const valorFormatado = formatarValor(value);
            this.setState({ [name]: valorFormatado });
        } else {
            this.setState({ [name]: value });
        }
        
    };

    handleChangeTemplate = (index, event) => {
        const { name, value } = event.target;
        this.setState((prevState) => {
            const templates = [...prevState.templates];
            templates[index][name] = value;
            return { templates };
        });
    };

    //TRATAMENTO GERAL
    handleChangeLegendaAplicacoes = (value) => {
        this.setState({ aplicacoes_legenda: value });
    };
    
    onChangeFarmacovigilancia = (farmacovigilanciaSelecionado) => {
        this.setState({ farmacovigilancia_formulario_id: farmacovigilanciaSelecionado ? farmacovigilanciaSelecionado.value : '', farmacovigilancia_formulario_nome: farmacovigilanciaSelecionado ? farmacovigilanciaSelecionado.label : ''  });
    };

    onChangeClienteId = (clienteSelecionado) => {
        this.setState({ cliente_id: clienteSelecionado ? clienteSelecionado.value : '' });
    };

    onChangeTipo = (tipoSelecionado) => {
        this.setState({ tipo_id: tipoSelecionado ? tipoSelecionado.value : '', tipo_nome: tipoSelecionado ? tipoSelecionado.label : '' });
    };

    onChangeTermo = (termoSelecionado) => {
        this.setState({ termo_id: termoSelecionado ? termoSelecionado.value : '', termo_nome: termoSelecionado ? termoSelecionado.label : '' });
    };

    onChangeTermoPrestador = (termoSelecionado) => {
        this.setState({ termo_prestador_id: termoSelecionado ? termoSelecionado.value : '', termo_prestador_nome: termoSelecionado ? termoSelecionado.label : '' });
    };

    onChangeModeloNovo = (modeloSelecionado) => {
        this.setState({ medico_novo_modelo_mensagem_id: modeloSelecionado ? modeloSelecionado.value : '', medico_novo_modelo_mensagem_titulo: modeloSelecionado ? modeloSelecionado.label : '' });
    };

    onChangeModeloExistente = (modeloSelecionado) => {
        this.setState({ medico_existente_modelo_mensagem_id: modeloSelecionado ? modeloSelecionado.value : '', medico_existente_modelo_mensagem_titulo: modeloSelecionado ? modeloSelecionado.label : '' });
    };

    onChangeDoenca = (termoSelecionado) => {
        this.setState({ doenca_principal_id: termoSelecionado ? termoSelecionado.value : '', doenca_principal_nome: termoSelecionado ? termoSelecionado.label : '' });
    };



    onChangeImagemFarmacovigilancia = (e) => {
        this.setState({ farmacovigilancia_imagem: e.target.files[0] });
    };

    onChangeImagem = (e) => {
        this.setState({ imagem_upload: e.target.files[0] });
    };

    onChangeImagemBranca = (e) => {
        this.setState({ imagem_branca_upload: e.target.files[0] });
    };

    onChangeLogomarca1 = (e) => {
        this.setState({ optout_logomarca_1: e.target.files[0] });
    };

    onChangeLogomarca2 = (e) => {
        this.setState({ optout_logomarca_2: e.target.files[0] });
    };

    onChangeWelcomeKit = (e) => {
        this.setState({ welcome_kit_upload: e.target.files[0] });
    };

    onChangeArquivoPDFModelo = (e) => {
        this.setState({ farmacovigilancia_pdf_modelo: e.target.files[0] });
    };

    onChangeTermoPacientePDF = (e) => {
        this.setState({ termo_paciente_pdf_upload: e.target.files[0] });
    };

    //Drag and Drop
    onDragEnd = (result) => {
        const { destination, source } = result;
    
        // Se o destino não existir ou se o item for solto na mesma posição, não faz nada
        if (!destination || (destination.droppableId === source.droppableId && destination.index === source.index)) {
            return;
        }
    
        const newEtapas = Array.from(this.state.etapas);
        const [relocatedItem] = newEtapas.splice(source.index, 1);
        newEtapas.splice(destination.index, 0, relocatedItem);
    
        this.setState({ etapas: newEtapas });
    };

    buscaServicosProcedimentos = async (inputValue = '', index) => {
        // Verifica se a etapa foi focada antes de realizar a chamada
        if (!this.state.etapas[index].isServicosFocused) {
            return [];
        }

        try {
            // Ajusta a URL da API conforme a presença do inputValue
            const response = await api.get(`/programas/servicos_procedimentos/?programa=${this.state.programa_id}&status=1`);
            const opcoes = response.data.results.map(servico => ({
                value: servico.servico_procedimento_id,
                label: servico.dados_servico.nome,
            }));
            return opcoes;
        } catch (error) {
            console.error(error);
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>Erro ao consultar serviços</p>,
            });
            return [];
        }
    };

    buscaPesquisas = async () => {
        const opcoes = await pesquisas.map(pesquisa => ({
            value: pesquisa.id,
            label: `[${pesquisa.tipo}] ${pesquisa.nome}`,
        }));
        return opcoes;
    };

    carregarAcoes = async (inputValue) => {
        try {
            const response = await api.get(`/programas/acoes/?programa_id=${this.state.programa_id}&nome=${inputValue}`);
            const opcoes = response.data.results.map(acao => ({
                value: acao.id,
                label: acao.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar acoes:', error);
            return [];
        }
    };

    handleEtapaServicoChange = (selectedOption, index) => {
        // Atualiza o serviço selecionado da etapa específica
        const updatedEtapas = [...this.state.etapas];
        updatedEtapas[index].servicos_procedimentos = selectedOption;
        this.setState({ etapas: updatedEtapas });
    };

    handleSelectTab = async (aba) => {
        if (this.state.carregamentoAbas.length > 0) {
            const containsAba = this.state.carregamentoAbas.some(item => item.nome === aba);
            if(containsAba){
                return;
            }
        }

        this.setState({
            loading: true
        });
        
        try {
            // Executa as requisições de forma assíncrona
            switch (aba) {
                case "servicosDoPrograma":
                    await this.carregarServicosPrograma();
                    break;
    
                case "etapasDoPrograma":
                    await this.carregarEtapas();
                    break;
    
                case "produtosDoPrograma":
                    await this.carregarProdutosPrograma();
                    break;
    
                case "botoesDoPrograma":
                    await this.carregarBotoesPrograma();
                    break;
    
                case "dicasDoPrograma":
                    await this.carregarDicasPrograma();
                    break;
    
                case "GraficosPrograma":
                    await this.carregarGraficosPrograma();
                    break;
    
                case "statusDoPrograma":
                    await this.carregarStatusPrograma();
                    break;
                case "doencasDoPrograma":
                    await this.carregarDoencasPrograma();
                    await this.carregarDoencasRelacionadas();
                    break;
                case "FarmacovigilanciaPrograma":
                    await this.carregarDadosFarmacovigilanciaPrograma();
                    break;

                case "monitoriaDoPrograma":
                    await this.carregaMonitoriaTipos();
                    break;

                case "MotivosOptoutPrograma":
                    await this.carregarOptOutMotivos();
                    break;

                case "AcoesPrograma":
                    await this.carregarAcoesPrograma();
                    break;
                
                case "colunasDoPrograma":
                    await this.carregarColunasAtendimentoPrograma();
                    break;

                case "filtrosDoPrograma":
                    await this.carregarFiltrosAtendimentoPrograma();
                    break;
    
                case "historicoDeCompras":
                    await this.carregarHistoricoDeCompras();
                    break;

                case "regrasDoPrograma":
                    break;

                case "modeloRelatorioDoPrograma":
                    break;

                case "reguasComunicacaoDoPrograma":
                    break;

                case "configuracoesPrograma":
                    break;
                    
                case "mensageriaRecorrentePrograma":
                    break;

                case "faqPrograma":
                    break;

                case "dashboardPrograma":
                    break;
                    
                case "servicoProcedimentoPrograma":
                    break;

                default:
                    break;
            }
    
            // Após todas as funções terminarem com sucesso, define loading como false
            this.setState({
                loading: false
            });

            this.setState(prevState => ({
                ...prevState,
                carregamentoAbas: [
                    ...prevState.carregamentoAbas,  // espalha os itens existentes
                    { nome: aba, status: true }     // adiciona o novo item ao final
                ]
            }));
    
        } catch (error) {
            // Caso algum erro aconteça, define loading como false
            console.error("Erro ao carregar os dados:", error);
            this.setState({
                loading: false
            });
        }
    }

    editaServico = (id) => {
        if(id){
            this.setState({
                servico_id: id,
                servico_titulo: 'Editando Serviço',
                loading: true,
            })

            //consulta os dados do programa na api
            api.get(`/servicos_procedimentos/${id}`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',
                    servico_nome: dados.nome,
                    servico_descricao: dados.descricao,
                    servico_tipo: dados.tipo,
                    servico_valor: dados.valor,
                    loading: false,
                    showModalServico: true
                })
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar serviço/procedimento, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
    }

    enviaRegistroServico = (e, index) => {
        e.preventDefault();

        const formData = new FormData();

        this.setState({
            loading: true,
            servico_nomeHelper: "",
            servico_descricaoHelper: "",
            servico_tipoHelper: "",
            servico_valorHelper: "",
        });

        const valorFormatadoAPI = formatarValorAPI(this.state.servico_valor);

        //vererifica se é edição ou adição
        const url = (this.state.servico_id) ? '/servicos_procedimentos/'+this.state.servico_id+'/' : '/servicos_procedimentos/'
        const metodo = (this.state.servico_id) ? 'put' : 'post'

        formData.append('nome', this.state.servico_nome);
        formData.append('descricao', this.state.servico_descricao);
        formData.append('tipo', this.state.servico_tipo);
        formData.append('valor', valorFormatadoAPI);
        formData.append('programa_id', this.state.programa_id);

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = 'Serviço/Procedimento cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            this.setState(prevState => ({
                ...prevState,
                carregamentoAbas: [
                    ...prevState.carregamentoAbas,  // espalha os itens existentes
                    { nome: "servicosDoPrograma", status: false }     // adiciona o novo item ao final
                ]
            }));
            this.handleSelectTab("servicosDoPrograma");
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o serviço/procedimento, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'nome'){
                        this.setState({ nomeHelper: value })
                    }
                    if(key === 'descricao'){
                        this.setState({ descricaoHelper: value })
                    }
                    if(key === 'tipo'){
                        this.setState({ tipoHelper: value })
                    }
                    if(key === 'valor'){
                        this.setState({ valorHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };
    /* Funções referente a aba de histórico de compras*/
    carregarEtapasPrograma = async (inputValue) => {
        try {
            const response = await api.get(`/programas/etapas/?programa_id=${this.state.programa_id}&nome=${inputValue}&status=1`);
            const opcoes = response.data.results.map(etapa => ({
                value: etapa.id,
                label: etapa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar etapas:', error);
            return [];
        }
    }

    carregarTemplatesWhatsapp = () => {
        const { etapaSelecionada } = this.state;
        if (!etapaSelecionada || !etapaSelecionada.id) {
            console.error("Erro: Nenhuma etapa selecionada.");
            return;
        }
    
        api.get(`/programas/etapas/templates-whatsapp/?etapa_id=${etapaSelecionada.id}`)
            .then(response => {
                const templatesCarregados = response.data.results.map(template => ({
                    id: template.id,
                    etapa_id: template.etapa_id,
                    titulo: template.titulo,
                    template: template.template,
                    destinatario: template.destinatario,
                }));
    
                this.setState({
                    templates: templatesCarregados,
                    erroLoadRegistro: '',
                    showModalTemplate: true, 
                    loading: false,
                });
            })
            .catch(error => {
                let erro_msg = "Erro ao carregar templates, tente novamente";
    
                if (error.response && error.response.status === 500) {
                    erro_msg = "Servidor indisponível no momento, tente novamente";
                }
    
                this.setState({
                    erroLoadRegistro: erro_msg,
                    loading: false,
                });
            });
    };
    
    enviaTemplate = (index, event) => {
        event.preventDefault();
        
        const { etapaSelecionada, templates } = this.state;
    
        if (!etapaSelecionada || !etapaSelecionada.id) {
            console.error("Erro: Nenhuma etapa selecionada.");
            return;
        }
    
        const formData = new FormData();
        this.setState({
            loading: true,
            templateHelper: "",
            tituloHelper: "",
            destinatarioHelper: "",
        });

        const templateAtual = templates[index];
    
        const url = templateAtual.id
            ? `/programas/etapas/templates-whatsapp/${templateAtual.id}/`
            : "/programas/etapas/templates-whatsapp/";
    
        const metodo = templateAtual.id ? "put" : "post";
    
        formData.append("etapa_id", etapaSelecionada.id);
        formData.append("titulo", templateAtual.titulo);
        formData.append("template", templateAtual.template);
        formData.append("destinatario", templateAtual.destinatario);
    
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            withReactContent(Swal).fire({
                title: <p>Template Whatsapp cadastrado com sucesso</p>,
                icon: "success",
                showCloseButton: true,
            });
    
            this.setState({ loading: false });
    
            this.setState(prevState => ({
                ...prevState,
                carregamentoAbas: [
                    ...prevState.carregamentoAbas,
                    { nome: "etapasDoPrograma", status: false }
                ]
            }));
    
            this.handleSelectTab("etapasDoPrograma");
        })
        .catch(error => {
            let erro_msg = "Erro ao cadastrar o Template Whatsapp, verifique os campos e tente novamente";
    
            if (error.response) {
                if (error.response.status === 500) {
                    erro_msg = "Servidor indisponível no momento";
                } else if (error.response.status === 400) {
                    const campos = error.response.data;
                    
                    this.setState(prevState => {
                        const novosTemplates = [...prevState.templates];
                        novosTemplates[index] = {
                            ...novosTemplates[index],
                            templateHelper: campos.template || "",
                            destinatarioHelper: campos.destinatario || "",
                            tituloHelper: campos.titulo || "",
                        };
                        return { templates: novosTemplates };
                    });
                }
            }
    
            withReactContent(Swal).fire({
                icon: "error",
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            });
    
            this.setState({ loading: false });
        });
    };
    carregarProdutosCompras = async (inputValue) => {
        const programa_id = this.state.programa_id;
        if (programa_id) {
            try {
                const response = await api.get(`/programas/produtos/?programa=${programa_id}&produto=${inputValue}`);
                const opcoesFiltradas = response.data.results.map(produto => ({
                    value: produto.produto_id,
                    label: produto.dados_produto.nome,
                }));

                return opcoesFiltradas;
            } catch (error) {
                console.error('Erro ao carregar campos:', error);
                Sentry.captureException('Erro ao carregar campos:', error);
            }
        }
    };

    handleChangeHistoricoDeCompras = (index, event, fieldName, bool) => {

        const historico_de_compras = [...this.state.historico_de_compras];
        if (fieldName === 'produto_id') {
            historico_de_compras[index] = { ...historico_de_compras[index], produto_id: event.value, produto_nome: event.label };
        } else if (fieldName === 'etapa_id') {
            historico_de_compras[index] = { ...historico_de_compras[index], etapa_id: event.value, etapa_nome: event.label };
        } else {
            const { name, value } = event.target;
            if(!value){
                historico_de_compras[index] = { ...historico_de_compras[index], [name]: bool };
            } else {
                historico_de_compras[index] = { ...historico_de_compras[index], [name]: value };
            }
            
        }
        this.setState({ historico_de_compras });
    };

    adicionarHistoricoDeCompras = () => {
        this.setState(prevState => ({
            historico_de_compras: [...prevState.historico_de_compras, {titulo: "", produto_id: '', produto_nome: '', ordem: '', etapa_id: '', id: null}],
        }));
    };

    removerHistoricoDeCompras = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover compra?',
            text: "Tem certeza que deseja remover esta compra?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const compra = this.state.historico_de_compras[index];

                if (compra.id) {
                    api({
                        method: 'delete',
                        url: `/programas/compras/${compra.id}/`,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Compra removida com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            historico_de_compras: prevState.historico_de_compras.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover a compra, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        historico_de_compras: prevState.historico_de_compras.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'A compra foi removida.',
                        'success'
                    );
                }
            }
        });
    };

    salvarHistoricoDeCompras = (index) => {
        const compra = this.state.historico_de_compras[index];
        const url = compra.id ? `/programas/compras/${compra.id}/` : '/programas/compras/';
        const metodo = compra.id ? 'put' : 'post';
    
        const dadosCompra = {
            titulo: compra.titulo,
            produto_id: compra.produto_id,
            ordem: compra.ordem,
            etapa_ignorar_mensageria_id: compra.etapa_id,
            programa_id: this.state.programa_id
        };

        api({
            method: metodo,
            url: url,
            data: dadosCompra,
        })
        .then(response => {
            // Se for um novo botao, atualize o estado com a ID retornada pela API
            if (!compra.id) {
                this.setState(prevState => {
                    const compraAtualizados = [...prevState.historico_de_compras];
                    compraAtualizados[index].id = response.data.id;
                    return { historico_de_compras: compraAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (compra.id) ? 'Compra atualizada com sucesso' : 'Compra cadastrada com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar a compra, verifique os campos e tente novamente'; 
            let content = '';           

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'titulo') {
                        content += `<br>&bull; Título: ${value}`;
                    }
                    if(key == 'ordem') {
                        content += `<br>&bull; Ordem: ${value}`;
                    }
                    if(key == 'programa_id') {
                        content += `<br>&bull; Id do programa: ${value}`;
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    }

    carregarHistoricoDeCompras = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/compras/?programa_id=${this.state.programa_id}`)
                .then(response => {                    
                    const comprasCarregadas = response.data.results.map(compra => ({
                        titulo: compra.titulo,
                        produto_id: compra.dados_produto.id,
                        produto_nome: compra.dados_produto.nome,
                        ordem: compra.ordem,
                        etapa_id: compra.dados_etapa.id,
                        etapa_nome: compra.dados_etapa.nome,
                        id: compra.id
                    }));
                    this.setState({ historico_de_compras: comprasCarregadas });
                })
                .catch(error => {
                    console.error('Erro ao carregar compras:', error);
                    
                    let erro_msg = 'Erro ao carregar compras do programa, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    excluirTemplate = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover Template?',
            text: "Tem certeza que deseja remover este Template?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const template = this.state.templates[index];

                if (template.id) {

                    const url = `/programas/etapas/templates-whatsapp/${template.id}/`;
                    const metodo = 'delete';
                
                    const dadosTemplate = {
                        status: false
                    };
                
                    api({
                        method: metodo,
                        url: url,
                        data: dadosTemplate,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Template Whatsapp removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            templates: prevState.templates.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o template, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        templates: prevState.templates.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O Template foi removida.',
                        'success'
                    );
                }
            }
        });
    };

    excluirArquivo = async (e, campoApi, campoState) => {
    e.preventDefault();
    const formData = new FormData();
    const MySwal = withReactContent(Swal);

    MySwal.fire({
        title: '<p>Você tem certeza que deseja excluir o arquivo?</p>',
        text: 'Esta ação não pode ser desfeita.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
    }).then((result) => {
        if (result.isConfirmed) {
            if (this.state.programa_id) {
                const url = '/programas/' + this.state.programa_id + '/';
                const metodo = 'put';

                formData.append(campoApi, true);

                api({
                    method: metodo,
                    url: url,
                    data: formData,
                })
                .then(response => {
                    MySwal.fire('Excluído!', 'O arquivo foi excluído com sucesso.', 'success');
                    this.setState({ loading: false });
                    this.carregarDadosPrograma();
                })
                .catch(error => {
                     this.setState({ loading: false });
                     MySwal.fire({ icon: 'error', title: "Erro", text: "Erro ao excluir arquivo." });
                });
            }
        }
    });
}

    abrirModalTemplates = (etapa) => {
        this.setState(
            { showModalTemplate: true, etapaSelecionada: etapa, templatesWhatsapp: [] }, 
            () => this.carregarTemplatesWhatsapp(etapa.id)
        );
    };

    adicionarTemplate = () => {
        this.setState(prevState => ({
            templates: [
                ...prevState.templates,
                { titulo: "", template: "", destinatario: "" } // Novo template vazio
            ]
        }));
    };

    handleOpenModalConfiguracoes = (index) => {
        const etapa = this.state.etapas[index];

        this.setState({
            showModalConfiguracoes: true,
            etapaConfiguracaoIndex: index,
            configuracoesJson: etapa.configuracoes
                ? etapa.configuracoes
                : '[]',
            configuracoesJsonError: '',
        });
    };

    fecharModalConfiguracoes = () => {
        this.setState({
            showModalConfiguracoes: false,
            etapaConfiguracaoIndex: null,
            configuracoesJson: '[]',
            configuracoesJsonError: '',
            loadingModalConfiguracoes: false,
        });
    };

    handleOpenModalHelpConfigEtapa = () => {
        this.setState({ showModalHelpConfigEtapa: true });
    }

    handleCloseModalHelpConfigEtapa = () => {
        this.setState({ showModalHelpConfigEtapa: false });
    }

    getEtapaConfigDocsSections = () => ([
        {
            title: 'Regra de Exibição Dinâmica',
            keyName: 'show_on',
            description: 'Esconde ou mostra uma etapa de acordo com campos do atendimento. Se a regra não for validada, a etapa fica invisível em fluxos que usam essa listagem.',
            example: `{
  "show_on": [
    {
      "campo": "recebe_kit_paciente",
      "valor": true
    }
  ]
}`,
            note: 'No exemplo acima, a etapa só será liberada quando "recebe_kit_paciente" for true.'
        },
        {
            title: 'Trava de Aba do Kit',
            keyName: 'etapa_kit',
            description: 'Identifica que a etapa está associada ao fluxo de kit. Quando true, impede marcação indevida em pontos específicos da jornada.',
            example: `{
  "etapa_kit": true
}`
        },
        {
            title: 'Bloqueio de Expansão no Histórico',
            keyName: 'deny_profiles',
            description: 'Mantém a etapa visível no histórico, mas bloqueia a expansão do accordion para os perfis informados.',
            example: `{
  "deny_profiles": ["medicos", "operador"]
}`,
            note: 'A validação considera tipo_usuario e, para prestador, também prestador_categoria.'
        },
        {
            title: 'Popup para Médico na Etapa',
            keyName: 'popup_medico',
            description: 'Exibe mensagem informativa para médico ao acessar a etapa atual. Opcionalmente permite segundo popup por doença.',
            example: `{
  "popup_medico": {
    "mensagem": "Mensagem principal do popup.",
    "popup_2": [
      {
        "doencas": [1, 2],
        "mensagem": "Mensagem complementar para doenças específicas."
      }
    ]
  }
}`
        },
        {
            title: 'Mensagem de conclusão da etapa por perfil',
            keyName: 'mensagem_sucesso_finalizacao_medico',
            description: 'A etapa tem um único campo "Mensagem de sucesso", então um texto escrito para quem executa aparece igual para a operação. Estas chaves dão a variante por perfil ao CONCLUIR a etapa (diferente do popup_medico, que dispara ao ABRIR). Sem elas, todos veem o campo "Mensagem de sucesso" como antes.',
            example: `{
  "mensagem_sucesso_finalizacao_medico": "Caso o paciente não atenda aos critérios de elegibilidade, um profissional do programa entrará em contato.",
  "mensagem_sucesso_finalizacao_prestador": "Registro concluído. A equipe do programa dará sequência."
}`
        }
    ]);

    salvarConfiguracoesEtapa = async () => {
        const { etapaConfiguracaoIndex, configuracoesJson } = this.state;

        try {
            JSON.parse(configuracoesJson);
        } catch (e) {
            this.setState({
                configuracoesJsonError: 'JSON inválido',
            });
            return;
        }

        // sincroniza com a etapa
        await this.setState(prevState => {
            const etapas = [...prevState.etapas];
            etapas[etapaConfiguracaoIndex].configuracoes = configuracoesJson;
            return { etapas };
        });

        // salva direto na API
        this.salvarEtapa(etapaConfiguracaoIndex);

        this.fecharModalConfiguracoes();
    };
    
    render(){
        const { 
            acoesJson,
            acoesJsonError,
        } = this.state;
        return (
            <div>
                <Button 
                    variant="link" 
                    className="mb-2 p-0 text-decoration-none text-white"
                    onClick={() => this.props.router.navigate("/programas")}
                >
                    <FaArrowLeft className="me-2" />
                    Voltar
                </Button>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosDoPrograma" id="tabs-programa" className="aditus-tabs" onSelect={this.handleSelectTab}>
                    <Tab eventKey="dadosDoPrograma" title="Dados do Programa">
                        {!this.state.loading  ? (
                        <Form onSubmit={this.enviaPrograma}>
                            <Card className="cardDestaque">
                                <Card.Body>                    
                                    <h4>Dados Gerais </h4>
                                    <Row>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nome do Programa <span style={{ color: 'red' }}> *</span></Form.Label>
                                                <Form.Control type="text" name="nome" required placeholder="Nome do Programa" value={this.state.nome} onChange={this.handleChange} />
                                                <Form.Text id="formNomeHelpBlock" className="text-danger">{this.state.nomeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Cliente</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={this.carregarClientes}
                                                    defaultOptions
                                                    name="cliente_id"
                                                    onChange={this.onChangeClienteId}
                                                    placeholder="Buscar cliente..."
                                                    noOptionsMessage={() => "Nenhum cliente encontrado"}
                                                    value={this.state.opcoesClientes.find(opcao => opcao.value === this.state.cliente_id)}
                                                />
                                                <Form.Text className="text-danger">{this.state.clienteIdHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Categoria<span style={{ color: 'red' }}> *</span></Form.Label>
                                                <Form.Control as="select" name="categoria" value={this.state.categoria} required onChange={this.handleChange}>
                                                    <option value="">Categoria do Programa</option>
                                                    {Object.entries(categoriasDeProgramas).map(([sigla, nome]) => (
                                                        <option key={sigla} value={sigla}>{nome}</option>
                                                    ))}
                                                </Form.Control>
                                                <Form.Text id="formCategoriaHelpBlock" className="text-danger">{this.state.categoriaHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>

                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Tipo de Programa <span style={{ color: 'red' }}> *</span></Form.Label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={this.carregarTiposPrograma}
                                                    defaultOptions
                                                    required
                                                    name="tipo_id"
                                                    placeholder="Buscar tipo de programa..."
                                                    noOptionsMessage={() => "Nenhum tipo de programa encontrado"}
                                                    onChange={this.onChangeTipo}
                                                    value={this.state.tipo_id ? { value: this.state.tipo_id, label: this.state.tipo_nome } : null}
                                                />
                                                <Form.Text className="text-danger">{this.state.tipoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>

                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Grupo de Cadastro Médico</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={this.carregarGrupos}
                                                    defaultOptions
                                                    name="grupo_cadastro_medico_id"
                                                    placeholder="Buscar grupo..."
                                                    noOptionsMessage={() => "Nenhum grupo encontrado"}
                                                    onChange={this.onChangeGrupo}
                                                    value={this.state.grupo_cadastro_medico_id ? { value: this.state.grupo_cadastro_medico_id, label: this.state.grupo_cadastro_medico_nome } : null}
                                                />
                                                <Form.Text className="text-danger">{this.state.grupoIdHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={2} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Tipo de Faturamento <span style={{ color: 'red' }}> *</span></Form.Label>
                                                <Form.Control as="select" name="tipo_faturamento" value={this.state.tipo_faturamento} onChange={this.handleChange}>
                                                    <option value="">Selecione</option>
                                                    {Object.entries(this.tiposFaturamento).map(([value, label]) => (
                                                        <option key={value} value={value}>{label}</option>
                                                    ))}
                                                </Form.Control>
                                                <Form.Text id="formTipoFaturamentoHelpBlock" className="text-danger">{this.state.tipoFaturamentoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={2} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Tipo do Cadastro Médico</Form.Label>
                                                <Form.Control as="select" name="tipo_cadastro_medico" value={this.state.tipo_cadastro_medico} onChange={this.handleChange}>
                                                    <option value="">Selecione</option>
                                                    {Object.entries(TiposCadastroMedico).map(([value, label]) => (
                                                        <option key={value} value={value}>{label}</option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={2} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Welcome Kit</Form.Label>
                                                <Form.Control type="file" name="welcome_kit_upload" onChange={this.onChangeWelcomeKit} ref={this.fileInput} />
                                                <Form.Text id="formWelcomeKitHelpBlock" className="text-danger">{this.state.welcomeKitHelper}</Form.Text>
                                                {this.state.welcome_kit && (
                                                    <Button variant="light" className="btn-sm" href={this.state.welcome_kit} target="_blank" style={{ marginTop: '10px' }}>
                                                        <FaEye /> Ver Welcome Kit Atual
                                                    </Button>
                                                )}
                                            </Form.Group>
                                        </Col>
                                         <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Bucket S3 Nome </Form.Label>
                                                <Form.Control type="text" name="bucketS3_nome" required placeholder="Bucket S3 Nome" value={this.state.bucketS3_nome} onChange={this.handleChange} />
                                                <Form.Text id="formContatoNomeHelpBlock" className="text-danger">{this.state.bucketS3Helper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Descrição do Programa <span style={{ color: 'red' }}> *</span></Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    required 
                                                    placeholder="Descrição" 
                                                    name="descricao"
                                                    value={this.state.descricao} 
                                                    onChange={this.handleChange} 
                                                    className="custom-textarea"
                                                />
                                                <Form.Text id="formDescricaoHelpBlock" className="text-danger">
                                                    {this.state.descricaoHelper}
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            <Card className="cardDestaque">
                                <Card.Body>
                                    <Row>
                                        <h4>Dados de Contato</h4>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nome do Contato</Form.Label>
                                                <Form.Control type="text" name="contato_nome" placeholder="Nome do contato" value={this.state.contato_nome} onChange={this.handleChange} />
                                                <Form.Text id="formContatoNomeHelpBlock" className="text-danger">{this.state.contatoNomeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>E-mail</Form.Label>
                                                <Form.Control type="email" placeholder="E-mail" name="contato_email" id="formEmail" value={this.state.contato_email} onChange={this.handleChange} />                            
                                                <Form.Text id="formContatoEmailHelpBlock" className="text-danger">{this.state.contatoEmailHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Celular</Form.Label>
                                                <Form.Control as={IMaskInput} mask="(00) 00000-0000" placeholder="Celular" name="contato_celular" id="formTelefone" value={this.state.contato_celular} onChange={this.handleChange} />
                                                <Form.Text id="formContatoCelularHelpBlock" className="text-danger">{this.state.contatoCelularHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            <Card className="cardDestaque">
                                <Card.Body>
                                    <Row>
                                        <h4>Termos do Programa</h4>
                                        <Col sm={3} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Termo PDF para Paciente</Form.Label>
                                                {!this.state.termo_paciente_pdf ? (
                                                    <>
                                                        <Form.Control type="file" name="termo_paciente_pdf" onChange={this.onChangeTermoPacientePDF} ref={this.fileInput} />
                                                        <Form.Text id="formtermoPacientePDFHelpBlock" className="text-danger">{this.state.termoPacientePDFHelper}</Form.Text>
                                                    </>
                                                ) : (
                                                <>
                                                    <br/>
                                                    <Button 
                                                        variant="light" 
                                                        className="btn-sm" 
                                                        onClick={(e) => this.excluirArquivo(e, 'excluir_pdf', 'termo_paciente_pdf')} 
                                                        style={{ marginTop: '10px' }}
                                                    >
                                                        <FaTrash /> Excluir PDF Atual
                                                    </Button>

                                                    <Button variant="light" className="btn-sm" href={this.state.termo_paciente_pdf} target="_blank" style={{ marginTop: '10px' }}>
                                                        <FaEye /> Ver Termo Atual
                                                    </Button>
                                                </>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col sm={3} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Versão do Termo PDF</Form.Label>
                                                <Form.Control type="text" name="versao" value={this.state.versao} onChange={this.handleChange} />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={3} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Termo para Paciente (Texto)</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={this.carregarTermos}
                                                    defaultOptions
                                                    name="termo_id"
                                                    placeholder="Buscar termo..."
                                                    noOptionsMessage={() => "Nenhum termo encontrado"}
                                                    onChange={this.onChangeTermo}
                                                    value={this.state.termo_id ? { value: this.state.termo_id, label: this.state.termo_nome } : null}
                                                />
                                                <Form.Text className="text-danger">{this.state.termoIdHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={3} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Termo para Médicos</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={this.carregarTermos}
                                                    defaultOptions
                                                    name="termo_prestador_id"
                                                    placeholder="Buscar termo..."
                                                    noOptionsMessage={() => "Nenhum termo encontrado"}
                                                    onChange={this.onChangeTermoPrestador}
                                                    value={this.state.termo_prestador_id ? { value: this.state.termo_prestador_id, label: this.state.termo_prestador_nome } : null}
                                                />
                                                <Form.Text className="text-danger">{this.state.termoIdHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>

                            {/* Pedido de novo aceite quando a versão do termo muda (HNS-1594, item 1.7) */}
                            <AtualizacaoTermosPrograma
                                programaId={this.state.programa_id || this.props.router?.params?.id}
                                versao={this.state.versao}
                            />

                            {/* Mesmo fluxo, para quem assina pelo link aberto: médicos e demais profissionais */}
                            <AtualizacaoTermosPrestador
                                programaId={this.state.programa_id || this.props.router?.params?.id}
                            />

                            <Card className="cardDestaque">
                                <Card.Body>
                                    {/* Sempre visível: a declaração precisa ser configurada ANTES de ligar a
                                        funcionalidade -- escondido atrás da flag, não havia como preparar o
                                        programa sem antes expor a indicação aos médicos */}
                                    <Row>
                                        <h4>Indicação de Profissional de Saúde</h4>
                                        {!this.state.habilitar_indicacao_profissional && (
                                            <p className="text-muted">
                                                A funcionalidade está desligada neste programa. Configure a declaração
                                                abaixo e depois ligue em <strong>Indicação de Profissional de Saúde</strong>,
                                                nas configurações do programa.
                                            </p>
                                        )}

                                        <Col sm={3} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Declaração do médico</Form.Label>
                                                {!this.state.declaracao_indicacao ? (
                                                    <Form.Control
                                                        type="file"
                                                        accept="application/pdf"
                                                        onChange={(e) => this.setState({ declaracao_indicacao_upload: e.target.files[0] })}
                                                    />
                                                ) : (
                                                    <>
                                                        <br/>
                                                        <Button variant="light" className="btn-sm" onClick={(e) => this.excluirArquivo(e, 'excluir_declaracao_indicacao', 'declaracao_indicacao')} style={{ marginTop: '10px' }}>
                                                            <FaTrash /> Excluir
                                                        </Button>
                                                        <Button variant="light" className="btn-sm ms-2" href={this.state.declaracao_indicacao} target="_blank" style={{ marginTop: '10px' }}>
                                                            <FaEye /> Visualizar
                                                        </Button>
                                                    </>
                                                )}
                                                <Form.Text muted>
                                                    PDF que o médico assina ao indicar um profissional.
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>

                                        <Col sm={9} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Marcações no PDF da declaração</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={8}
                                                    style={{ fontFamily: 'monospace', fontSize: '13px' }}
                                                    value={this.state.declaracao_indicacao_marcacoes}
                                                    isInvalid={!!this.state.erroMarcacoesDeclaracao}
                                                    placeholder='[{"x": 244.1, "y": 503.4, "texto": "medico_nome", "pagina": 1, "centralizado": true}]'
                                                    onChange={(e) => {
                                                        const valor = e.target.value;
                                                        let erro = '';
                                                        if (valor.trim()) {
                                                            try { JSON.parse(valor); }
                                                            catch { erro = 'JSON inválido — confira colchetes, vírgulas e aspas.'; }
                                                        }
                                                        this.setState({ declaracao_indicacao_marcacoes: valor, erroMarcacoesDeclaracao: erro });
                                                    }}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {this.state.erroMarcacoesDeclaracao}
                                                </Form.Control.Feedback>
                                                <Form.Text muted>
                                                    Onde preencher cada dado no PDF, por coordenada — origem no canto inferior esquerdo da página.
                                                    Campos de texto: <code>medico_nome</code>, <code>medico_registro</code>, <code>medico_registro_uf</code>,
                                                    {' '}<code>indicado_nome</code>, <code>indicado_conselho</code>, <code>indicado_registro</code>,
                                                    {' '}<code>indicado_registro_uf</code>, <code>data</code>, <code>data_dia</code>, <code>data_mes</code>, <code>data_ano</code>.
                                                    A resposta SIM/NÃO usa <code>{'{"slug": "autoriza_contato", "opcoes": {"true": {...}, "false": {...}}}'}</code>.
                                                    As coordenadas valem para o PDF enviado: trocar o arquivo exige reconferir.
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <h4>Termos da plataforma dos médicos</h4>
                                        
                                        {/* Regulamento do Programa */}
                                        <Col sm={3} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Regulamento do Programa</Form.Label>
                                                {!this.state.regulamento_programa ? (
                                                    <Form.Control 
                                                        type="file" 
                                                        onChange={(e) => this.setState({ regulamento_programa_upload: e.target.files[0] })} 
                                                        ref={this.fileInput} 
                                                    />
                                                ) : (
                                                    <>
                                                        <br/>
                                                        <Button variant="light" className="btn-sm" onClick={(e) => this.excluirArquivo(e, 'excluir_regulamento', 'regulamento_programa')} style={{ marginTop: '10px' }}>
                                                            <FaTrash /> Excluir
                                                        </Button>
                                                        <Button variant="light" className="btn-sm ms-2" href={this.state.regulamento_programa} target="_blank" style={{ marginTop: '10px' }}>
                                                            <FaEye /> Visualizar
                                                        </Button>
                                                    </>
                                                )}
                                            </Form.Group>
                                        </Col>

                                        {/* Aviso de Privacidade */}
                                        <Col sm={3} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Aviso de Privacidade</Form.Label>
                                                {!this.state.aviso_privacidade ? (
                                                    <Form.Control 
                                                        type="file" 
                                                        onChange={(e) => this.setState({ aviso_privacidade_upload: e.target.files[0] })} 
                                                        ref={this.fileInput} 
                                                    />
                                                ) : (
                                                    <>
                                                        <br/>
                                                        <Button variant="light" className="btn-sm" onClick={(e) => this.excluirArquivo(e, 'excluir_aviso', 'aviso_privacidade')} style={{ marginTop: '10px' }}>
                                                            <FaTrash /> Excluir
                                                        </Button>
                                                        <Button variant="light" className="btn-sm ms-2" href={this.state.aviso_privacidade} target="_blank" style={{ marginTop: '10px' }}>
                                                            <FaEye /> Visualizar
                                                        </Button>
                                                    </>
                                                )}
                                            </Form.Group>
                                        </Col>

                                        {/* Política de Cookies */}
                                        <Col sm={3} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Política de Cookies</Form.Label>
                                                {!this.state.politica_cookies ? (
                                                    <Form.Control 
                                                        type="file" 
                                                        onChange={(e) => this.setState({ politica_cookies_upload: e.target.files[0] })} 
                                                        ref={this.fileInput} 
                                                    />
                                                ) : (
                                                    <>
                                                        <br/>
                                                        <Button variant="light" className="btn-sm" onClick={(e) => this.excluirArquivo(e, 'excluir_cookies', 'politica_cookies')} style={{ marginTop: '10px' }}>
                                                            <FaTrash /> Excluir
                                                        </Button>
                                                        <Button variant="light" className="btn-sm ms-2" href={this.state.politica_cookies} target="_blank" style={{ marginTop: '10px' }}>
                                                            <FaEye /> Visualizar
                                                        </Button>
                                                    </>
                                                )}
                                            </Form.Group>
                                        </Col>

                                        {/* Termos do Programa (Médicos) */}
                                        <Col sm={3} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Termos do Programa (Médicos)</Form.Label>
                                                {!this.state.termos_programa_medicos ? (
                                                    <Form.Control 
                                                        type="file" 
                                                        onChange={(e) => this.setState({ termos_programa_medicos_upload: e.target.files[0] })} 
                                                        ref={this.fileInput} 
                                                    />
                                                ) : (
                                                    <>
                                                        <br/>
                                                        <Button variant="light" className="btn-sm" onClick={(e) => this.excluirArquivo(e, 'excluir_termos_medicos', 'termos_programa_medicos')} style={{ marginTop: '10px' }}>
                                                            <FaTrash /> Excluir
                                                        </Button>
                                                        <Button variant="light" className="btn-sm ms-2" href={this.state.termos_programa_medicos} target="_blank" style={{ marginTop: '10px' }}>
                                                            <FaEye /> Visualizar
                                                        </Button>
                                                    </>
                                                )}
                                            </Form.Group>
                                        </Col>

                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Conteúdo do E-mail de Solicitação do Aceite do Termo (Médicos)</Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    placeholder="Descrição" 
                                                    name="solicitacao_aceite_termo_opt_in_medicos"
                                                    value={this.state.solicitacao_aceite_termo_opt_in_medicos} 
                                                    onChange={this.handleChange} 
                                                    className="custom-textarea"
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Conteúdo do E-mail enviado com credenciais de acesso do médico</Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    placeholder="Descrição" 
                                                    name="envio_email_credenciais_de_acesso_medicos"
                                                    value={this.state.envio_email_credenciais_de_acesso_medicos} 
                                                    onChange={this.handleChange} 
                                                    className="custom-textarea"
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Template Mensagem Whatsapp</Form.Label>
                                                <Form.Control type="text" name="template_mensagem_whatsapp" value={this.state.template_mensagem_whatsapp} onChange={this.handleChange} />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Template Whatsapp - Reenvio de termo ao profissional</Form.Label>
                                                <Form.Control type="text" name="termos_template_whatsapp_prestador" value={this.state.termos_template_whatsapp_prestador} onChange={this.handleChange} />
                                                <Form.Text muted>
                                                    Nome do template aprovado. Vazio = o reenvio sai apenas por e-mail.
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            <Card className="cardDestaque">
                                <Card.Body>
                                    <Row>
                                        <h4>Validações</h4>                                
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Permite Menor de Idade?</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.permite_menor_idade ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ permite_menor_idade: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.permite_menor_idade ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ permite_menor_idade: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Permite atendimento extra com aprovacao?</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.permite_atendimento_extra_com_aprovacao ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ permite_atendimento_extra_com_aprovacao: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.permite_atendimento_extra_com_aprovacao ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ permite_atendimento_extra_com_aprovacao: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Exige vinculação de médico?</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.medico_cadastro ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ medico_cadastro: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.medico_cadastro ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ medico_cadastro: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Exige vinculação de laboratório?</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.laboratorio_cadastro ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ laboratorio_cadastro: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.laboratorio_cadastro ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ laboratorio_cadastro: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Vínculo de Atendente/Navegador</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_vinculo_atendente ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_vinculo_atendente: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_vinculo_atendente ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_vinculo_atendente: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Seleção de Laboratório</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_escolha_laboratorio ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_escolha_laboratorio: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_escolha_laboratorio ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_escolha_laboratorio: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Escolha do Multiprofissional</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_escolha_multiprofissional ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_escolha_multiprofissional: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_escolha_multiprofissional ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_escolha_multiprofissional: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Optin por Telefone</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_optin_telefone ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_optin_telefone: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_optin_telefone ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_optin_telefone: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Gestão de Produtos</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_gestao_produtos ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_gestao_produtos: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_gestao_produtos ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_gestao_produtos: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Gestão de Aplicações</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_gestao_aplicacoes ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_gestao_aplicacoes: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_gestao_aplicacoes ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_gestao_aplicacoes: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Registro de Compras</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_registro_compras ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_registro_compras: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_registro_compras ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_registro_compras: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Registro de Dosagens</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_registro_dosagens ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_registro_dosagens: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_registro_dosagens ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_registro_dosagens: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Exames</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_exames ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_exames: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_exames ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_exames: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Multiplos Exames</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_selecionar_multiplos_exames ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_selecionar_multiplos_exames: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_selecionar_multiplos_exames ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_selecionar_multiplos_exames: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Ocultar Menu Atendimentos</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.ocultar_menu_atendimentos ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ ocultar_menu_atendimentos: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.ocultar_menu_atendimentos ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ ocultar_menu_atendimentos: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Validacao de Atendimento</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_validacao_atendimento ? "success" : "outline-secondary"}
                                                            onClick={() => this.setState({ habilitar_validacao_atendimento: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_validacao_atendimento ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_validacao_atendimento: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Mensageria de Aniversário</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_mensageria_aniversario ? "success" : "outline-secondary"}
                                                            onClick={() => this.setState({ habilitar_mensageria_aniversario: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_mensageria_aniversario ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_mensageria_aniversario: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Ocultar Menu Receptivos</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.ocultar_menu_receptivos ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ ocultar_menu_receptivos: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.ocultar_menu_receptivos ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ ocultar_menu_receptivos: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Ocultar Menu Prestadores</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.ocultar_menu_prestadores ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ ocultar_menu_prestadores : true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.ocultar_menu_prestadores ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ ocultar_menu_prestadores: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Ocultar Nome Local e Telefone Contato (Endereço paciente)</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.ocultar_nome_local ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ ocultar_nome_local : true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.ocultar_nome_local ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ ocultar_nome_local: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar geolocalização na pesquisa de laboratórios (aba de exames)</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_geolocalizacao_laboratorios ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_geolocalizacao_laboratorios : true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_geolocalizacao_laboratorios ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_geolocalizacao_laboratorios: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>  
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Exige CPF para atendimento</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.exige_cpf_atendimento ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ exige_cpf_atendimento : true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.exige_cpf_atendimento ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ exige_cpf_atendimento: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>   
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Pre-Cadastro Básico</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_pre_cadastro_basico ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_pre_cadastro_basico : true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_pre_cadastro_basico ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_pre_cadastro_basico: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Exige endereço do paciente</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.endereco_paciente_obrigatorio ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ endereco_paciente_obrigatorio : true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.endereco_paciente_obrigatorio ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ endereco_paciente_obrigatorio: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>  
                                        
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Exige Aceite Termo Opt-in (Medicos)</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.exige_aceite_termo_opt_in_medicos ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ exige_aceite_termo_opt_in_medicos: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.exige_aceite_termo_opt_in_medicos ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ exige_aceite_termo_opt_in_medicos: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                {/* liga o menu do médico, a fila da operação e as abas de indicação */}
                                                <Form.Label>Indicação de Profissional de Saúde</Form.Label>
                                                <div>
                                                    <Button
                                                        variant={this.state.habilitar_indicacao_profissional ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_indicacao_profissional: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button
                                                        variant={!this.state.habilitar_indicacao_profissional ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_indicacao_profissional: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>

                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Permite reativar atendimento</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.permite_reativar_atendimento ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ permite_reativar_atendimento: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.permite_reativar_atendimento ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ permite_reativar_atendimento: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Trocar termo Atendimentos por Pacientes (Sidebar)</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.sidebar_atendimentos_pacientes ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ sidebar_atendimentos_pacientes: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.sidebar_atendimentos_pacientes ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ sidebar_atendimentos_pacientes: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>

                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Exibir info. detalhada no card de Paciente(edição de atendimentos)</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.ativar_detalhamento_card_paciente_inAtendimentos ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ ativar_detalhamento_card_paciente_inAtendimentos: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.ativar_detalhamento_card_paciente_inAtendimentos ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ ativar_detalhamento_card_paciente_inAtendimentos: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>

                                        <Col sm={4}>
                                            <Form.Group className="mb-3">
                                                        <Form.Label>Habilitar Envio de Kit para Paciente</Form.Label>
                                                        <div>
                                                            <Button 
                                                                variant={this.state.habilitar_envio_kit ? "success" : "outline-secondary"}
                                                                onClick={() => this.handleHabilitarEnvioKitChange(true)}>
                                                                Sim
                                                            </Button>
                                                            {' '}
                                                            <Button 
                                                                variant={!this.state.habilitar_envio_kit ? "danger" : "outline-secondary"}
                                                                onClick={() => this.handleHabilitarEnvioKitChange(false)}>
                                                                Não
                                                            </Button>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={4} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Aviso de limite de Atendimentos</Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    required 
                                                    placeholder="Descrição" 
                                                    name="aviso_limite_atendimentos"
                                                    value={this.state.aviso_limite_atendimentos} 
                                                    onChange={this.handleChange} 
                                                    className="custom-textarea"
                                                />
                                            </Form.Group>
                                        </Col>    
                                        <Col sm={2}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Limite de atendimentos por CPF</Form.Label>
                                                <Form.Control 
                                                    type="number" 
                                                    name="limite_atendimentos_por_cpf" 
                                                    value={this.state.limite_atendimentos_por_cpf} 
                                                    onChange={this.handleChange}
                                                />
                                            </Form.Group>
                                        </Col> 
                                        
                                    </Row>
                                                
                                </Card.Body>
                            </Card>
                            <Card className="cardDestaque">
                                <Card.Body>
                                    <Row>
                                        <h4>Agendamentos</h4>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Agendamento de Serviços</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_agendamentos_servicos ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_agendamentos_servicos: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_agendamentos_servicos ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_agendamentos_servicos: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Tipos de Agendamento</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_tipos_agendamento  ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_tipos_agendamento : true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_tipos_agendamento  ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_tipos_agendamento : false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Conteúdo do E-mail de Solicitação do Prestador</Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    placeholder="Descrição" 
                                                    name="agendamento_email_solicitacao_prestador"
                                                    value={this.state.agendamento_email_solicitacao_prestador} 
                                                    onChange={this.handleChange} 
                                                    className="custom-textarea"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Conteúdo do E-mail de Atualização do Status
                                                </Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    placeholder="Descrição" 
                                                    name="agendamento_email_atualizacao_status"
                                                    value={this.state.agendamento_email_atualizacao_status} 
                                                    onChange={this.handleChange} 
                                                    className="custom-textarea"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                        {/*
                                            <Form.Group className="mb-3">
                                                <Form.Label>Logomarca <span style={{ color: 'red' }}> *</span></Form.Label>
                                                <Form.Control type="file" name="imagem_upload" onChange={this.onChangeImagem} ref={this.fileInput} />
                                                <Form.Text id="formImagemHelpBlock" className="text-danger">{this.state.imagemHelper}</Form.Text>
                                                {this.state.imagem && (
                                                    <div>
                                                        <img src={this.state.imagem} alt="Imagem Atual" style={{ maxWidth: '100px', marginTop: '10px' }} />
                                                    </div>
                                                )}
                                            </Form.Group>
                                            */}
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            <Card className="cardDestaque">
                                <Card.Body>
                                    <Row>
                                        <h4>Identidade Visual - Layout e Labels</h4>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Logomarca <span style={{ color: 'red' }}> *</span></Form.Label>
                                                <Form.Control type="file" name="imagem_upload" onChange={this.onChangeImagem} ref={this.fileInput} />
                                                <Form.Text id="formImagemHelpBlock" className="text-danger">{this.state.imagemHelper}</Form.Text>
                                                {this.state.imagem && (
                                                    <div>
                                                        <img src={this.state.imagem} alt="Imagem Atual" style={{ maxWidth: '100px', marginTop: '10px' }} />
                                                    </div>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Logomarca Branca</Form.Label>
                                                <Form.Control type="file" name="imagem_branca_upload" onChange={this.onChangeImagemBranca} ref={this.fileInput} />
                                                <Form.Text id="formImagemBrancaHelpBlock" className="text-danger">{this.state.imagemBrancaHelper}</Form.Text>
                                                {this.state.imagem_branca && (
                                                    <div>
                                                        <img src={this.state.imagem_branca} alt="Imagem Branca" style={{ maxWidth: '100px', marginTop: '10px', backgroundColor: '#333' }} />
                                                    </div>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label htmlFor="colorInputFundo">Cor de fundo</Form.Label>                                                
                                                <InputGroup className="mb-3">
                                                    <Form.Control type="text" placeholder="Selecione a cor ao lado" name="layout_cor_fundo" id="formLayoutCorFundo" value={this.state.layout_cor_fundo} onChange={this.handleChange} style={{width: '80%'}} />
                                                    <Form.Control
                                                        type="color"
                                                        id="colorInputFundo"
                                                        name="layout_cor_fundo"
                                                        value={this.state.layout_cor_fundo}
                                                        title="Escolha sua cor"
                                                        onChange={this.handleChange}
                                                        style={{padding: 5, height: 45}}
                                                    />
                                                </InputGroup>
                                                <Form.Text id="layoutCorFundoHelper" className="text-danger">{this.state.layoutCorFundoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label htmlFor="colorInputFundo">Cor primária</Form.Label>                                                
                                                <InputGroup className="mb-3">
                                                    <Form.Control type="text" placeholder="Selecione a cor ao lado" name="layout_cor_primaria" id="formLayoutCorPrimaria" value={this.state.layout_cor_primaria} onChange={this.handleChange} style={{width: '80%'}} />
                                                    <Form.Control
                                                        type="color"
                                                        id="colorInputPrimaria"
                                                        name="layout_cor_primaria"
                                                        value={this.state.layout_cor_primaria}
                                                        title="Escolha sua cor"
                                                        onChange={this.handleChange}
                                                        style={{padding: 5, height: 45}}
                                                    />
                                                </InputGroup>
                                                <Form.Text id="layoutCorPrimariaHelper" className="text-danger">{this.state.layoutCorPrimariaHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label htmlFor="colorInputSecundaria">Cor secundária</Form.Label>                                                
                                                <InputGroup className="mb-3">
                                                    <Form.Control type="text" placeholder="Selecione a cor ao lado" name="layout_cor_secundaria" id="formLayoutCorSecundaria" value={this.state.layout_cor_secundaria} onChange={this.handleChange} style={{width: '80%'}} />
                                                    <Form.Control
                                                        type="color"
                                                        id="colorInputSecundaria"
                                                        name="layout_cor_secundaria"
                                                        value={this.state.layout_cor_secundaria}
                                                        title="Escolha sua cor"
                                                        onChange={this.handleChange}
                                                        style={{padding: 5, height: 45}}
                                                    />
                                                </InputGroup>
                                                <Form.Text id="formContatoNomeHelpBlock" className="text-danger">{this.state.layoutCorSecundariaHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>     
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Label endereço paciente <span style={{ color: 'red' }}> *</span></Form.Label>
                                                <Form.Control type="text" name="label_endereco_paciente" required placeholder="Label endereço paciente" value={this.state.label_endereco_paciente} onChange={this.handleChange} />
                                            </Form.Group>
                                        </Col>   
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Label do Botão Iniciar Atendimento <span style={{ color: 'red' }}> *</span></Form.Label>
                                                <Form.Control type="text" name="label_botao_atendimento" required placeholder="Label Botão de Atendimento" value={this.state.label_botao_atendimento} onChange={this.handleChange} />
                                                <Form.Text id="formLabelBotaoHelpBlock" className="text-danger">{this.state.labelBotaoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            <Card className="cardDestaque">
                                <Card.Body>
                                    <Row>
                                        <h4 className="mt-3">Dados para Mensageria</h4>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Canais de Contato <span style={{ color: 'red' }}> *</span></Form.Label>
                                                <Form.Control type="text" name="canais_contato" value={this.state.canais_contato} onChange={this.handleChange} />
                                                <Form.Text id="formCanaisContatoHelpBlock" className="text-danger">{this.state.canaisContatoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nome da Equipe <span style={{ color: 'red' }}> *</span></Form.Label>
                                                <Form.Control type="text" name="nome_equipe" value={this.state.nome_equipe} onChange={this.handleChange} />
                                                <Form.Text id="formNomeEquipeHelpBlock" className="text-danger">{this.state.nomeEquipeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Template atendimento receptivo</Form.Label>
                                                <Form.Control type="text" name="template_atendimento_receptivo" value={this.state.template_atendimento_receptivo} onChange={this.handleChange} />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Template Mensageria Aniversário</Form.Label>
                                                <Form.Control type="text" name="template_mensageria_aniversario" value={this.state.template_mensageria_aniversario} onChange={this.handleChange} />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Link Política do Programa</Form.Label>
                                                <Form.Control type="text" name="link_politica_programa" value={this.state.link_politica_programa} onChange={this.handleChange} />
                                                <Form.Text id="formPoliticaProgramaHelpBlock" className="text-danger">{this.state.politicaProgramaHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Link Regulamento do Programa</Form.Label>
                                                <Form.Control type="text" name="link_regulamento_programa" value={this.state.link_regulamento_programa} onChange={this.handleChange} />
                                                <Form.Text id="formRegulamentoProgramaHelpBlock" className="text-danger">{this.state.regulamentoProgramaHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>                                        
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Orientação Cadastro Médico <span style={{ color: 'red' }}> *</span></Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    name="orientacao_cadastro"
                                                    value={this.state.orientacao_cadastro} 
                                                    onChange={this.handleChange} 
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Instruções Termo Paciente</Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    name="instrucoes_paciente_termo"
                                                    value={this.state.instrucoes_paciente_termo} 
                                                    onChange={this.handleChange} 
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Instruções 2 Termo Paciente</Form.Label>
                                                <Form.Control 
                                                    as="textarea"  
                                                    name="instrucoes2_paciente_termo"
                                                    value={this.state.instrucoes2_paciente_termo} 
                                                    onChange={this.handleChange} 
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Texto para sessão de dicas</Form.Label>
                                                <Form.Control 
                                                    as="textarea"  
                                                    name="dicas_texto"
                                                    value={this.state.dicas_texto} 
                                                    onChange={this.handleChange} 
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Informações de Atendimento</Form.Label>
                                                <Form.Control 
                                                    as="textarea"  
                                                    name="instrucao_atendimento"
                                                    value={this.state.instrucao_atendimento} 
                                                    onChange={this.handleChange} 
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Informações de Atendimento receptivo</Form.Label>
                                                <Form.Control 
                                                    as="textarea"  
                                                    name="informacoes_receptivo"
                                                    value={this.state.informacoes_receptivo} 
                                                    onChange={this.handleChange} 
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <h4 className="mt-3">Importação de Médicos</h4>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Modelo de Mensagem para Importação de Novo Médico:</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={this.CarregarModelosMensagem}
                                                    defaultOptions
                                                    name="medico_novo_modelo_mensagem_id"
                                                    noOptionsMessage={() => "Nenhum modelo de mensagem encontrado"}
                                                    onChange={this.onChangeModeloNovo}
                                                    value={this.state.medico_novo_modelo_mensagem_id ? { value: this.state.medico_novo_modelo_mensagem_id, label: this.state.medico_novo_modelo_mensagem_titulo } : null}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Modelo de Mensagem para Importação de Médico Existente:</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={this.CarregarModelosMensagem}
                                                    defaultOptions
                                                    name="medico_existente_modelo_mensagem_id"
                                                    noOptionsMessage={() => "Nenhum modelo de mensagem encontrado"}
                                                    onChange={this.onChangeModeloExistente}
                                                    value={this.state.medico_existente_modelo_mensagem_id ? { value: this.state.medico_existente_modelo_mensagem_id, label: this.state.medico_existente_modelo_mensagem_titulo } : null}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>                
                            </Card>
                            <Card className="cardDestaque">
                                <Card.Body>      
                                    
                                    {this.state.programa_id && (     
                                        <>
                                            <Row>
                                                <h4 className="mt-3">Optout do Programa</h4>
                                                <Col sm={4} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Habilitar Optout</Form.Label>
                                                        <div>
                                                            <Button 
                                                                variant={this.state.optout_habilitado ? "success" : "outline-secondary"}
                                                                onClick={() => this.setState({ optout_habilitado: true })}>
                                                                Sim
                                                            </Button>
                                                            {' '}
                                                            <Button 
                                                                variant={!this.state.optout_habilitado ? "danger" : "outline-secondary"}
                                                                onClick={() => this.setState({ optout_habilitado: false })}>
                                                                Não
                                                            </Button>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            {this.state.optout_habilitado == true && (
                                                <Row>
                                                    <Col sm={4} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Título da Página</Form.Label>
                                                            <Form.Control type="text" name="optout_titulo" required placeholder="Título da Página" value={this.state.optout_titulo} onChange={this.handleChange} />
                                                            <Form.Text id="formLabelTituloHelpBlock" className="text-danger">{this.state.tituloHelper}</Form.Text>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={4} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Logomarca 1</Form.Label>
                                                            <Form.Control type="file" name="optout_logomarca_1" onChange={this.onChangeLogomarca1} ref={this.fileInput} />
                                                            <Form.Text id="formImagemBrancaHelpBlock" className="text-danger">{this.state.logomarca1Helper}</Form.Text>
                                                            {this.state.optout_logomarca_1 && (
                                                                <div>
                                                                    <img src={this.state.optout_logomarca_1} alt="Imagem Atual" style={{ maxWidth: '100px', marginTop: '10px' }} />
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={4} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Logomarca 2</Form.Label>
                                                            <Form.Control type="file" name="optout_logomarca_2" onChange={this.onChangeLogomarca2} ref={this.fileInput} />
                                                            <Form.Text id="formImagemBrancaHelpBlock" className="text-danger">{this.state.logomarca2Helper}</Form.Text>
                                                            {this.state.optout_logomarca_2 && (
                                                                <div>
                                                                    <img src={this.state.optout_logomarca_2} alt="Imagem Atual" style={{ maxWidth: '100px', marginTop: '10px' }} />
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={4} xs={12}>
                                                        <Form.Group className="row-list">
                                                            <Form.Label>Status ao realizar optout</Form.Label>
                                                            <Form.Control as="select" value={this.state.optout_status_id} name="optout_status_id" required onChange={this.handleChange}>
                                                                <option value="">Selecione um status</option>
                                                                {this.state.dados_status.map(status => (
                                                                    <option key={status.slug} value={status.id}>{status.nome}</option>
                                                                ))}
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={6} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Texto da Página</Form.Label>
                                                            <Form.Control 
                                                                as="textarea"  
                                                                name="optout_texto"
                                                                value={this.state.optout_texto} 
                                                                onChange={this.handleChange} 
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row> 
                                            )}
                                        </>
                                    )}      
                                      
                                    {this.state.erroLoadCli ? 
                                    <Alert variant="warning">
                                        {this.state.erroLoadCli}
                                    </Alert> : ''
                                    }                                      
                                    <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar Dados do Programa
                                            </>
                                        )}
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Form> 
                        ) : (
                            <Card className="cardDestaque">
                                <Card.Body>                    
                                    <Row>
                                        <Col xs={12} style={{textAlign: "center"}}>
                                            <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                        </Col>    
                                    </Row>    
                                </Card.Body>
                            </Card>
                        )}
                    </Tab>
                    
                    {this.state.programa_id && hasPerm('add_programas_servicos_procedimentos') && (
                        <Tab eventKey="servicoProcedimentoPrograma" title="Serviços/Procedimentos [BETA]">
                            {this.state.carregamentoAbas.some(item => item.nome === 'servicoProcedimentoPrograma') ? (
                                <ProgramaServicoProcedimento programaId={this.state.programa_id} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>
                                        <p>Clique para carregar o Dashboard...</p>
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}

                    {this.state.programa_id && hasPerm('add_programas_servicos_procedimentos') && (
                        <Tab eventKey="servicosDoPrograma" title="Serviços/Procedimentos">
                            {!this.state.loading ? (
                                <Card className="cardDestaque">
                                    <Card.Body>
                                        <Form onSubmit={this.enviaServicosPrograma}>
                                            <h4>Serviços/Procedimentos do Programa</h4>
                                            {this.state.servicos.map((servico, index) => (
                                                <div key={index} className="row-list">
                                                    <Row>
                                                        <Col sm={10}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Serviço</Form.Label>
                                                                <Row>
                                                                    <Col sm={8} >
                                                                        <AsyncSelect
                                                                            cacheOptions
                                                                            loadOptions={this.carregarServicos}
                                                                            defaultOptions
                                                                            name="servico_procedimento_id"
                                                                            placeholder="Buscar serviço/procedimento..."
                                                                            noOptionsMessage={() => "Nenhum serviço/procedimento encontrado"}
                                                                            onChange={e => this.handleChangeServico(index, e, 'servico_procedimento_id')}
                                                                            value={servico.servico_procedimento_id ? { value: servico.servico_procedimento_id, label: `${servico.servico_procedimento_nome} (#${servico.servico_procedimento_id})` } : null}
                                                                        />
                                                                    </Col>
                                                                    
                                                                   
                                                                </Row>
                                                            </Form.Group>
                                                        </Col>
                                                        {/*<Col sm={2}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Valor</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="valor"
                                                                    value={servico.valor} 
                                                                    onChange={e => this.handleChangeServico(index, e, 'valor')}
                                                                />
                                                            </Form.Group>
                                                        </Col>*/}
                                                        <Col sm={2}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Limite por CPF</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="limite_por_cpf"
                                                                    value={servico.limite_por_cpf} 
                                                                    onChange={e => this.handleChangeServico(index, e, 'limite_por_cpf')}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={3}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Observação do Limite</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="limite_observacao"
                                                                    value={servico.limite_observacao || ''} 
                                                                    onChange={e => this.handleChangeServico(index, e, 'limite_observacao')}
                                                                    placeholder="Ex: Somente são permitidos 8 agendamentos por mês"
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Permite Ultrapassar Limite</Form.Label>
                                                                <Form.Control 
                                                                    as="select"
                                                                    name="permite_ultrapassar_limite"
                                                                    value={servico.permite_ultrapassar_limite ? 'true' : 'false'}
                                                                    onChange={e => this.handleChangeServico(index, e, 'permite_ultrapassar_limite')}
                                                                >
                                                                    <option value="false">Não</option>
                                                                    <option value="true">Sim</option>
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Lembrete Dia Anterior</Form.Label>
                                                                <Form.Control 
                                                                    as="select"
                                                                    name="lembrete_dia_anterior"
                                                                    value={servico.lembrete_dia_anterior ? 'true' : 'false'}
                                                                    onChange={e => this.handleChangeServico(index, e, 'lembrete_dia_anterior')}
                                                                >
                                                                    <option value="false">Não</option>
                                                                    <option value="true">Sim</option>
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={3}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Template WhatsApp Prestador</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="template_whatsapp_prestador"
                                                                    value={servico.template_whatsapp_prestador || ''} 
                                                                    onChange={e => this.handleChangeServico(index, e, 'template_whatsapp_prestador')}
                                                                    placeholder="Nome do template"
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={3}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Template WhatsApp Paciente</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="template_whatsapp_paciente"
                                                                    value={servico.template_whatsapp_paciente || ''} 
                                                                    onChange={e => this.handleChangeServico(index, e, 'template_whatsapp_paciente')}
                                                                    placeholder="Nome do template"
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Limite Reagendamentos</Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    name="limite_reagendamentos"
                                                                    value={servico.limite_reagendamentos || ''} 
                                                                    onChange={e => this.handleChangeServico(index, e, 'limite_reagendamentos')}
                                                                    
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Limite Período (dias)</Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    name="limite_periodo"
                                                                    value={servico.limite_periodo || ''} 
                                                                    onChange={e => this.handleChangeServico(index, e, 'limite_periodo')}
                                                                    
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Estados</Form.Label>
                                                                <AsyncSelect
                                                                    cacheOptions
                                                                    loadOptions={this.carregarEstados}
                                                                    defaultOptions
                                                                    name="servico_estados"
                                                                    placeholder="Buscar estados..."
                                                                    noOptionsMessage={() => "Nenhum serviço/procedimento encontrado"}
                                                                    isMulti
                                                                    onChange={e => this.handleChangeServico(index, e, 'estados_selecionados')}
                                                                    value={servico.estados_selecionados ? 
                                                                    Object.keys(servico.estados_selecionados).map(uf => ({
                                                                        value: uf, // 'uf' será o valor da sigla do estado
                                                                        label: servico.estados_selecionados[uf] // 'label' será o nome do estado
                                                                    })) : null}
                                                                />
                                                            </Form.Group>
                                                        </Col>                                                      
                                                        <Row>
                                                            <Col sm={12} className="divestados">   
                                                                {Object.keys(servico.estados_selecionados).length > 0 && (
                                                                    <>
                                                                        {Object.entries(servico.estados_selecionados).map(([sigla, nome]) => (
                                                                            <>
                                                                            <Card className="cardDestaque" key={sigla}>
                                                                                <Card.Body>                    
                                                                                    <Form>
                                                                                        <h4 title={!servico.show ? "Mostrar opções do estado!" : "Fechar opções dos estados!"} style={{cursor: "pointer"}} onClick={(e) => this.handleChangeServico(index, e, "show")}>Opções do estado: {nome} ({sigla})</h4>
                                                                                        <Row>
                                                                                            <Col sm={12} xs={12}>
                                                                                                <Form.Group className="mb-3">
                                                                                                        {Object.entries(servico.estados_register)
                                                                                                        .filter(([newkey, estado]) => estado.uf === sigla)
                                                                                                        .map(([newkey, estado]) => (  // Aqui é necessário usar key e estado
                                                                                                            <div key={newkey}>
                                                                                                                <Row>
                                                                                                                    <Col sm={2} xs={12}>
                                                                                                                        <Form.Group className="mb-3">
                                                                                                                            <Form.Label>Novo</Form.Label>
                                                                                                                            <div>
                                                                                                                                <Button 
                                                                                                                                    variant={estado.novo ? "success" : "outline-secondary"}
                                                                                                                                    onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "novo", index_child: newkey, value: true })}>
                                                                                                                                    Sim
                                                                                                                                </Button>
                                                                                                                                {' '}
                                                                                                                                <Button 
                                                                                                                                    variant={!estado.novo ? "danger" : "outline-secondary"}
                                                                                                                                    onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "novo", index_child: newkey, value: false })}>
                                                                                                                                    Não
                                                                                                                                </Button>
                                                                                                                            </div>
                                                                                                                        </Form.Group>
                                                                                                                    </Col>
                                                                                                                    <Col sm={2} xs={12}>
                                                                                                                        <Form.Group className="mb-3">
                                                                                                                            <Form.Label>Novo ACM</Form.Label>
                                                                                                                            <div>
                                                                                                                                <Button 
                                                                                                                                    variant={estado.novo_acm ? "success" : "outline-secondary"}
                                                                                                                                    onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "novo_acm", index_child: newkey, value: true })}>
                                                                                                                                    Sim
                                                                                                                                </Button>
                                                                                                                                {' '}
                                                                                                                                <Button 
                                                                                                                                    variant={!estado.novo_acm ? "danger" : "outline-secondary"}
                                                                                                                                    onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "novo_acm", index_child: newkey, value: false })}>
                                                                                                                                    Não
                                                                                                                                </Button>
                                                                                                                            </div>
                                                                                                                        </Form.Group>
                                                                                                                    </Col>
                                                                                                                    <Col sm={2} xs={12}>
                                                                                                                        <Form.Group className="mb-3">
                                                                                                                            <Form.Label>Adequação</Form.Label>
                                                                                                                            <div>
                                                                                                                                <Button 
                                                                                                                                    variant={estado.adequacao ? "success" : "outline-secondary"}
                                                                                                                                    onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "adequacao", index_child: newkey, value: true })}>
                                                                                                                                    Sim
                                                                                                                                </Button>
                                                                                                                                {' '}
                                                                                                                                <Button 
                                                                                                                                    variant={!estado.adequacao ? "danger" : "outline-secondary"}
                                                                                                                                    onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "adequacao", index_child: newkey, value: false })}>
                                                                                                                                    Não
                                                                                                                                </Button>
                                                                                                                            </div>
                                                                                                                        </Form.Group>
                                                                                                                    </Col>
                                                                                                                    <Col sm={2} xs={12}>
                                                                                                                        <Form.Group className="mb-3">
                                                                                                                            <Form.Label>Adequação ACM</Form.Label>
                                                                                                                            <div>
                                                                                                                                <Button 
                                                                                                                                    variant={estado.adequacao_acm ? "success" : "outline-secondary"}
                                                                                                                                    onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "adequacao_acm", index_child: newkey, value: true })}>
                                                                                                                                    Sim
                                                                                                                                </Button>
                                                                                                                                {' '}
                                                                                                                                <Button 
                                                                                                                                    variant={!estado.adequacao_acm ? "danger" : "outline-secondary"}
                                                                                                                                    onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "adequacao_acm", index_child: newkey, value: false })}>
                                                                                                                                    Não
                                                                                                                                </Button>
                                                                                                                            </div>
                                                                                                                        </Form.Group>
                                                                                                                    </Col>
                                                                                                                    <Col sm={2} xs={12}>
                                                                                                                        <Form.Group className="mb-3">
                                                                                                                            <Form.Label>Renovação</Form.Label>
                                                                                                                            <div>
                                                                                                                                <Button 
                                                                                                                                    variant={estado.renovacao ? "success" : "outline-secondary"}
                                                                                                                                    onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "renovacao", index_child: newkey, value: true })}>
                                                                                                                                    Sim
                                                                                                                                </Button>
                                                                                                                                {' '}
                                                                                                                                <Button 
                                                                                                                                    variant={!estado.renovacao ? "danger" : "outline-secondary"}
                                                                                                                                    onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "renovacao", index_child: newkey, value: false })}>
                                                                                                                                    Não
                                                                                                                                </Button>
                                                                                                                            </div>
                                                                                                                        </Form.Group>
                                                                                                                    </Col>
                                                                                                                    <Col sm={2} xs={12}>
                                                                                                                        <Form.Group className="mb-3">
                                                                                                                            <Form.Label>Renovação ACM</Form.Label>
                                                                                                                            <div>
                                                                                                                                <Button 
                                                                                                                                    variant={estado.renovacao_acm ? "success" : "outline-secondary"}
                                                                                                                                    onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "renovacao_acm", index_child: newkey, value: true })}>
                                                                                                                                    Sim
                                                                                                                                </Button>
                                                                                                                                {' '}
                                                                                                                                <Button 
                                                                                                                                    variant={!estado.renovacao_acm ? "danger" : "outline-secondary"}
                                                                                                                                    onClick={(e) => this.handleChangeServico(index, e, "estados_register", {campo: "renovacao_acm", index_child: newkey, value: false })}>
                                                                                                                                    Não
                                                                                                                                </Button>
                                                                                                                            </div>
                                                                                                                        </Form.Group>
                                                                                                                    </Col>
                                                                                                                </Row>
                                                                                                            </div>
                                                                                                        ))}
                                                                                                </Form.Group>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </Form>
                                                                                </Card.Body>
                                                                            </Card>
                                                                            </>
                                                                        ))}
                                                                    </>
                                                                    )}
                                                            </Col>
                                                        </Row>
                                                    </Row>
                                                    <Button variant="success" className="btn-sm" onClick={() => this.salvarServico(index)}><FaCheck className="me-1" /> Salvar Serviço</Button>&nbsp;&nbsp;
                                                    <Button variant="danger" className="btn-sm ms-2" onClick={() => this.removerServico(index)}><FaTimes className="me-1" /> Remover Serviço</Button>
                                                </div>
                                            ))}
                                            <Button variant="secondary" onClick={this.adicionarServico}><FaStream /> Adicionar Serviço</Button>
                                        </Form> 
                                    </Card.Body>                
                                </Card>
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                            {/* Modal Serviços*/}
                            <Modal size="lg" show={this.state.showModalServico} onHide={(e) => this.setState({showModalServico: false})}>
                                <Modal.Header closeButton>
                                    <Modal.Title>{this.state.servico_titulo}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form onSubmit={this.enviaRegistroServico}>
                                        <Row>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Nome</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="servico_nome" 
                                                        required 
                                                        placeholder="Nome" 
                                                        value={this.state.servico_nome} 
                                                        onChange={this.handleChange} 
                                                    />
                                                    <Form.Text id="formNomeHelpBlock" className="text-danger">
                                                        {this.state.servico_nomeHelper}   
                                                    </Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={3} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>
                                                        Ícone (<a href="https://lucide.dev/icons/" target="_blank" rel="noopener noreferrer" style={{textDecoration: 'underline'}}>Lucide</a>)
                                                    </Form.Label>
                                                    <InputGroup>
                                                        <InputGroup.Text>
                                                            <FaSearch />
                                                        </InputGroup.Text>
                                                        <Form.Control 
                                                            type="text" 
                                                            placeholder="Ex: CheckCircle2" 
                                                            name="icon" 
                                                            value={status.icon} 
                                                            onChange={(e) => this.handleChangeStatus(index, e, "icon")} 
                                                        />
                                                    </InputGroup>
                                                </Form.Group>
                                            </Col>

                                            <Col sm={4} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Tipo</Form.Label>
                                                    <Form.Control 
                                                        as="select" 
                                                        name="servico_tipo" 
                                                        value={this.state.servico_tipo} 
                                                        required 
                                                        onChange={this.handleChange}
                                                    >
                                                        <option value="">Tipo</option>
                                                        {Object.entries(tiposServicos).map(([sigla, nome]) => (
                                                            <option key={sigla} value={sigla}>
                                                                {nome}
                                                            </option>
                                                        ))}
                                                    </Form.Control>
                                                    <Form.Text id="formTipoHelpBlock" className="text-danger">
                                                        {this.state.servico_tipoHelper}
                                                    </Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={2} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Valor</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="servico_valor"
                                                        value={this.state.servico_valor ? formatarValor(this.state.servico_valor) : ''} 
                                                        onChange={this.handleChange}
                                                    />
                                                    <Form.Text id="formEanHelpBlock" className="text-danger">
                                                        {this.state.servico_valorHelper}
                                                    </Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={12} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Descrição</Form.Label>
                                                    <Form.Control 
                                                        as="textarea" 
                                                        required 
                                                        placeholder="Descrição" 
                                                        name="servico_descricao"
                                                        value={this.state.servico_descricao} 
                                                        onChange={this.handleChange} 
                                                        className="custom-textarea"
                                                    />
                                                    <Form.Text id="formDescricaoHelpBlock" className="text-danger">
                                                        {this.state.servico_descricaoHelper}
                                                    </Form.Text>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        {this.state.erroLoadRegistro ? (
                                            <Alert variant="warning">
                                                
                                            </Alert>
                                        ) : (
                                            ''
                                        )}
                                        <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                            {this.state.loading ? (
                                                <span className="spinner-border spinner-border-sm"></span>
                                            ) : (
                                                <>
                                                    <FaCheck className="me-1" /> Salvar
                                                </>
                                            )}
                                        </Button>
                                    </Form>
                                </Modal.Body>
                            </Modal>
                        </Tab>
                    )}

                    

                    {this.state.programa_id && hasPerm('add_programas_etapas') && (
                        <Tab eventKey="etapasDoPrograma" title="Etapas">
                            {!this.state.loading ? (
                                <Card className="cardDestaque">
                                    <Card.Body>
                                        <div className="d-flex align-items-center mb-2">
                                            <h4 className="mb-0 me-2">Etapas do Programa</h4>
                                            <Button
                                                variant="link"
                                                className="p-0 text-decoration-none"
                                                onClick={this.handleOpenModalHelpConfigEtapa}
                                                title="Ver documentação das configurações de etapa"
                                                aria-label="Ver documentação das configurações de etapa"
                                            >
                                                <FaQuestionCircle />
                                            </Button>
                                        </div>
                                        <DragDropContext onDragEnd={this.onDragEndEtapas}>
                                            <StrictModeDroppable droppableId="etapas-droppable">
                                                {(provided) => (
                                                    <div ref={provided.innerRef} {...provided.droppableProps}>
                                                        <Accordion>
                                                            {this.state.etapas.map((etapa, index) => (
                                                                <Draggable key={`etapa-${index}`} draggableId={`etapa-${index}`} index={index}>
                                                                    {(provided) => (
                                                                        <div ref={provided.innerRef} {...provided.draggableProps} className="mb-3">
                                                                            <Accordion.Item eventKey={index.toString()} className="border rounded shadow-sm">
                                                                                <Accordion.Header>
                                                                                    <div className="d-flex w-100 align-items-center me-3">
                                                                                        <div className="d-flex align-items-center">
                                                                                            <span {...provided.dragHandleProps} style={{ cursor: 'grab', marginRight: '15px', color: '#6c757d', fontSize: '1.2em' }} title="Clique e arraste para reordenar" onClick={(e) => e.stopPropagation()}>
                                                                                                <FaGripVertical />
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="flex-grow-1">
                                                                                            <span style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>Etapa {index + 1} {etapa.nome ? `- ${etapa.nome}` : ''}</span>
                                                                                        </div>
                                                                                        <div>
                                                                                            <Button variant="outline-primary" size="sm" onClick={(e) => { e.stopPropagation(); this.handleOpenModalConfiguracoes(index); }}> <FaGear className="me-1"/> Configurações Avançadas </Button>
                                                                                        </div>
                                                                                    </div>
                                                                                </Accordion.Header>
                                                                                <Accordion.Body className="bg-light pt-3">
                                                                                    <div className="row-list border-0 shadow-none bg-transparent p-0 m-0">
                                                                                        <Row dataetapa={etapa.id ? etapa.id : index}>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Nome</Form.Label>
                                                            <Form.Control 
                                                                type="text" 
                                                                name="nome" 
                                                                value={etapa.nome} 
                                                                onChange={e => this.handleEtapaChange(index, e)}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={2}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Dias para Próxima Etapa</Form.Label>
                                                            <Form.Control 
                                                                type="number" 
                                                                name="dias_proxima_etapa" 
                                                                value={etapa.dias_proxima_etapa} 
                                                                onChange={e => this.handleEtapaChange(index, e)}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={3}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Avançar Etapa Automaticamente?</Form.Label>
                                                            <Form.Control
                                                                as="select"
                                                                name="avancar_etapa_automaticamente"
                                                                value={etapa.avancar_etapa_automaticamente ? "1" : "0"}
                                                                onChange={e => this.handleSimNaoChange(index, 'avancar_etapa_automaticamente', e)}
                                                            >
                                                                <option key="0" value="0">Não</option>
                                                                <option key="1" value="1">Sim</option>
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Formulário</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregarFormularios}
                                                                defaultOptions
                                                                name="formulario_id"
                                                                placeholder="Buscar formulário..."
                                                                noOptionsMessage={() => "Nenhum formulário encontrado"}
                                                                onChange={e => this.handleEtapaChange(index, e, 'formulario_id')}
                                                                value={etapa.formulario_id ? { value: etapa.formulario_id, label: etapa.formulario_nome } : null}
                                                            />
                                                            {etapa.formulario_id && (
                                                                <ListGroup variant="light" className="mt-2">   
                                                                    <ListGroup.Item action href={`/formularios/edit/${etapa.formulario_id}`} >
                                                                        <FaSearch /> Ver Formulário
                                                                    </ListGroup.Item>    
                                                                </ListGroup>
                                                            )}
                                                        </Form.Group>
                                                    </Col>
                                                    {this.state.status_programa.length > 0 && (
                                                        <Col sm={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Status Vinculado ao Finalizar
                                                                    <OverlayTrigger
                                                                        placement="top"
                                                                        overlay={
                                                                            <Tooltip id="tooltip-explanation">
                                                                                Indica qual status deverá salvar o atendimento quando essa etapa for concluída.
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <span style={{ cursor: 'pointer', marginLeft: '5px' }}>
                                                                            <FaQuestionCircle />
                                                                        </span>
                                                                    </OverlayTrigger>
                                                                </Form.Label>
                                                                <Form.Control as="select" name="status_finalizacao_etapa_id" value={etapa.status_finalizacao_etapa_id} onChange={e => this.handleEtapaChange(index, e)}>
                                                                    <option value="">Selecione um status</option>
                                                                    {this.state.status_programa.map((status) => (
                                                                        <option key={status.id} value={status.id}>{status.nome}</option>
                                                                    ))}
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                    )}
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Formulário de Pesquisa</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregarFormulariosPesquisas}
                                                                defaultOptions
                                                                name="formulario_pesquisa_id"
                                                                placeholder="Buscar formulário de pesquisa..."
                                                                noOptionsMessage={() => "Nenhum formulário encontrado"}
                                                                onChange={e => this.handleEtapaChange(index, e, 'formulario_pesquisa_id')}
                                                                value={etapa.formulario_pesquisa_id ? { value: etapa.formulario_pesquisa_id, label: etapa.formulario_pesquisa_nome } : null}
                                                            />
                                                            {etapa.formulario_pesquisa_id && (
                                                                <ListGroup variant="light" className="mt-2">   
                                                                    <ListGroup.Item action href={`/formularios/edit/${etapa.formulario_pesquisa_id}`} >
                                                                        <FaSearch /> Ver Formulário
                                                                    </ListGroup.Item>    
                                                                </ListGroup>
                                                            )}
                                                        </Form.Group>
                                                    </Col>
                                                    
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Descrição</Form.Label>
                                                            <Form.Control 
                                                                as="textarea" 
                                                                name="descricao" 
                                                                value={etapa.descricao} 
                                                                onChange={e => this.handleEtapaChange(index, e)} 
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                <Col sm={3}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Exige Ação do Navegador Após Prazo?</Form.Label>
                                                        <Form.Control
                                                            as="select"
                                                            name="acao_navegador_apos_prazo"
                                                            value={etapa.acao_navegador_apos_prazo ? "1" : "0"}
                                                            onChange={e => this.handleSimNaoChange(index, 'acao_navegador_apos_prazo', e)}
                                                        >
                                                            <option key="0" value="0">Não</option>
                                                            <option key="1" value="1">Sim</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                    <Col sm={3}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Prazo para Ação do Navegador (horas)</Form.Label>
                                                            <Form.Control type="number" name="prazo_acao_navegador" value={etapa.prazo_acao_navegador} onChange={e => this.handleEtapaChange(index, e)}>
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>                                            
                                                <Row>
                                                    <Col sm={3}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Responsável pelo Preenchimento</Form.Label>
                                                            <Form.Control as="select" name="responsavel_etapa" value={etapa.responsavel_etapa} onChange={e => this.handleEtapaChange(index, e)}>
                                                                <option value="">Selecione o responsável</option>
                                                                {Object.entries(responsaveisEtapas).map(([value, label]) => (
                                                                    <option key={value} value={value}>{label}</option>
                                                                ))}
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={3}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Título de sucesso na finalização</Form.Label>
                                                            <Form.Control 
                                                                type="text" 
                                                                name="titulo_sucesso_finalizacao" 
                                                                value={etapa.titulo_sucesso_finalizacao} 
                                                                onChange={e => this.handleEtapaChange(index, e)}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={3}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Mensagem de sucesso na finalização</Form.Label>
                                                            <Form.Control 
                                                                type="text" 
                                                                name="mensagem_sucesso_finalizacao" 
                                                                value={etapa.mensagem_sucesso_finalizacao} 
                                                                onChange={e => this.handleEtapaChange(index, e)}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Row>
                                                        <Col sm={3}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Etapa de Termo?</Form.Label>
                                                                <Form.Control as="select" name="etapa_termo" value={(etapa.etapa_termo) ? "1" : "0"} onChange={e => this.handleEtapaChange(index, e, 'etapa_termo')}>
                                                                    <option key="0" value="0">Não</option>
                                                                    <option key="1" value="1">Sim</option>
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={3}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Etapa de Nota Fiscal?</Form.Label>
                                                                <Form.Control as="select" name="etapa_nota_fiscal" value={(etapa.etapa_nota_fiscal) ? "1" : "0"} onChange={e => this.handleEtapaChange(index, e, 'etapa_nota_fiscal')}>
                                                                    <option key="0" value="0">Não</option>
                                                                    <option key="1" value="1">Sim</option>
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={3}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Etapa de definição de tipo de paciente?</Form.Label>
                                                                <Form.Control as="select" name="etapa_tipo_paciente" value={(etapa.etapa_tipo_paciente) ? "1" : "0"} onChange={e => this.handleEtapaChange(index, e, 'etapa_tipo_paciente')}>
                                                                    <option key="0" value="0">Não</option>
                                                                    <option key="1" value="1">Sim</option>
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col sm={3}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Criar Ação atendimento?</Form.Label>
                                                                <Form.Control as="select" name="criar_acao_atendimento" value={(etapa.criar_acao_atendimento) ? "1" : "0"} onChange={e => this.handleEtapaChange(index, e, 'criar_acao_atendimento')}>
                                                                    <option key="0" value="0">Não</option>
                                                                    <option key="1" value="1">Sim</option>
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={3}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Ação Texto</Form.Label>
                                                                <Form.Control 
                                                                    type="text" 
                                                                    name="acao_texto" 
                                                                    value={etapa.acao_texto} 
                                                                    onChange={e => this.handleEtapaChange(index, e)}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={6} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Ação</Form.Label>
                                                                <AsyncSelect
                                                                    cacheOptions
                                                                    loadOptions={this.carregarAcoes}
                                                                    defaultOptions
                                                                    name="acao_id"
                                                                    onChange={e => this.handleEtapaChange(index, e, 'acao_id')}
                                                                    placeholder="Buscar ação..."
                                                                    noOptionsMessage={() => "Nenhuma ação encontrada"}
                                                                    value={etapa.acao_id ? { value: etapa.acao_id, label: etapa.acao_nome } : null}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col sm={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Serviços Disponíveis:</Form.Label>
                                                                
                                                                <Form.Check 
                                                                    type="checkbox"
                                                                    id={`servicos_relacionados_bool_${index}`}
                                                                    name="servicos_relacionados_bool"
                                                                    label="Habilitar serviços da etapa"
                                                                    checked={etapa.servicos_relacionados_bool}
                                                                    onChange={e => this.handleEtapaChangeCheck(e.target.checked, index, 'servicos_relacionados_bool')}
                                                                />
                                                                {
                                                                etapa.servicos_relacionados_bool &&
                                                                <>
                                                                    <AsyncSelect
                                                                        key={index}
                                                                        cacheOptions
                                                                        defaultOptions={etapa.opcoesServicos}
                                                                        loadOptions={(inputValue) => this.buscaServicosProcedimentos(inputValue, index)}
                                                                        onFocus={() => this.handleFocusEtapaServicos(index)}
                                                                        onChange={(selectedOption) => this.handleEtapaServicoChange(selectedOption, index)} 
                                                                        value={etapa.servicos_procedimentos}
                                                                        isMulti
                                                                    />
                                                                    <Row>
                                                                        <Col sm={2}>
                                                                            <Form.Check 
                                                                                type="checkbox"
                                                                                id={`servico_obrigatorio_${index}`}
                                                                                name="servico_obrigatorio"
                                                                                label="Obrigatório escolher serviço na etapa"
                                                                                checked={etapa.servico_obrigatorio}
                                                                                className="mt-2"
                                                                                onChange={e => this.handleEtapaChangeCheck(e.target.checked, index, 'servico_obrigatorio')}
                                                                            />
                                                                        </Col>
                                                                        <Col sm={2}>
                                                                            <Form.Check 
                                                                                type="checkbox"
                                                                                id={`servico_fixo_${index}`}
                                                                                name="servico_fixo"
                                                                                label="Serviço fixo"
                                                                                checked={etapa.servico_fixo}
                                                                                className="mt-2"
                                                                                onChange={e => this.handleEtapaChangeCheck(e.target.checked, index, 'servico_fixo')}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                </>
                                                                }                                                            
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    <Col sm={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Ocultar Etapa Para</Form.Label>
                                                            <Row>
                                                                {Object.entries(responsaveisEtapas).map(([id, label]) => (
                                                                    <Col xs={6} sm={2} key={`${id}-${index}`}> {/* Ajuste o tamanho da coluna conforme necessário */}
                                                                        <Form.Check 
                                                                            type="checkbox"
                                                                            id={`ocultar-${id}-${index}`}
                                                                            label={label}
                                                                            checked={etapa.ocultar_etapa.includes(id)}
                                                                            onChange={e => this.handleOcultarEtapaChange(id, e.target.checked, index)}
                                                                        />
                                                                    </Col>
                                                                ))}
                                                            </Row>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Mídias de Contato</Form.Label>
                                                            <Row>
                                                                {Object.keys(MidiasContato).map((midia) => (
                                                                    <Col xs={6} sm={2} key={`${midia}-${index}`}> {/* Ajuste o tamanho da coluna conforme necessário */}
                                                                        <Form.Check 
                                                                            type="checkbox"
                                                                            id={`midia-${midia}-${index}`}
                                                                            label={MidiasContato[midia]}
                                                                            checked={etapa.midias_contato.includes(midia)}
                                                                            onChange={e => this.handleMidiasContatoChange(midia, e.target.checked, index)}
                                                                        />
                                                                    </Col>
                                                                ))}
                                                            </Row>
                                                        </Form.Group>
                                                    </Col>
                                                <Row>
                                                {(etapa.midias_contato.includes('manuseio')  || etapa.alerta_atendimento) && (
                                                    <Col>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Alerta Navegador</Form.Label>
                                                            <Form.Control 
                                                                as="textarea" 
                                                                name="alerta_navegador" 
                                                                value={etapa.alerta_navegador} 
                                                                onChange={e => this.handleEtapaChange(index, e)} 
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                )}
                                                </Row>
                                                </Row>
                                                {/* Condicionais para exibir mais campos */}
                                                {etapa.midias_contato.length > 0 && (
                                                    <>  
                                                        <Row>
                                                            <Row key={index}>
                                                                <Col sm={3}>
                                                                    <Button
                                                                        variant="dark"
                                                                        size="sm"
                                                                        className="mb-2"
                                                                        onClick={() => this.abrirModalTemplates(etapa)}
                                                                    >
                                                                        Templates Whatsapp para Envio Manual
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                            <Col sm={6}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Configurar mensagens</Form.Label>
                                                                    <Col sm={4}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Dias para enviar mensageria</Form.Label>
                                                                            <Form.Control type="number" name="dias_envio_mensageria" value={etapa.dias_envio_mensageria} onChange={e => this.handleEtapaChange(index, e)}>
                                                                            </Form.Control>
                                                                        </Form.Group>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Envia mensageria via cron?</Form.Label>
                                                                            <Form.Control
                                                                                as="select"
                                                                                name="envia_mensageria_cron"
                                                                                value={etapa.envia_mensageria_cron ? "1" : "0"}
                                                                                onChange={e => this.handleSimNaoChange(index, 'envia_mensageria_cron', e)}
                                                                            >
                                                                                <option key="0" value="0">Não</option>
                                                                                <option key="1" value="1">Sim</option>
                                                                            </Form.Control>
                                                                        </Form.Group>
                                                                    </Col>
                                                                    <Row>
                                                                        {Object.keys(tiposMensagem).map((tipo) => (
                                                                            <Col xs={6} sm={2} key={`${tipo}-${index}`}> {/* Ajuste o tamanho da coluna conforme necessário */}
                                                                                <Button
                                                                                    type="button"
                                                                                    id={`tipo-${tipo}-${index}`}
                                                                                    label={tiposMensagem[tipo]}
                                                                                    onClick={() => this.handleTiposMensagemChange(tipo, index)}
                                                                                    className={`custom-btn-outline-primary ${etapa.tipo_mensagem === tipo ? 'active' : ''}`}
                                                                                >
                                                                                    {tiposMensagem[tipo]}
                                                                                </Button>
                                                                            </Col>
                                                                        ))}
                                                                    </Row>
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        {etapa.tipo_mensagem === 'padrao' && (
                                                            <>
                                                                {etapa.midias_contato.includes('whatsapp') && (
                                                                <Row>
                                                                    <Col sm={4}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>ID do Template do Whatsapp</Form.Label>
                                                                            <Form.Control 
                                                                                type="text" 
                                                                                name="whatsapp_template" 
                                                                                value={etapa.whatsapp_template} 
                                                                                onChange={e => this.handleEtapaChange(index, e)}
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                                )}
                                                                <Row>
                                                                    <Col sm={3}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Tipo do Envio</Form.Label>
                                                                            <Form.Control as="select" name="tipo_envio" value={etapa.tipo_envio} onChange={e => this.handleEtapaChange(index, e)}>
                                                                                <option value="">Selecione o tipo de envio</option>
                                                                                {Object.entries(tiposEnvio).map(([value, label]) => (
                                                                                    <option key={value} value={value}>{label}</option>
                                                                                ))}
                                                                            </Form.Control>
                                                                        </Form.Group>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Momento do Envio</Form.Label>
                                                                            <Form.Control as="select" name="momento_envio" value={etapa.momento_envio} onChange={e => this.handleEtapaChange(index, e)}>
                                                                                <option value="">Selecione o momento do envio</option>
                                                                                {Object.entries(momentosEnvio).map(([value, label]) => (
                                                                                    <option key={value} value={value}>{label}</option>
                                                                                ))}
                                                                            </Form.Control>
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Destinatário da Mensagem</Form.Label>
                                                                            <Form.Control as="select" name="destinatario_mensagem" value={etapa.destinatario_mensagem} onChange={e => this.handleEtapaChange(index, e)}>
                                                                                <option value="">Selecione o destinatário</option>
                                                                                {Object.entries(destinatariosMensagem).map(([value, label]) => (
                                                                                    <option key={value} value={value}>{label}</option>
                                                                                ))}
                                                                            </Form.Control>
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Conteúdo do SMS</Form.Label>
                                                                            <Form.Control
                                                                                as="textarea"
                                                                                name="conteudo_mensagem"
                                                                                value={etapa.conteudo_mensagem}
                                                                                onChange={e => this.handleEtapaChange(index, e)}
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Conteúdo do E-mail</Form.Label>
                                                                            <Form.Control
                                                                                as="textarea"
                                                                                name="conteudo_mensagem_email"
                                                                                value={etapa.conteudo_mensagem_email}
                                                                                onChange={e => this.handleEtapaChange(index, e)}
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        )}
                                                        
                                                        {etapa.tipo_mensagem === 'retorno' && (
                                                            <>
                                                                {etapa.midias_contato.includes('whatsapp') && (
                                                                <Row>
                                                                    <Col sm={4}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Retorno Whatsapp Template</Form.Label>
                                                                            <Form.Control
                                                                                type="text"
                                                                                name="cancelamento_retorno_whatsapp_template"
                                                                                value={etapa.cancelamento_retorno_whatsapp_template}
                                                                                onChange={e => this.handleEtapaChange(index, e)}
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                                )}
                                                                <Row>
                                                                    <Col>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Retorno Destinatário da Mensagem</Form.Label>
                                                                            <Form.Control as="select" name="cancelamento_retorno_destinatario_mensagem" value={etapa.cancelamento_retorno_destinatario_mensagem} onChange={e => this.handleEtapaChange(index, e)}>
                                                                                <option value="">Selecione o destinatário</option>
                                                                                {Object.entries(destinatariosMensagem).map(([value, label]) => (
                                                                                    <option key={value} value={value}>{label}</option>
                                                                                ))}
                                                                            </Form.Control>
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Retorno Conteúdo da Mensagem (SMS)</Form.Label>
                                                                            <Form.Control
                                                                                as="textarea"
                                                                                name="cancelamento_retorno_conteudo_mensagem"
                                                                                value={etapa.cancelamento_retorno_conteudo_mensagem}
                                                                                onChange={e => this.handleEtapaChange(index, e)}
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Retorno Título do Email</Form.Label>
                                                                            <Form.Control
                                                                                type="text"
                                                                                name="cancelamento_retorno_titulo_email"
                                                                                value={etapa.cancelamento_retorno_titulo_email}
                                                                                onChange={e => this.handleEtapaChange(index, e)}
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Retorno Conteúdo Mensagem do Email</Form.Label>
                                                                            <Form.Control
                                                                                as="textarea"
                                                                                name="cancelamento_retorno_conteudo_mensagem_email"
                                                                                value={etapa.cancelamento_retorno_conteudo_mensagem_email}
                                                                                onChange={e => this.handleEtapaChange(index, e)}
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        )}
                                                        {etapa.tipo_mensagem === 'cancelamento' && (
                                                            <>
                                                                {etapa.midias_contato.includes('whatsapp') && (
                                                                <Row>
                                                                    <Col sm={4}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Cancelamento Whatsapp Template</Form.Label>
                                                                            <Form.Control
                                                                                type="text"
                                                                                name="cancelamento_whatsapp_template"
                                                                                value={etapa.cancelamento_whatsapp_template}
                                                                                onChange={e => this.handleEtapaChange(index, e)}
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                                )}
                                                                <Row>
                                                                    <Col>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Cancelamento Destinatário da Mensagem</Form.Label>
                                                                            <Form.Control as="select" name="cancelamento_destinatario_mensagem" value={etapa.cancelamento_destinatario_mensagem} onChange={e => this.handleEtapaChange(index, e)}>
                                                                                <option value="">Selecione o destinatário</option>
                                                                                {Object.entries(destinatariosMensagem).map(([value, label]) => (
                                                                                    <option key={value} value={value}>{label}</option>
                                                                                ))}
                                                                            </Form.Control>
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Cancelamento Conteúdo da Mensagem (SMS)</Form.Label>
                                                                            <Form.Control
                                                                                as="textarea"
                                                                                name="cancelamento_conteudo_mensagem"
                                                                                value={etapa.cancelamento_conteudo_mensagem}
                                                                                onChange={e => this.handleEtapaChange(index, e)}
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Cancelamento Título do Email</Form.Label>
                                                                            <Form.Control
                                                                                type="text"
                                                                                name="cancelamento_titulo_email"
                                                                                value={etapa.cancelamento_titulo_email}
                                                                                onChange={e => this.handleEtapaChange(index, e)}
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Cancelamento Conteúdo Mensagem do Email</Form.Label>
                                                                            <Form.Control
                                                                                as="textarea"
                                                                                name="cancelamento_conteudo_mensagem_email"
                                                                                value={etapa.cancelamento_conteudo_mensagem_email}
                                                                                onChange={e => this.handleEtapaChange(index, e)}
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                                <Row>
                                                    <Col sm={4}>
                                                        <Button variant="success" className="btn-sm" onClick={() => this.salvarEtapa(index)}><FaCheck className="me-1" /> Salvar Etapa</Button>&nbsp;
                                                        <Button variant="danger" className="btn-sm ms-2" onClick={() => this.removerEtapa(index)}><FaTimes className="me-1" /> Remover Etapa</Button>
                                                    </Col>
                                                    <Col sm={8}>
                                                    </Col>
                                                </Row>
                                            </div>
                                                                                </Accordion.Body>
                                                                            </Accordion.Item>
                                                                        </div>
                                                                    )}
                                                                </Draggable>
                                                            ))}
                                                        </Accordion>
                                                        {provided.placeholder}
                                                    </div>
                                                )}
                                            </StrictModeDroppable>
                                        </DragDropContext>
                                        <Button variant="secondary" onClick={this.adicionarEtapa}><FaStream /> Adicionar Etapa</Button>
                                    </Card.Body>               
                                </Card>
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                            {/* Modal Etapas*/}
                            <Modal size="lg" show={this.state.showModalTemplate} onHide={() => this.setState({showModalTemplate: false})}>
                                <Modal.Header closeButton>
                                    <Modal.Title>
                                        {this.state.template_titulo}
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="mb-3" style={{ fontSize: '0.9rem' }}>
                                        <strong>{this.state.etapaSelecionada?.nome && `Etapa: ${this.state.etapaSelecionada.nome}`}</strong>
                                    </div>
                                    <Form>
                                        {this.state.templates.map((template, index) => (
                                            <div key={index} className="border rounded p-3 mb-3">
                                                <Row>
                                                    <Col sm={6} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Título</Form.Label>
                                                            <Form.Control 
                                                                type="text" 
                                                                name="titulo" 
                                                                required 
                                                                placeholder="Título" 
                                                                value={template.titulo} 
                                                                onChange={(e) => this.handleChangeTemplate(index, e)} 
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={6} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Nome de Template</Form.Label>
                                                            <Form.Control 
                                                                type="text" 
                                                                name="template" 
                                                                required 
                                                                placeholder="Nome" 
                                                                value={template.template} 
                                                                onChange={(e) => this.handleChangeTemplate(index, e)} 
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Destinatário</Form.Label>
                                                            <Form.Control as="select" name="destinatario" value={template.destinatario} onChange={(e) => this.handleChangeTemplate(index, e)}>
                                                                <option value="">Selecione o Destinatário</option>
                                                                {Object.entries(destinatariosMensagem).map(([value, label]) => (
                                                                    <option key={value} value={value}>{label}</option>
                                                                ))}
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm={4}>
                                                        <Button variant="success" className="btn-sm" onClick={(e) => this.enviaTemplate(index, e)}><FaCheck className="me-1" /> Salvar Template</Button>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <Button variant="danger" className="btn-sm ms-2" onClick={() => this.excluirTemplate(index)}><FaTimes className="me-1" /> Remover Template</Button>
                                                    </Col>
                                                </Row>
                                            </div>
                                        ))}
                                        <Button variant="secondary" onClick={this.adicionarTemplate}><FaStream /> Adicionar Template</Button>
                                    </Form>
                                </Modal.Body>
                            </Modal>

                            <Modal show={this.state.showModalConfiguracoes} onHide={this.fecharModalConfiguracoes} size="xl" backdrop="static">
                                <Modal.Header closeButton>
                                    <Modal.Title className="d-flex align-items-center">
                                        Configurações da Etapa
                                        <FaQuestionCircle 
                                            className="ms-2 text-primary" 
                                            style={{ cursor: 'pointer', fontSize: '1.2rem' }} 
                                            onClick={this.handleOpenModalHelpConfigEtapa}
                                            title="Ver Documentação Avançada"
                                        />
                                    </Modal.Title>
                                </Modal.Header>

                                <Modal.Body>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Configurações (JSON)</Form.Label>
                                        {this.state.configuracoesJsonError && (
                                            <Alert variant="danger" className="py-1 mb-2"> {this.state.configuracoesJsonError}</Alert>
                                        )}

                                        <Editor
                                            height="300px"
                                            defaultLanguage="json"
                                            value={this.state.configuracoesJson}
                                            onChange={(value) =>
                                                this.setState({
                                                    configuracoesJson: value || '',
                                                    configuracoesJsonError: '',
                                                })
                                            }
                                            theme="vs-dark"
                                            options={{
                                                minimap: { enabled: false },
                                                fontSize: 14,
                                                automaticLayout: true,
                                            }}
                                        />
                                    </Form.Group>
                                </Modal.Body>

                                <Modal.Footer>
                                    <Button variant="secondary" onClick={this.fecharModalConfiguracoes}>
                                        Cancelar
                                    </Button>

                                    <Button variant="success" onClick={this.salvarConfiguracoesEtapa}>
                                        <FaCheck className="me-1" /> Salvar
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <Modal show={this.state.showModalHelpConfigEtapa} onHide={this.handleCloseModalHelpConfigEtapa} size="lg" style={{ zIndex: 1060 }}>
                                <Modal.Header closeButton>
                                    <Modal.Title><FaQuestionCircle className="me-2 text-primary" /> Documentação: Configurações</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p>As configurações de etapa utilizam um objeto <b>JSON</b> para injetar regras e comportamentos customizados na timeline de atendimentos do paciente. Certifique-se de digitar/colar o JSON em formato válido (com aspas duplas nas chaves).</p>
                                    <hr />

                                    {this.getEtapaConfigDocsSections().map((section, index) => (
                                        <div key={section.keyName} className={index > 0 ? 'mt-4' : ''}>
                                            <h5>{index + 1}. {section.title} (<code>{section.keyName}</code>)</h5>
                                            <p>{section.description}</p>
                                            <pre className="bg-dark text-light p-3 rounded">
{section.example}
                                            </pre>
                                            {section.note && (
                                                <p className="text-muted small mb-0">{section.note}</p>
                                            )}
                                        </div>
                                    ))}
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={this.handleCloseModalHelpConfigEtapa}>
                                        Fechar e Entendi
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                        </Tab>
                    )}
                    {this.state.programa_id && hasPerm('add_programas_produtos') && (
                        <Tab eventKey="produtosDoPrograma" title="Produtos">
                            {!this.state.loading ? (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Form onSubmit={this.enviaProdutosPrograma}>
                                            <h4>Produtos do Programa</h4>
                                            {this.state.produtos.map((produto, index) => (
                                                <div key={index} className="row-list">
                                                    <Row>
                                                        <Col sm={6}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Produto</Form.Label>
                                                                <AsyncSelect
                                                                    cacheOptions
                                                                    loadOptions={this.carregarProdutos}
                                                                    defaultOptions
                                                                    name="produto_id"
                                                                    placeholder="Buscar produto..."
                                                                    noOptionsMessage={() => "Nenhum produto encontrado"}
                                                                    onChange={e => this.handleProdutoChange(index, e, 'produto_id')}
                                                                    value={produto.produto_id ? { value: produto.produto_id, label: produto.produto_nome } : null}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={6}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Valor</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="valor"
                                                                    value={produto.valor} 
                                                                    onChange={e => this.handleProdutoChange(index, e, 'valor')}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        
                                                    </Row>
                                                    <Button variant="success" className="btn-sm" onClick={() => this.salvarProduto(index)}><FaCheck className="me-1" /> Salvar Produto</Button>
                                                    <Button variant="danger" className="btn-sm ms-2" onClick={() => this.removerProduto(index)}><FaTimes className="me-1" /> Remover Produto</Button>
                                                </div>
                                            ))}
                                            <Button variant="secondary" onClick={this.adicionarProduto}><FaStream /> Adicionar Produto</Button>
                                        </Form> 
                                    </Card.Body>                
                                </Card>
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}

                    {this.state.programa_id && hasPerm('add_programas_botoes') && (
                        <Tab eventKey="botoesDoPrograma" title="Botões Atendimento">
                            {!this.state.loading ? (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Form>
                                            <h4>Botões Atendimento</h4>
                                            {this.state.botoes_atendimento.map((botao, index) => (
                                            <div key={index} className="row-list">
                                                <Row>                                                
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Título</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="titulo"
                                                                value={botao.titulo} 
                                                                onChange={e => this.handleBotaoAtendimentoChange(index, e, 'titulo')}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Formulário</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregarFormularios}
                                                                defaultOptions
                                                                name="formulario_id"
                                                                placeholder="Buscar formulário..."
                                                                noOptionsMessage={() => "Nenhum formulário encontrado"}
                                                                onChange={e => this.handleBotaoAtendimentoChange(index, e, 'formulario_id')}
                                                                value={botao.formulario_id ? { value: botao.formulario_id, label: botao.formulario_nome } : null}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Descrição</Form.Label>
                                                            <Form.Control 
                                                                as="textarea"                                                             
                                                                placeholder="Descrição" 
                                                                name="descricao"
                                                                value={botao.descricao} 
                                                                onChange={e => this.handleBotaoAtendimentoChange(index, e, 'descricao')}
                                                                rows={3}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Callback</Form.Label>
                                                            <Form.Control 
                                                                type="text"                                                             
                                                                name="callback_funcao"
                                                                value={botao.callback_funcao} 
                                                                onChange={e => this.handleBotaoAtendimentoChange(index, e, 'callback_funcao')}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Restringir para Usuário</Form.Label>
                                                            <Form.Control as="select" name="tipo_usuario" value={botao.tipo_usuario} onChange={e => this.handleBotaoAtendimentoChange(index, e, 'tipo_usuario')}>
                                                                <option value="">Selecione o responsável</option>
                                                                {Object.entries(tiposUsuarioBotoes).map(([value, label]) => (
                                                                    <option key={value} value={value}>{label}</option>
                                                                ))}
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={2} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Exibir botão de monitoria?</Form.Label>
                                                            <div>
                                                                <Button 
                                                                    name="exibir_botao_monitoria"
                                                                    variant={botao.exibir_botao_monitoria ? "success" : "outline-secondary"}
                                                                    onClick={e => this.handleBotaoAtendimentoChange(index, e, 'exibir_botao_monitoria', true)}>
                                                                    Sim
                                                                </Button>
                                                                {' '}
                                                                <Button 
                                                                    name="exibir_botao_monitoria"
                                                                    variant={!botao.exibir_botao_monitoria ? "danger" : "outline-secondary"}
                                                                    onClick={e => this.handleBotaoAtendimentoChange(index, e, 'exibir_botao_monitoria', false)}>
                                                                    Não
                                                                </Button>
                                                            </div>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={2} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Exibir como aba?</Form.Label>
                                                            <div>
                                                                <Button 
                                                                    name="exibir_aba"
                                                                    variant={botao.exibir_aba ? "success" : "outline-secondary"}
                                                                    onClick={e => this.handleBotaoAtendimentoChange(index, e, 'exibir_aba', true)}>
                                                                    Sim
                                                                </Button>
                                                                {' '}
                                                                <Button 
                                                                    name="exibir_aba"
                                                                    variant={!botao.exibir_aba ? "danger" : "outline-secondary"}
                                                                    onClick={e => this.handleBotaoAtendimentoChange(index, e, 'exibir_aba', false)}>
                                                                    Não
                                                                </Button>
                                                            </div>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={2} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Envia formulário por e-mail?</Form.Label>
                                                            <div>
                                                                <Button 
                                                                    name="envia_email"
                                                                    variant={botao.envia_email ? "success" : "outline-secondary"}
                                                                    onClick={e => this.handleBotaoAtendimentoChange(index, e, 'envia_email', true)}>
                                                                    Sim
                                                                </Button>
                                                                {' '}
                                                                <Button 
                                                                    name="envia_email"
                                                                    variant={!botao.envia_email ? "danger" : "outline-secondary"}
                                                                    onClick={e => this.handleBotaoAtendimentoChange(index, e, 'envia_email', false)}>
                                                                    Não
                                                                </Button>
                                                            </div>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                {botao.envia_email && (
                                                    <Card className="cardDestaque">
                                                        <Card.Body>                    
                                                            <Row>
                                                                <h4>Formulário de E-mail</h4>
                                                                <Col sm={6} xs={12}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>Título</Form.Label>
                                                                        <Form.Control 
                                                                            type="text"                                                             
                                                                            name="email_titulo"
                                                                            value={botao.email_titulo} 
                                                                            onChange={e => this.handleBotaoAtendimentoChange(index, e, 'email_titulo')}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col sm={6} xs={12}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>Destinatários</Form.Label>
                                                                        <Form.Control 
                                                                            type="text"                                                             
                                                                            name="email_enderecos"
                                                                            value={botao.email_enderecos} 
                                                                            onChange={e => this.handleBotaoAtendimentoChange(index, e, 'email_enderecos')}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col sm={12} xs={12}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>Conteúdo do e-mail</Form.Label>
                                                                        <ReactQuill
                                                                            value={botao.email_conteudo}
                                                                            name="email_conteudoo"
                                                                            onChange={e => this.handleBotaoAtendimentoChange(index, e, 'email_conteudo')}
                                                                            theme="snow" // Tema do editor, pode ser "snow" ou "bubble"
                                                                            modules={{
                                                                                toolbar: [
                                                                                [{ header: '1' }, { header: '2' }, { font: [] }],
                                                                                [{ list: 'ordered' }, { list: 'bullet' }],
                                                                                ['bold', 'italic', 'underline'],
                                                                                ['link', 'image'],
                                                                                [{ align: [] }],
                                                                                ['clean'],
                                                                                ],
                                                                            }}
                                                                            placeholder="Digite seu conteúdo aqui"
                                                                            className="form-control"
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                            </Row>
                                                        </Card.Body>
                                                    </Card>
                                                )}
                                                <Button variant="success" className="btn-sm" onClick={() => this.salvarBotoesAtendimento(index)}><FaCheck className="me-1" /> Salvar Botão</Button>&nbsp;&nbsp;
                                                <Button variant="danger" className="btn-sm ms-2" onClick={() => this.removerBotao(index)}><FaTimes className="me-1" /> Remover Botão</Button>
                                            </div>
                                            ))}
                                            <Button variant="secondary" onClick={this.adicionarBotao}><FaStream /> Adicionar Botão</Button>
                                        </Form> 
                                    </Card.Body>                
                                </Card>
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}

                    {this.state.programa_id && hasPerm('add_programas_colunas_atendimento') && (
                        <Tab eventKey="colunasDoPrograma" title="Colunas Atendimento">
                            {!this.state.loading ? (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Form>
                                            <h4>Colunas de Atendimento</h4>
                                            {this.state.colunas_atendimento_padrao.map((coluna, index) => (
                                                <div key={index} className="row-list">
                                                    <Card className="cardDestaque">
                                                        <Card.Body>      
                                                            <h4> Coluna: {coluna.nome} - <span title="Clique para editar o campo" style={{cursor: "pointer"}} onClick={(e) => this.handleColunaAtendimentoChange(index, e, "show", coluna.show)}>Editar {coluna.id ? `(${coluna.id})` : ""}<FaEdit/> </span></h4> 
                                                            <div style={{display: coluna.show ? "block" : "none"}}>
                                                                <Row>                                                
                                                                    <Col sm={4}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Nome</Form.Label>
                                                                            <Form.Control
                                                                                type="text"
                                                                                name="nome"
                                                                                value={coluna.nome} 
                                                                                onChange={e => this.handleColunaAtendimentoChange(index, e, 'nome')}
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                    <Col sm={4}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Slug</Form.Label>
                                                                            <Form.Control
                                                                                type="text"
                                                                                name="slug"
                                                                                value={coluna.slug}
                                                                                disabled 
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                    <Col sm={2}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Ordem</Form.Label>
                                                                            <Form.Control
                                                                                type="number"
                                                                                name="ordem"
                                                                                value={coluna.ordem} 
                                                                                onChange={e => this.handleColunaAtendimentoChange(index, e, 'ordem')}
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                    <Col sm={2}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Visualizar Campo?</Form.Label>
                                                                            <div>
                                                                                <Button 
                                                                                    variant={coluna.exibir_campo ? "success" : "outline-secondary"}
                                                                                    onClick={(e) => this.handleColunaAtendimentoChange(index, e, 'exibir_campo', true)}>
                                                                                    Sim
                                                                                </Button>
                                                                                {' '}
                                                                                <Button 
                                                                                    variant={!coluna.exibir_campo ? "danger" : "outline-secondary"}
                                                                                    onClick={(e) => this.handleColunaAtendimentoChange(index, e, 'exibir_campo', false)}>
                                                                                    Não
                                                                                </Button>
                                                                            </div>
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                                <Button variant="error" className="btn-sm ms-2 btn btn-danger" onClick={(e) => this.handleColunaAtendimentoChange(index, e, "show", coluna.show)}><FaCheck className="me-1" /> Cancelar</Button>&nbsp;&nbsp;
                                                                <Button variant="success" className="btn-sm" onClick={() => this.salvarColunaAtendimento(coluna)}><FaCheck className="me-1" /> Salvar Coluna</Button>&nbsp;&nbsp;
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                </div>
                                            ))}
                                        </Form> 
                                    </Card.Body>                
                                </Card>
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}

                    {this.state.programa_id && hasPerm('add_programas_filtros_atendimento') && (
                        <Tab eventKey="filtrosDoPrograma" title="Filtros Atendimento">
                            {!this.state.loading ? (
                                <>
                                    <Card className="cardDestaque">
                                        <Card.Body>                    
                                            <Form>
                                                <h4>Filtros de Atendimento Rápido</h4>
                                                {this.state.filtros_atendimento_padrao.filter(f => f.tipo === 'filtro_rapido').map((filtro, index) => {
                                                    const filtroIndex = index;
                                                    return (
                                                        <div key={filtroIndex} className="row-list">
                                                            <Card className="cardDestaque">
                                                                <Card.Body>      
                                                                    <h4> Filtro: {filtro.nome} - <span title="Clique para editar o filtro" style={{cursor: "pointer"}} onClick={(e) => this.handleFiltroAtendimentoChange(filtroIndex, e, "show", filtro.show)}>Editar {filtro.id ? `(${filtro.id})` : ""}<FaEdit/> </span></h4> 
                                                                    <div style={{display: filtro.show ? "block" : "none"}}>
                                                                        <Row>                                                
                                                                            <Col sm={4}>
                                                                                <Form.Group className="mb-3">
                                                                                    <Form.Label>Nome</Form.Label>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        name="nome"
                                                                                        value={filtro.nome} 
                                                                                        onChange={e => this.handleFiltroAtendimentoChange(filtroIndex, e, 'nome')}
                                                                                    />
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Col sm={2}>
                                                                                <Form.Group className="mb-3">
                                                                                    <Form.Label>Slug</Form.Label>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        name="slug"
                                                                                        value={filtro.slug}
                                                                                        disabled 
                                                                                    />
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Col sm={2}>
                                                                                <Form.Group className="mb-3">
                                                                                    <Form.Label>Ordem</Form.Label>
                                                                                    <Form.Control
                                                                                        type="number"
                                                                                        name="ordem"
                                                                                        value={filtro.ordem} 
                                                                                        onChange={e => this.handleFiltroAtendimentoChange(filtroIndex, e, 'ordem')}
                                                                                    />
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Col sm={2}>
                                                                                <Form.Group className="mb-3">
                                                                                    <Form.Label>Visualizar Filtro?</Form.Label>
                                                                                    <div>
                                                                                        <Button 
                                                                                            variant={filtro.exibir_filtro ? "success" : "outline-secondary"}
                                                                                            onClick={(e) => this.handleFiltroAtendimentoChange(filtroIndex, e, 'exibir_filtro', true)}>
                                                                                            Sim
                                                                                        </Button>
                                                                                        {' '}
                                                                                        <Button 
                                                                                            variant={!filtro.exibir_filtro ? "danger" : "outline-secondary"}
                                                                                            onClick={(e) => this.handleFiltroAtendimentoChange(filtroIndex, e, 'exibir_filtro', false)}>
                                                                                            Não
                                                                                        </Button>
                                                                                    </div>
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Col sm={2}>
                                                                                <Form.Group className="mb-3">
                                                                                    <Form.Label>Filtro Padrão?</Form.Label>
                                                                                    <div>
                                                                                        <Button 
                                                                                            variant={filtro.padrao ? "success" : "outline-secondary"}
                                                                                            onClick={(e) => this.handleFiltroAtendimentoChange(filtroIndex, e, 'padrao', true)}>
                                                                                            Sim
                                                                                        </Button>
                                                                                        {' '}
                                                                                        <Button 
                                                                                            variant={!filtro.padrao ? "danger" : "outline-secondary"}
                                                                                            onClick={(e) => this.handleFiltroAtendimentoChange(filtroIndex, e, 'padrao', false)}>
                                                                                            Não
                                                                                        </Button>
                                                                                    </div>
                                                                                </Form.Group>
                                                                            </Col>
                                                                        </Row>
                                                                        <Button variant="error" className="btn-sm ms-2 btn btn-danger" onClick={(e) => this.handleFiltroAtendimentoChange(filtroIndex, e, "show", filtro.show)}><FaCheck className="me-1" /> Cancelar</Button>&nbsp;&nbsp;
                                                                        <Button variant="success" className="btn-sm" onClick={() => this.salvarFiltroAtendimento(filtro)}><FaCheck className="me-1" /> Salvar Filtro</Button>&nbsp;&nbsp;
                                                                    </div>
                                                                </Card.Body>
                                                            </Card>
                                                        </div>
                                                    )

                                                })}
                                            </Form> 
                                        </Card.Body>           
                                    </Card>
                                    <Card className="cardDestaque">
                                        <Card.Body>                    
                                            <Form>
                                                <h4>Filtros de Atendimento Avançado</h4>
                                                {this.state.filtros_atendimento_padrao.filter(f => f.tipo === 'filtro_avancado').map((filtro, index) => {
                                                    const filtroIndex = this.state.filtros_atendimento_padrao.filter(f => f.tipo === 'filtro_rapido').length + index;
                                                    return (
                                                        <div key={filtroIndex} className="row-list">
                                                            <Card className="cardDestaque">
                                                                <Card.Body>      
                                                                    <h4> Filtro: {filtro.nome} - <span title="Clique para editar o filtro" style={{cursor: "pointer"}} onClick={(e) => this.handleFiltroAtendimentoChange(filtroIndex, e, "show", filtro.show)}>Editar {filtro.id ? `(${filtro.id})` : ""}<FaEdit/> </span></h4> 
                                                                    <div style={{display: filtro.show ? "block" : "none"}}>
                                                                        <Row>                                                
                                                                            <Col sm={4}>
                                                                                <Form.Group className="mb-3">
                                                                                    <Form.Label>Nome</Form.Label>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        name="nome"
                                                                                        value={filtro.nome} 
                                                                                        onChange={e => this.handleFiltroAtendimentoChange(filtroIndex, e, 'nome')}
                                                                                    />
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Col sm={4}>
                                                                                <Form.Group className="mb-3">
                                                                                    <Form.Label>Slug</Form.Label>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        name="slug"
                                                                                        value={filtro.slug}
                                                                                        disabled 
                                                                                    />
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Col sm={2}>
                                                                                <Form.Group className="mb-3">
                                                                                    <Form.Label>Ordem</Form.Label>
                                                                                    <Form.Control
                                                                                        type="number"
                                                                                        name="ordem"
                                                                                        value={filtro.ordem} 
                                                                                        onChange={e => this.handleFiltroAtendimentoChange(filtroIndex, e, 'ordem')}
                                                                                    />
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Col sm={2}>
                                                                                <Form.Group className="mb-3">
                                                                                    <Form.Label>Visualizar Filtro?</Form.Label>
                                                                                    <div>
                                                                                        <Button 
                                                                                            variant={filtro.exibir_filtro ? "success" : "outline-secondary"}
                                                                                            onClick={(e) => this.handleFiltroAtendimentoChange(filtroIndex, e, 'exibir_filtro', true)}>
                                                                                            Sim
                                                                                        </Button>
                                                                                        {' '}
                                                                                        <Button 
                                                                                            variant={!filtro.exibir_filtro ? "danger" : "outline-secondary"}
                                                                                            onClick={(e) => this.handleFiltroAtendimentoChange(filtroIndex, e, 'exibir_filtro', false)}>
                                                                                            Não
                                                                                        </Button>
                                                                                    </div>
                                                                                </Form.Group>
                                                                            </Col>
                                                                        </Row>
                                                                        <Button variant="error" className="btn-sm ms-2 btn btn-danger" onClick={(e) => this.handleFiltroAtendimentoChange(filtroIndex, e, "show", filtro.show)}><FaCheck className="me-1" /> Cancelar</Button>&nbsp;&nbsp;
                                                                        <Button variant="success" className="btn-sm" onClick={() => this.salvarFiltroAtendimento(filtro)}><FaCheck className="me-1" /> Salvar Filtro</Button>&nbsp;&nbsp;
                                                                    </div>
                                                                </Card.Body>
                                                            </Card>
                                                        </div>
                                                    )
                                                })}
                                            </Form> 
                                        </Card.Body>                
                                    </Card>
                                </>
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}

                    {this.state.programa_id && hasPerm('add_programas_dicas') && (
                        <Tab eventKey="dicasDoPrograma" title="Dicas">
                            {!this.state.loading ? (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Form>
                                            <h4>Dicas do Programa</h4>
                                            {this.state.dicas.map((dica, index) => (
                                                <div key={index} className="row-list">
                                                    <Row>
                                                        <Col sm={6}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Título</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="titulo"
                                                                    value={dica.titulo} 
                                                                    onChange={e => this.handleDicasChange(index, e, 'titulo')}
                                                                />
                                                            </Form.Group>
                                                        </Col>                                                    
                                                        <Col sm={6}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Imagem</Form.Label>
                                                                <Form.Control 
                                                                    type="file" 
                                                                    name="imagem" 
                                                                    onChange={e => this.handleDicasChange(index, e, 'imagem_upload')}
                                                                    ref={this.fileInput} 
                                                                />
                                                                {dica.imagem && (
                                                                    <div>
                                                                        <img src={dica.imagem} alt="Imagem Atual" style={{ maxWidth: '100px', marginTop: '10px' }} />
                                                                    </div>
                                                                )}
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={4} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Categoria</Form.Label>
                                                                <Form.Control as="select" name="categoria" value={dica.categoria} onChange={e => this.handleDicasChange(index, e, 'categoria')}>
                                                                    <option value="">Categoria da Dica</option>
                                                                    {Object.entries(categoriasDeDicas).map(([sigla, nome]) => (
                                                                        <option key={sigla} value={sigla}>{nome}</option>
                                                                    ))}
                                                                </Form.Control>
                                                                <Form.Text id="formCategoriaHelpBlock" className="text-danger">{this.state.categoriaHelper}</Form.Text>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={12} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Descrição <span style={{ color: 'red' }}> *</span></Form.Label>
                                                                <Form.Control 
                                                                    as="textarea" 
                                                                    required 
                                                                    placeholder="Descrição" 
                                                                    name="descricao"
                                                                    value={dica.descricao} 
                                                                    onChange={e => this.handleDicasChange(index, e, 'descricao')}
                                                                    rows={3}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    <Button variant="success" className="btn-sm" onClick={() => this.salvarDica(index)}><FaCheck className="me-1" /> Salvar Dica</Button>&nbsp;&nbsp;
                                                    <Button variant="danger" className="btn-sm ms-2" onClick={() => this.removerDica(index)}><FaTimes className="me-1" /> Remover Dica</Button>
                                                </div>
                                            ))}
                                            <Button variant="secondary" onClick={this.adicionarDica}><FaStream /> Adicionar Dica</Button>
                                        </Form> 
                                    </Card.Body>                
                                </Card>
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}

                    {this.state.programa_id && hasPerm('add_programas_graficos') && (
                        <Tab eventKey="GraficosPrograma" title="Gráficos">
                            {!this.state.loading ? (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Form>
                                            <h4>Gráficos do Programa</h4>
                                            {this.state.graficos.map((grafico, index) => (
                                                <div key={index} className="row-list">
                                                    <Row>
                                                        <Col sm={6}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Título do gráfico</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="titulo_grafico"
                                                                    value={grafico.titulo_grafico} 
                                                                    onChange={e => this.handleGraficosChange(index, e, 'titulo_grafico')}
                                                                />
                                                            </Form.Group>
                                                        </Col>                                                                                                        
                                                        <Col sm={4} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Categoria</Form.Label>
                                                                <Form.Control as="select" name="categoria" value={grafico.categoria} onChange={e => this.handleGraficosChange(index, e, 'categoria')}>
                                                                    <option value="">Categoria</option>
                                                                    {Object.entries(categoriasDeGraficos).map(([sigla, nome]) => (
                                                                        <option key={sigla} value={sigla}>{nome}</option>
                                                                    ))}
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>                                                    
                                                    </Row>
                                                    <Button variant="success" className="btn-sm" onClick={() => this.salvarGrafico(index)}><FaCheck className="me-1" /> Salvar Gráfico</Button>&nbsp;&nbsp;
                                                    <Button variant="danger" className="btn-sm ms-2" onClick={() => this.removerGrafico(index)}><FaTimes className="me-1" /> Remover Gráfico</Button>
                                                </div>
                                            ))} 
                                            <Button variant="secondary" onClick={this.adicionarGrafico}><FaStream /> Adicionar Gráfico</Button>
                                        </Form> 
                                    </Card.Body>                
                                </Card>
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}

                    {this.state.programa_id && hasPerm('view_group') && (
                        <Tab eventKey="apiKeysPrograma" title="API Key">
                            {!this.state.loading ? (
                                <ApiKeysPrograma programa_id={this.state.programa_id} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}

                    {this.state.programa_id && hasPerm('add_programas_status') && (
                        <Tab eventKey="statusDoPrograma" title="Status do Programa">
                            {!this.state.loading ? (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Form>
                                            <h4>Status do Programa</h4>
                                            {this.state.status_programa.map((status, index) => (
                                            <div key={index} className="row-list">
                                                <Row>                                                
                                                    <Col sm={4} xs={12}>
                                                        <Form.Group>
                                                            <Form.Label>Nome</Form.Label>   
                                                            <Form.Control 
                                                                type="text"                                                             
                                                                name="nome"
                                                                value={status.nome} 
                                                                onChange={(e) => this.handleChangeStatus(index, e, "nome")}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={4} xs={12}>
                                                        <Form.Group>
                                                            <Form.Label>Slug</Form.Label>   
                                                            <Form.Control 
                                                                type="text"                                                             
                                                                name="slug"
                                                                value={status.slug} 
                                                                onChange={(e) => this.handleChangeStatus(index, e, "slug")}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={2} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Ativo / Inativo</Form.Label>
                                                            <div>
                                                                <Button name="ativo"
                                                                    variant={status.ativo ? "success" : "outline-secondary"}
                                                                    onClick={(e) => this.handleChangeStatus(index, e, "ativo", true)}>
                                                                    Ativo
                                                                </Button>
                                                                {' '}
                                                                <Button name="ativo"
                                                                    variant={!status.ativo ? "danger" : "outline-secondary"}
                                                                    onClick={(e) => this.handleChangeStatus(index, e, "ativo", false)}>
                                                                    Inativo
                                                                </Button>
                                                            </div>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={2} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Adicionar como menu lateral</Form.Label>
                                                            <Form.Control 
                                                                type="text"                                                             
                                                                name="menu_adicional_atendimento"
                                                                value={status.menu_adicional_atendimento} 
                                                                onChange={(e) => this.handleChangeStatus(index, e, "menu_adicional_atendimento")}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={3} xs={12}>
                                                        <Form.Group>
                                                            <Form.Label>Ordem</Form.Label>   
                                                            <Form.Control 
                                                                type="number"                                                             
                                                                name="ordem"
                                                                value={status.ordem} 
                                                                onChange={(e) => this.handleChangeStatus(index, e, "ordem")}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={3} xs={12}>
                                                        <Form.Group>
                                                            <Form.Label>Cor</Form.Label>
                                                            <InputGroup className="mb-3">
                                                                <Form.Control type="text" placeholder="Selecione a cor ao lado" name="cor" id="cor" value={status.cor} onChange={(e) => this.handleChangeStatus(index, e, "cor")} 
                                                                style={{width: '80%'}} />
                                                                <Form.Control
                                                                    type="color"
                                                                    id="corInput"
                                                                    name="cor"
                                                                    value={status.cor}
                                                                    title="Escolha sua cor"
                                                                    onChange={(e) => this.handleChangeStatus(index, e, "cor")}
                                                                    style={{padding: 5, height: 45}}
                                                                />
                                                            </InputGroup>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={3} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Tipo<span style={{ color: 'red' }}> *</span></Form.Label>
                                                            <Form.Control as="select" name="tipo" value={status.tipo} required onChange={(e) => this.handleChangeStatus(index, e, "tipo")}>
                                                                <option value="">Tipo do Status</option>
                                                                <option value="normal">Normal</option>
                                                                <option value="cadastro_atendimento">Cadastro de atendimento</option>
                                                                <option value="cadastro_via_landing_page">Cadastro via landing page/Email</option>
                                                                <option value="finalizacao_atendimento">Finalização do atendimento</option>
                                                                <option value="pause_atendimento">Interrompe atendimento</option>
                                                                <option value="reativacao">Reativação</option>
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={3} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Template Whatsapp</Form.Label>
                                                            <Form.Control 
                                                                type="text"                                                             
                                                                name="template_whatsapp"
                                                                value={status.template_whatsapp} 
                                                                onChange={(e) => this.handleChangeStatus(index, e, "template_whatsapp")}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={3} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>
                                                                Ícone (<a href="https://lucide.dev/icons/" target="_blank" rel="noopener noreferrer" style={{textDecoration: 'underline'}}>Lucide</a>)
                                                            </Form.Label>
                                                            <Form.Control 
                                                                type="text"                                                             
                                                                name="icon"
                                                                placeholder="Ex: CheckCircle2"
                                                                value={status.icon} 
                                                                onChange={(e) => this.handleChangeStatus(index, e, "icon")}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm={6} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Descrição do Status </Form.Label>
                                                            <Form.Control 
                                                                as="textarea" 
                                                                placeholder="Descrição" 
                                                                name="descricao"
                                                                value={status.descricao} 
                                                                onChange={(e) => this.handleChangeStatus(index, e, "descricao")} 
                                                                className="custom-textarea"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={6} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Orientação</Form.Label>
                                                            <Form.Control 
                                                                as="textarea" 
                                                                placeholder="Orientação" 
                                                                name="orientacao"
                                                                value={status.orientacao} 
                                                                onChange={(e) => this.handleChangeStatus(index, e, "orientacao")} 
                                                                className="custom-textarea"
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                </Row>
                                                <Button variant="success" className="btn-sm" onClick={() => this.salvarStatusPrograma(index)}><FaCheck className="me-1" /> Salvar Status</Button>&nbsp;&nbsp;
                                                <Button variant="danger" className="btn-sm ms-2" onClick={() => this.removerStatus(index)}><FaTimes className="me-1" /> Remover Status</Button>
                                            </div>
                                            ))}
                                            <Button variant="secondary" onClick={this.adicionarStatus}><FaStream /> Adicionar Status</Button>
                                        </Form> 
                                    </Card.Body>                
                                </Card>
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}
                    {this.state.programa_id && this.state.habilitar_gestao_aplicacoes && hasPerm('add_programas_aplicacoes_status') && (
                        <Tab eventKey="monitoriaDoPrograma" title="Monitoria">
                            {this.state.habilitar_gestao_aplicacoes && !this.state.loading ? (
                                <Card className="cardDestaque">
                                    <Card.Body>
                                        <Row style={{marginBottom: "10px"}}>
                                            <h4>Monitoria de aplicações</h4>
                                            <Col sm={4} xs={12}>
                                                <Form.Group>
                                                    <Form.Label>Tipos</Form.Label>
                                                    <CreatableSelect
                                                        isMulti
                                                        onChange={(e) => this.handleChangeMonitoriaTipos(e)}
                                                        options={this.state.monitoria_tipos}
                                                        value={this.state.monitoria_tipos}
                                                        placeholder="Selecione ou crie tipos"
                                                        onCreateOption={(e) => this.criaMonitoriaTipos(e)}
                                                        getOptionLabel={(e) => (
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <span>{e.label}</span>
                                                            
                                                        </div>
                                                        )}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={8} xs={12}>
                                                <Form.Group>
                                                    <Form.Label>Legenda de Aplicações</Form.Label>
                                                    <ReactQuill
                                                        value={this.state.aplicacoes_legenda}
                                                        name="aplicacoes_legenda"
                                                        onChange={(e) => this.handleChangeLegendaAplicacoes(e)}
                                                        theme="snow" // Tema do editor, pode ser "snow" ou "bubble"
                                                        modules={{
                                                            toolbar: [
                                                            [{ header: '1' }, { header: '2' }, { font: [] }],
                                                            [{ list: 'ordered' }, { list: 'bullet' }],
                                                            ['bold', 'italic', 'underline'],
                                                            ['link', 'image'],
                                                            [{ align: [] }],
                                                            ['clean'],
                                                            ],
                                                        }}
                                                        placeholder="Digite seu conteúdo aqui"
                                                        className="form-control"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Card className="cardDestaque">
                                            <Card.Body>                    
                                                <Form>
                                                    <h4>Status de Aplicação</h4>
                                                    {this.state.status_aplicacao.map((status, index) => (
                                                    <div key={index} className="row-list">
                                                        <Row style={{marginBottom: "10px"}}>                                                
                                                            <Col sm={4} xs={12}>
                                                                <Form.Group>
                                                                    <Form.Label>Nome</Form.Label>   
                                                                    <Form.Control 
                                                                        type="text"                                                             
                                                                        name="nome"
                                                                        value={status.nome} 
                                                                        onChange={(e) => this.handleChangeStatusAplicacao(index, e, "nome")}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col sm={8} xs={12}>
                                                                <Form.Group>
                                                                    <Form.Label>Motivos de não aplicação (Separe os motivos por vírgula)</Form.Label>   
                                                                    <Form.Control 
                                                                        type="text"                                                             
                                                                        name="motivos_nao_realizacao"
                                                                        value={status.motivos_nao_realizacao} 
                                                                        onChange={(e) => this.handleChangeStatusAplicacao(index, e, "motivos_nao_realizacao")}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Button variant="success" className="btn-sm" onClick={() => this.salvarStatusAplicacao(index)}><FaCheck className="me-1" /> Salvar Status</Button>&nbsp;&nbsp;
                                                        <Button variant="danger" className="btn-sm ms-2" onClick={() => this.removerStatusAplicacao(index)}><FaTimes className="me-1" /> Remover Status</Button>
                                                    </div>
                                                    ))}
                                                    <Button variant="secondary" onClick={this.adicionarStatusAplicacao}><FaStream /> Adicionar Status</Button>
                                                </Form> 
                                            </Card.Body>                
                                        </Card>
                                        <Card className="cardDestaque">
                                            <Card.Body>                    
                                                <Form>
                                                    <h4>Dosagens2</h4>
                                                    {this.state.dosagens.map((dosagem, index) => (
                                                    <div key={index} className="row-list">
                                                        <Row style={{marginBottom: "10px"}}>                                                
                                                            <Col sm={4} xs={12}>
                                                                <Form.Group>
                                                                    <Form.Label>Quantidade</Form.Label>   
                                                                    <Form.Control 
                                                                        type="number"                                                             
                                                                        name="quantidade"
                                                                        value={dosagem.quantidade} 
                                                                        onChange={(e) => this.handleChangeDosagem(index, e, "quantidade")}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col sm={4} xs={12}>
                                                                <Form.Group>
                                                                    <Form.Label>Unidade</Form.Label>   
                                                                    <Form.Control as="select" name="unidade" value={dosagem.unidade} required onChange={(e) => this.handleChangeDosagem(index, e, "unidade")}>
                                                                        {Object.entries(unidadesDosagens).map(([sigla, nome]) => (
                                                                            <option key={sigla} value={sigla}>{nome}</option>
                                                                        ))}
                                                                </Form.Control>
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        
                                                        <Button variant="success" className="btn-sm" onClick={() => this.salvarDosagem(index)}><FaCheck className="me-1" /> Salvar Dosagem</Button>&nbsp;&nbsp;
                                                        <Button variant="danger" className="btn-sm ms-2" onClick={() => this.removerDosagem(index)}><FaTimes className="me-1" /> Remover Dosagem</Button>
                                                    </div>
                                                    ))}
                                                    <Button variant="secondary" onClick={this.adicionarDosagem}><FaStream /> Adicionar Dosagem</Button>
                                                </Form> 
                                            </Card.Body>                
                                        </Card>
                                        <Button variant="success" className="btn-submit mt-3" disabled={this.state.loading} onClick={(e) => this.enviaMonitoria()}>
                                            {this.state.loading ? (
                                                <span className="spinner-border spinner-border-sm"></span>
                                            ) : (
                                                <>
                                                    <FaCheck className="me-1" /> Salvar Dados da Monitoria
                                                </>
                                            )}
                                        </Button>
                                    </Card.Body>
                                </Card>
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}
                    {this.state.programa_id && this.state.categoria === 'linha_cuidado' && (
                        <Tab eventKey="examesLinhaCuidado" title="Exames da Linha de Cuidado">
                            <ProgramaExamesLinhaCuidado programaId={this.state.programa_id} />
                        </Tab>
                    )}
                    {this.state.programa_id && hasPerm('add_programas_doencas') && (
                        <Tab eventKey="doencasDoPrograma" title="Doenças do Programa">
                            {!this.state.loading ? (
                                <Card className="cardDestaque">
                                <Card.Body>
                                    <Row>
                                        <h4>Doenças do Programa</h4>
                                        <Col sm={6} xd={12}>
                                            <Form.Group>
                                                <Form.Label>Local da Seleção da Doença </Form.Label>
                                                    <Form.Control as="select" className="form-control" name="validacao_doenca" value={this.state.validacao_doenca} onChange={this.handleChange}>
                                                        <option value="paciente">Paciente</option>
                                                        <option value="atendimento">Atendimento</option>
                                                    </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Label Doenças</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="label_doencas"
                                                    value={this.state.label_doencas }
                                                    onChange={this.handleChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Exige Confirmação de Diagnóstico?</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.exige_confirmacao_diagnostico ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ exige_confirmacao_diagnostico: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.exige_confirmacao_diagnostico ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ exige_confirmacao_diagnostico: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Row>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Doença Principal</Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions
                                                        loadOptions={this.carregarDoencas}
                                                        defaultOptions
                                                        name="doenca_principal_id"
                                                        placeholder="Buscar doença..."
                                                        noOptionsMessage={() => "Nenhuma doença encontrada"}
                                                        onChange={this.onChangeDoenca}
                                                        value={this.state.doenca_principal_id ? { value: this.state.doenca_principal_id, label: this.state.doenca_principal_nome} : null}
                                                    />
                                                    <Form.Text id="formProgramaHelpBlock" className="text-danger">{this.state.programaHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Col sm={6} xs={12}>
                                            <Button variant="success" className="btn-submit mt-3" disabled={this.state.loading} onClick={(e) => this.enviaDoencas()}>
                                                {this.state.loading ? (
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                ) : (
                                                    <>
                                                        <FaCheck className="me-1" /> Salvar Dados das Doenças
                                                    </>
                                                )}
                                            </Button>
                                            <hr />
                                            <h4 className="mt-3">Patologias Relacionadas</h4>
                                        </Col>
                                        <Col sm={12} xs={12}>
                                            {this.state.doencas.map((doenca, index) => (
                                            <div className="row-list" key={`doenca-${index}`}>
                                                <Row>
                                                    <Col sm={4} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Patologia</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregarDoencas}
                                                                defaultOptions
                                                                name="doenca_id"
                                                                placeholder="Buscar doença..."
                                                                noOptionsMessage={() => "Nenhuma doença encontrada"}
                                                                onChange={(selectedOption) => this.onChangeDoencaRelacionada(index, selectedOption)}
                                                                value={doenca.doenca_id ? { value: doenca.doenca_id, label: doenca.doenca_nome } : null}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    {doenca.doenca_id && (
                                                        <>
                                                            <Col sm={4} xs={12}>
                                                                <Form.Group>
                                                                    <Form.Label>Idade Mínima</Form.Label>
                                                                    <Form.Control
                                                                        type="number"
                                                                        name="idade_minima"
                                                                        value={doenca.idade_minima}
                                                                        onChange={(e) => this.handleChangeIdade(index, e, 'idade_minima')}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col sm={4} xs={12}>
                                                                <Form.Group>
                                                                    <Form.Label>Idade Máxima</Form.Label>
                                                                    <Form.Control
                                                                        type="number"
                                                                        name="idade_maxima"
                                                                        value={doenca.idade_maxima}
                                                                        onChange={(e) => this.handleChangeIdade(index, e, 'idade_maxima')}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </>
                                                    )}
                                                    <Col sm={2} xs={12}>
                                                        <Button variant="success" className="btn-sm" onClick={() => this.salvarDoenca(index)}>Salvar Doença</Button>
                                                    </Col>
                                                    <Col sm={2} xs={12}>
                                                        <Button variant="danger" className="btn-sm" onClick={() => this.removerDoenca(index)}>Remover Doença</Button>
                                                    </Col>
                                                </Row>
                                            </div>
                                            ))}
                                            <br></br>
                                            <Button variant="secondary" className="btn-sm" onClick={this.adicionarDoenca}>Adicionar Doença</Button>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>

                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}
                    {this.state.programa_id && hasPerm('add_programas_compras') && (
                        <Tab eventKey="historicoDeCompras" title="Histórico de Compras">
                            {!this.state.loading ? (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Form>
                                            <h4>Histórico de Compras</h4>
                                            {this.state.historico_de_compras.map((compra, index) => (
                                            <div key={index} className="row-list">
                                                <Row>                                                
                                                    <Col sm={4} xs={12}>
                                                        <Form.Group>
                                                            <Form.Label>Título</Form.Label>   
                                                            <Form.Control 
                                                                type="text"                                                             
                                                                name="titulo"
                                                                value={compra.titulo} 
                                                                onChange={(e) => this.handleChangeHistoricoDeCompras(index, e, "titulo")}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={2} xs={12}>
                                                        <Form.Group>
                                                            <Form.Label>Ordem</Form.Label>   
                                                            <Form.Control 
                                                                type="number"                                                             
                                                                name="ordem"
                                                                value={compra.ordem} 
                                                                onChange={(e) => this.handleChangeHistoricoDeCompras(index, e, "ordem")}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={3} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Produto</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregarProdutosCompras}
                                                                defaultOptions
                                                                name="produto_id"
                                                                onChange={e => this.handleChangeHistoricoDeCompras(index, e, 'produto_id')}
                                                                placeholder="Buscar produto..."
                                                                noOptionsMessage={() => "Nenhum produto encontrado"}
                                                                value={compra.produto_id ? { value: compra.produto_id, label: compra.produto_nome } : null}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={3} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Etapa</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregarEtapasPrograma}
                                                                defaultOptions
                                                                name="etapa_id"
                                                                onChange={e => this.handleChangeHistoricoDeCompras(index, e, 'etapa_id')}
                                                                placeholder="Buscar etapa..."
                                                                noOptionsMessage={() => "Nenhuma etapa encontrada"}
                                                                value={compra.etapa_id ? { value: compra.etapa_id, label: compra.etapa_nome } : null}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Button variant="success" className="btn-sm" onClick={() => this.salvarHistoricoDeCompras(index)}><FaCheck className="me-1" /> Salvar Compra</Button>&nbsp;&nbsp;
                                                <Button variant="danger" className="btn-sm ms-2" onClick={() => this.removerHistoricoDeCompras(index)}><FaTimes className="me-1" /> Remover Compra</Button>
                                            </div>
                                            ))}
                                            <Button variant="secondary" onClick={this.adicionarHistoricoDeCompras}><FaStream /> Adicionar Compra</Button>
                                        </Form> 
                                    </Card.Body>                
                                </Card>
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}
                    {this.state.programa_id && hasPerm('add_programas_farmacovigilancia') && (
                        <Tab eventKey="FarmacovigilanciaPrograma" title="Farmacovigilância">
                            {!this.state.loading ? (
                                <>
                                <ProgramaFarmacovigilanciaConfig programaId={this.state.programa_id} />
                                <Card className="cardDestaque">
                                    <Card.Body>
                                        <Form onSubmit={this.enviarFarmacovigilancia}>
                                            <h4>Farmacovigilância</h4>
                                                    <Row>
                                                        <Col sm={6}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Formulário de Farmacovigilância</Form.Label>
                                                                <AsyncSelect
                                                                    cacheOptions
                                                                    loadOptions={this.carregarFormulariosFarmacovigilancia}
                                                                    defaultOptions
                                                                    name="farmacovigilancia_formulario_id"
                                                                    placeholder="Buscar formulário..."
                                                                    noOptionsMessage={() => "Nenhum formulário encontrado"}
                                                                    onChange={this.onChangeFarmacovigilancia}
                                                                    value={this.state.farmacovigilancia_formulario_id ? { value: this.state.farmacovigilancia_formulario_id, label: this.state.farmacovigilancia_formulario_nome} : null}

                                                                    />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={6}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Email para Envio de Relatório</Form.Label>
                                                                <Form.Control
                                                                    type="email"
                                                                    name="farmacovigilancia_email"
                                                                    placeholder="Informe o email"
                                                                    value={this.state.farmacovigilancia_email}
                                                                    onChange={this.handleChange}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Texto PDF</Form.Label>
                                                                <Form.Control
                                                                    as="textarea"
                                                                    name="texto_sessao1"
                                                                    rows={3}
                                                                    placeholder="Informe o texto do PDF"
                                                                    value={this.state.texto_sessao1}
                                                                    onChange={this.handleChange}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={6}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Número do Documento</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="n_documento"
                                                                    placeholder="Informe o número do documento"
                                                                    value={this.state.n_documento}
                                                                    onChange={this.handleChange}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={6}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Versão</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="versao"
                                                                    placeholder="Informe a versão"
                                                                    value={this.state.versao}
                                                                    onChange={this.handleChange}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={4} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Habilitar Excel?</Form.Label>
                                                                <div>
                                                                    <Button 
                                                                        variant={this.state.habilita_excel_farmacovigilancia ? "success" : "outline-secondary"}
                                                                        onClick={() => this.setState({ habilita_excel_farmacovigilancia: true })}>
                                                                        Sim
                                                                    </Button>
                                                                    {' '}
                                                                    <Button 
                                                                        variant={!this.state.habilita_excel_farmacovigilancia ? "danger" : "outline-secondary"}
                                                                        onClick={() => this.setState({ habilita_excel_farmacovigilancia: false })}>
                                                                        Não
                                                                    </Button>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>     
                                                        <Col sm={4} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Habilitar PDF?</Form.Label>
                                                                <div>
                                                                    <Button 
                                                                        variant={this.state.farmacovigilancia_habilitar_pdf ? "success" : "outline-secondary"}
                                                                        onClick={() => this.setState({ farmacovigilancia_habilitar_pdf: true })}>
                                                                        Sim
                                                                    </Button>
                                                                    {' '}
                                                                    <Button 
                                                                        variant={!this.state.farmacovigilancia_habilitar_pdf ? "danger" : "outline-secondary"}
                                                                        onClick={() => this.setState({ farmacovigilancia_habilitar_pdf: false })}>
                                                                        Não
                                                                    </Button>
                                                                </div>
                                                            </Form.Group>
                                                        </Col> 
                                                        <Col sm={6}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Modelo</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="farmacovigilancia_modelo"
                                                                    placeholder="Informe o Modelo"
                                                                    value={this.state.farmacovigilancia_modelo}
                                                                    onChange={this.handleChange}
                                                                />
                                                            </Form.Group>
                                                        </Col> 
                                                        <Col sm={6} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Imagem</Form.Label>
                                                                <Form.Control type="file" name="farmacovigilancia_imagem" onChange={this.onChangeImagemFarmacovigilancia} ref={this.fileInput} />
                                                                {this.state.farmacovigilancia_imagem && (
                                                                    <div>
                                                                        <img src={this.state.farmacovigilancia_imagem} alt="Imagem Atual" style={{ maxWidth: '100px', marginTop: '10px' }} />
                                                                    </div>
                                                                )}
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={6} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label> Arquivo PDF de Modelo</Form.Label>
                                                                <Form.Control type="file" name="farmacovigilancia_pdf_modelo" onChange={this.onChangeArquivoPDFModelo} ref={this.fileInput} />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                                        {this.state.loading ? (
                                                            <span className="spinner-border spinner-border-sm"></span>
                                                        ) : (
                                                            <>
                                                                <FaCheck className="me-1" /> Salvar
                                                            </>
                                                        )}
                                                    </Button>
                                        </Form>
                                    </Card.Body>
                                </Card>
                                </>
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}
                    {this.state.programa_id && this.state.optout_habilitado == true && hasPerm('add_programas_optout_motivos') &&  (
                        <Tab eventKey="MotivosOptoutPrograma" title="Motivos Optout">
                            {!this.state.loading ? (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Form>
                                        <h4>Motivos de Optout</h4>
                                            {this.state.motivos_optout.map((optout, index) => (
                                            <div key={index} className="row-list">
                                                <Row>                                                
                                                    <Col sm={6} xs={12}>
                                                        <Form.Group>
                                                            <Form.Label>Título</Form.Label>   
                                                            <Form.Control 
                                                                type="text"                                                             
                                                                name="titulo"
                                                                value={optout.titulo} 
                                                                onChange={(e) => this.handleChangeOptOut(index, e, "titulo")}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={6} xs={12}>
                                                        <Form.Group>
                                                            <Form.Label>Ordem</Form.Label>   
                                                            <Form.Control 
                                                                type="number"                                                             
                                                                name="ordem"
                                                                value={optout.ordem} 
                                                                onChange={(e) => this.handleChangeOptOut(index, e, "ordem")}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <br></br>
                                                <Button variant="success" className="btn-sm" onClick={() => this.salvarOptOutPrograma(index)}><FaCheck className="me-1" /> Salvar OptOut</Button>&nbsp;&nbsp;
                                                <Button variant="danger" className="btn-sm ms-2" onClick={() => this.removerOptOutPrograma(index)}><FaTimes className="me-1" /> Remover OptOut</Button>
                                            </div>
                                            ))}
                                            <Button variant="secondary" onClick={this.adicionarOptOut}><FaStream /> Adicionar OptOut</Button>
                                        </Form> 
                                    </Card.Body>                
                                </Card>
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}
                    {this.state.programa_id && hasPerm('add_programas_acoes') && ( 
                        <Tab eventKey="AcoesPrograma" title="Ações Programa">
                            {!this.state.loading ? (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Form>
                                        <h4>Ações do Programa</h4>
                                            {this.state.acoes_programa.map((acoes, index) => (
                                            <div key={index} className="row-list">
                                                <Row>                                                
                                                    <Col sm={6} xs={12}>
                                                        <Form.Group>
                                                            <Form.Label>Título</Form.Label>   
                                                            <Form.Control 
                                                                type="text"                                                             
                                                                name="nome"
                                                                value={acoes.nome} 
                                                                onChange={(e) => this.handleChangeAcoesPrograma(index, e, "nome")}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={3} xs={12}>
                                                        <Form.Group>
                                                            <Form.Label>Slug</Form.Label>   
                                                            <Form.Control 
                                                                type="text"                                                             
                                                                name="slug"
                                                                value={acoes.slug} 
                                                                onChange={(e) => this.handleChangeAcoesPrograma(index, e, "slug")}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={3} xs={12}>
                                                        <Form.Group>
                                                            <Form.Label>Ordem</Form.Label>   
                                                            <Form.Control 
                                                                type="number"                                                             
                                                                name="ordem"
                                                                value={acoes.ordem} 
                                                                onChange={(e) => this.handleChangeAcoesPrograma(index, e, "ordem")}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <br></br>
                                                <Button variant="success" className="btn-sm" onClick={() => this.salvarAcoesPrograma(index)}><FaCheck className="me-1" /> Salvar Ações Programa</Button>&nbsp;&nbsp;
                                                <Button variant="danger" className="btn-sm ms-2" onClick={() => this.removerAcoesPrograma(index)}><FaTimes className="me-1" /> Remover Ações Programa</Button>
                                            </div>
                                            ))}
                                            <Button variant="secondary" onClick={this.adicionarAcoesPrograma}><FaStream /> Adicionar Ações Programa</Button>
                                        </Form> 
                                    </Card.Body>                
                                </Card>
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}
                    {this.state.habilitar_envio_kit && (
                        <Tab eventKey="kitsPrograma" title="Kits Programa">
                            <Card>
                                <Card.Header>Kits do Programa</Card.Header>
                                <Card.Body>
                                    {this.state.kits.map((kit, kitIndex) => (
                                        <div key={kitIndex} className="mb-3">
                                            <Row>
                                                <Col sm={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Título</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={kit.titulo}
                                                            onChange={(e) => this.handleKitChange(kitIndex, e, 'titulo')}
                                                            placeholder="Título do Kit"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={2}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Status</Form.Label>
                                                        <Form.Check
                                                            type="checkbox"
                                                            checked={kit.status}
                                                            onChange={(e) => this.handleKitChange(kitIndex, { target: { value: e.target.checked } }, 'status')}
                                                            label="Ativo"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6}>
                                                    <Button variant="success" onClick={() => this.salvarKit(kitIndex)} className="mt-4 me-2">
                                                        Salvar Kit
                                                    </Button>
                                                    <Button variant="danger" onClick={() => this.removerKit(kitIndex)} className="mt-4">
                                                        Remover Kit
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={12}>
                                                    {kit.produtos.map((produto, produtoIndex) => (
                                                        <Row key={produtoIndex} className="mb-3">
                                                            <Col sm={4}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Produto</Form.Label>
                                                                    <AsyncSelect
                                                                        cacheOptions
                                                                        loadOptions={this.carregarProdutos}
                                                                        defaultOptions
                                                                        name="produto_id"
                                                                        placeholder="Buscar produto..."
                                                                        noOptionsMessage={() => "Nenhum produto encontrado"}
                                                                        onChange={(e) =>
                                                                            this.handleProdutoKitChange(kitIndex, produtoIndex, e, 'produto_id')
                                                                        }
                                                                        value={
                                                                            produto.produto_id
                                                                                ? { value: produto.produto_id, label: produto.produto_nome }
                                                                                : null
                                                                        }
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col sm={2}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Dosagem</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        value={produto.dosagem || ""}
                                                                        onChange={(e) =>
                                                                            this.handleDosagemChange(kitIndex, produtoIndex, e)
                                                                        }
                                                                        placeholder="Dosagem"
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col sm={2}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Tipo</Form.Label>
                                                                    <Form.Control
                                                                        as="select"
                                                                        name="dosagem_tipo"
                                                                        required
                                                                        onChange={(e) =>
                                                                            this.handleChangeDosagemTipo(kitIndex, produtoIndex, e)
                                                                        }
                                                                        value={produto.dosagem_tipo || ""}
                                                                    >
                                                                        <option value="">Selecione...</option>
                                                                        {Object.keys(this.list_tipo_dosagem || {}).map((key) => (
                                                                            <option key={key} value={key}>
                                                                                {this.list_tipo_dosagem[key]}
                                                                            </option>
                                                                        ))}
                                                                    </Form.Control>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col sm={2}>
                                                                <Button
                                                                    variant="danger"
                                                                    onClick={() => this.removerProdutoKit(kitIndex, produtoIndex)}
                                                                    className="mt-4"
                                                                >
                                                                    Remover Produto
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    ))}
                                                    <Button variant="secondary" onClick={() => this.adicionarProdutoKit(kitIndex)}>
                                                        Adicionar Produto
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <hr />
                                        </div>
                                    ))}
                                    <Button variant="primary" onClick={this.adicionarKit}>
                                        Adicionar Kit
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Tab>
                    )}

                    {this.state.programa_id && (
                        <Tab eventKey="regrasDoPrograma" title="Regras">
                            {this.state.carregamentoAbas.some(item => item.nome === 'regrasDoPrograma') ? (
                                <ProgramaRegras programaId={this.state.programa_id} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>
                                        <p>Clique para carregar as regras...</p>
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}

                    {this.state.programa_id && (
                        <Tab eventKey="modeloRelatorioDoPrograma" title="Modelos de Relatório">
                            {this.state.carregamentoAbas.some(item => item.nome === 'modeloRelatorioDoPrograma') ? (
                                <ModeloRelatorio programaId={this.state.programa_id} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>
                                        <p>Clique para carregar os modelos de relatório...</p>
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}

                    {this.state.programa_id && (
                        <Tab eventKey="reguasComunicacaoDoPrograma" title="Réguas de Comunicação">
                            {this.state.carregamentoAbas.some(item => item.nome === 'reguasComunicacaoDoPrograma') ? (
                                <ProgramaReguasComunicacao programaId={this.state.programa_id} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>
                                        <p>Clique para carregar as réguas de comunicação...</p>
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}

                    {this.state.programa_id && (
                        <Tab eventKey="configuracoesPrograma" title="Configurações">
                            {this.state.carregamentoAbas.some(item => item.nome === 'configuracoesPrograma') ? (
                                <ProgramaConfiguracoes programaId={this.state.programa_id} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>
                                        <p>Clique para carregar as configurações...</p>
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}

                    {this.state.programa_id && (
                        <Tab eventKey="mensageriaRecorrentePrograma" title="Mensageria Recorrente">
                            {this.state.carregamentoAbas.some(item => item.nome === 'mensageriaRecorrentePrograma') ? (
                                <ProgramaMensageriaRecorrente programaId={this.state.programa_id} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>
                                        <p>Clique para carregar as mensagerias recorrentes...</p>
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}

                    {this.state.programa_id && (
                        <Tab eventKey="faqPrograma" title="FAQ">
                            {this.state.carregamentoAbas.some(item => item.nome === 'faqPrograma') ? (
                                <ProgramaFAQ programaId={this.state.programa_id} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>
                                        <p>Clique para carregar FAQ...</p>
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}

                    {this.state.programa_id && (
                        <Tab eventKey="dashboardPrograma" title="Dashboard">
                            {this.state.carregamentoAbas.some(item => item.nome === 'dashboardPrograma') ? (
                                <ProgramaDashboard programaId={this.state.programa_id} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>
                                        <p>Clique para carregar o Dashboard...</p>
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}

                </Tabs>
            </div>
        )
    }
}

export default withRouter(ProgramasEdit);
